import { EventBus } from "@/components/EventBus";
import { AddActivityCategoryRequest, AddActivityCategoryResponse, AddActivityRequest, AddActivityResponse, AddActivityScheduleDocumentRequest, AddActivityScheduleDocumentResponse, AddActivityScheduleRequest, AddActivityScheduleResponse, AddActivitySheetRequest, AddActivitySheetResponse, AddActivityUsingAIRequest, AddActivityUsingAIResponse, AddAgencyPricingRequest, AddAgencyPricingResponse, AddAgencyRequest, AddAgencyResponse, AddAutomaticNotificationRequest, AddAutomaticNotificationResponse, AddAutomaticNotificationRuleRequest, AddAutomaticNotificationRuleResponse, AddBookingGroupPaymentRequest, AddBookingGroupPaymentResponse, AddBookingRequest, AddBookingResponse, AddBookingToDayScheduleRequest, AddBookingToDayScheduleResponse, AddBudgetRequest, AddBudgetResponse, AddCarrierRequest, AddCarrierResponse, AddContentElementRequest, AddContentElementResponse, AddDocumentRequest, AddDocumentResponse, AddDocumentToBookingRequest, AddDocumentToBookingResponse, AddEmployeeDocumentRequest, AddEmployeeDocumentResponse, AddEmployeeRequest, AddEmployeeResponse, AddEmployeeSeasonRequest, AddEmployeeSeasonResponse, AddGuideRateRequest, AddGuideRateResponse, AddGuideRequest, AddGuideResponse, AddHelpPageRequest, AddHelpPageResponse, AddHotelRequest, AddHotelResponse, AddImageCategoryRequest, AddImageCategoryResponse, AddImageRequest, AddImageResponse, AddImageToBookingRequest, AddImageToBookingResponse, AddIncidentRequest, AddIncidentResponse, AddIntegrationRequest, AddIntegrationResponse, AddItemsToSalesInvoiceRequest, AddItemsToSalesInvoiceResponse, AddKeyRequest, AddKeyResponse, AddLeadRequest, AddLeadResponse, AddLocalMessageRequest, AddLocalMessageResponse, AddMailAccountRequest, AddMailAccountResponse, AddManualVoucherToScheduledServiceRequest, AddManualVoucherToScheduledServiceResponse, AddMeetingPointRequest, AddMeetingPointResponse, AddMessageTemplateRequest, AddMessageTemplateResponse, AddNotificationRequest, AddNotificationResponse, AddOperatorPricingRequest, AddOperatorPricingResponse, AddOperatorRequest, AddOperatorResponse, AddOrganizationRequest, AddOrganizationResponse, AddPageRequest, AddPageResponse, AddPaymentMethodRequest, AddPaymentMethodResponse, AddPaymentRequest, AddPaymentResponse, AddPostRequest, AddPostResponse, AddProductPricingRequest, AddProductPricingResponse, AddProductRequest, AddProductResponse, AddProductScheduleRequest, AddProductScheduleResponse, AddProfileRequest, AddProfileResponse, AddProviderRequest, AddProviderResponse, AddPurchaseInvoiceRequest, AddPurchaseInvoiceResponse, AddPurchaseRateRequest, AddPurchaseRateResponse, AddPurchaseRateScheduleRequest, AddPurchaseRateScheduleResponse, AddRatePricingRequest, AddRatePricingResponse, AddRateRequest, AddRateResponse, AddReportCategoryRequest, AddReportCategoryResponse, AddReportRequest, AddReportResponse, AddRouteRequest, AddRouteResponse, AddSalesInvoiceRequest, AddSalesInvoiceResponse, AddScheduledServiceRequest, AddScheduledServiceResponse, AddSeasonRequest, AddSeasonResponse, AddSeriesRequest, AddSeriesResponse, AddServiceRequest, AddServiceResponse, AddSettlementRuleRequest, AddSettlementRuleResponse, AddTaxRequest, AddTaxResponse, AddTimeRecordRequest, AddTimeRecordResponse, AddTransferBookingRequest, AddTransferBookingResponse, AddTransferExtraRequest, AddTransferExtraResponse, AddTransferJourneyRequest, AddTransferJourneyResponse, AddTransferProductRequest, AddTransferProductResponse, AddTransferRateRequest, AddTransferRateResponse, AddTransferZoneRequest, AddTransferZoneResponse, AddUserRequest, AddUserResponse, AddWebsiteFilterRequest, AddWebsiteFilterResponse, AddWebsiteRequest, AddWebsiteResponse, AddWhatsAppAccountRequest, AddWhatsAppAccountResponse, AddWorkFlowRequest, AddWorkFlowResponse, AddWorkOrderRequest, AddWorkOrderResponse, AddZoneRequest, AddZoneResponse, ArchivePrebookingRequest, ArchivePrebookingResponse, AssignBookingsToDayScheduleSupportRequest, AssignBookingsToDayScheduleSupportResponse, AssignDayScheduleServiceToExistingWorkOrderRequest, AssignDayScheduleServiceToExistingWorkOrderResponse, AssignDayScheduleServiceToNewWorkOrderRequest, AssignDayScheduleServiceToNewWorkOrderResponse, BeginMailAccountConnectionRequest, BeginMailAccountConnectionResponse, BookScheduledServiceCathedralVouchersRequest, BookScheduledServiceCathedralVouchersResponse, BulkAddProductPricingRequest, BulkAddProductPricingResponse, BulkAddProductScheduleRequest, BulkAddProductScheduleResponse, BulkClearTimeRecordsRequest, BulkClearTimeRecordsResponse, BulkDeleteActivitiesRequest, BulkDeleteActivitiesResponse, BulkDeleteActivityCategoriesRequest, BulkDeleteActivityCategoriesResponse, BulkDeleteActivitySchedulesRequest, BulkDeleteActivitySchedulesResponse, BulkDeleteActivitySheetsRequest, BulkDeleteActivitySheetsResponse, BulkDeleteAgenciesRequest, BulkDeleteAgenciesResponse, BulkDeleteAutomaticNotificationRulesRequest, BulkDeleteAutomaticNotificationRulesResponse, BulkDeleteAutomaticNotificationsRequest, BulkDeleteAutomaticNotificationsResponse, BulkDeleteBookingsRequest, BulkDeleteBookingsResponse, BulkDeleteBudgetsRequest, BulkDeleteBudgetsResponse, BulkDeleteCarriersRequest, BulkDeleteCarriersResponse, BulkDeleteContentElementsRequest, BulkDeleteContentElementsResponse, BulkDeleteDocumentsRequest, BulkDeleteDocumentsResponse, BulkDeleteEmployeesRequest, BulkDeleteEmployeesResponse, BulkDeleteGuideRatesRequest, BulkDeleteGuideRatesResponse, BulkDeleteGuidesRequest, BulkDeleteGuidesResponse, BulkDeleteHelpPagesRequest, BulkDeleteHelpPagesResponse, BulkDeleteHotelsRequest, BulkDeleteHotelsResponse, BulkDeleteImageCategoriesRequest, BulkDeleteImageCategoriesResponse, BulkDeleteImagesRequest, BulkDeleteImagesResponse, BulkDeleteIncidentsRequest, BulkDeleteIncidentsResponse, BulkDeleteIntegrationsRequest, BulkDeleteIntegrationsResponse, BulkDeleteKeysRequest, BulkDeleteKeysResponse, BulkDeleteLeadsRequest, BulkDeleteLeadsResponse, BulkDeleteLocalMessagesRequest, BulkDeleteLocalMessagesResponse, BulkDeleteMailAccountsRequest, BulkDeleteMailAccountsResponse, BulkDeleteMeetingPointsRequest, BulkDeleteMeetingPointsResponse, BulkDeleteMessageTemplatesRequest, BulkDeleteMessageTemplatesResponse, BulkDeleteNotificationsRequest, BulkDeleteNotificationsResponse, BulkDeleteOperatorsRequest, BulkDeleteOperatorsResponse, BulkDeleteOrganizationsRequest, BulkDeleteOrganizationsResponse, BulkDeletePagesRequest, BulkDeletePagesResponse, BulkDeletePaymentMethodsRequest, BulkDeletePaymentMethodsResponse, BulkDeletePaymentsRequest, BulkDeletePaymentsResponse, BulkDeletePostsRequest, BulkDeletePostsResponse, BulkDeleteProductsRequest, BulkDeleteProductsResponse, BulkDeleteProvidersRequest, BulkDeleteProvidersResponse, BulkDeletePurchaseInvoicesRequest, BulkDeletePurchaseInvoicesResponse, BulkDeletePurchaseRatesRequest, BulkDeletePurchaseRatesResponse, BulkDeleteRatesRequest, BulkDeleteRatesResponse, BulkDeleteReportCategoriesRequest, BulkDeleteReportCategoriesResponse, BulkDeleteReportsRequest, BulkDeleteReportsResponse, BulkDeleteRoutesRequest, BulkDeleteRoutesResponse, BulkDeleteSeasonsRequest, BulkDeleteSeasonsResponse, BulkDeleteSeriesRequest, BulkDeleteSeriesResponse, BulkDeleteServicesRequest, BulkDeleteServicesResponse, BulkDeleteSettlementRulesRequest, BulkDeleteSettlementRulesResponse, BulkDeleteTaxesRequest, BulkDeleteTaxesResponse, BulkDeleteTimeRecordsRequest, BulkDeleteTimeRecordsResponse, BulkDeleteTransferBookingsRequest, BulkDeleteTransferBookingsResponse, BulkDeleteTransferExtrasRequest, BulkDeleteTransferExtrasResponse, BulkDeleteTransferJourneysRequest, BulkDeleteTransferJourneysResponse, BulkDeleteTransferProductsRequest, BulkDeleteTransferProductsResponse, BulkDeleteTransferRatesRequest, BulkDeleteTransferRatesResponse, BulkDeleteTransferZonesRequest, BulkDeleteTransferZonesResponse, BulkDeleteWebsitesRequest, BulkDeleteWebsitesResponse, BulkDeleteWorkFlowsRequest, BulkDeleteWorkFlowsResponse, BulkDeleteWorkOrdersRequest, BulkDeleteWorkOrdersResponse, BulkSetActivityExternalOperatorRequest, BulkSetActivityExternalOperatorResponse, BulkSetAgencyDocumentationSentRequest, BulkSetAgencyDocumentationSentResponse, BulkSetAgencyParentAgencyRequest, BulkSetAgencyParentAgencyResponse, BulkSetAgencyRateRequest, BulkSetAgencyRateResponse, BulkSetAgencyTrainRateRequest, BulkSetAgencyTrainRateResponse, BulkSetHotelRelevanceRequest, BulkSetHotelRelevanceResponse, BulkSetImageCategoryRequest, BulkSetImageCategoryResponse, BulkSetServiceDurationRequest, BulkSetServiceDurationResponse, BulkSetServiceGuideRateRequest, BulkSetServiceGuideRateResponse, BulkSetServiceListTypeRequest, BulkSetServiceListTypeResponse, BulkSetServiceTypeRequest, BulkSetServiceTypeResponse, BulkUpdatePurchaseInvoiceFiscalInformationRequest, BulkUpdatePurchaseInvoiceFiscalInformationResponse, BulkUpdateSalesInvoiceFiscalInformationRequest, BulkUpdateSalesInvoiceFiscalInformationResponse, CancelBookingRequest, CancelBookingResponse, CancelBudgetRequest, CancelBudgetResponse, CancelPrebookingRequest, CancelPrebookingResponse, ChangeMeetingPointDescriptionRequest, ChangeMeetingPointDescriptionResponse, ChangeMeetingPointGeolocationRequest, ChangeMeetingPointGeolocationResponse, ChangeMeetingPointLocalityRequest, ChangeMeetingPointLocalityResponse, ChangeMeetingPointOrderRequest, ChangeMeetingPointOrderResponse, ChangeMeetingPointZoneRequest, ChangeMeetingPointZoneResponse, ChangeProfileDescriptionRequest, ChangeProfileDescriptionResponse, ChangeProfilePermissionsRequest, ChangeProfilePermissionsResponse, ChangeRouteZoneRequest, ChangeRouteZoneResponse, ChangeUserPasswordRequest, ChangeUserPasswordResponse, ChangeZoneCodeRequest, ChangeZoneCodeResponse, ChangeZoneDescriptionRequest, ChangeZoneDescriptionResponse, CheckBookingRequest, CheckBookingRequirementsRequest, CheckBookingRequirementsResponse, CheckBookingResponse, CheckScheduledServiceRequest, CheckScheduledServiceResponse, CleanUpProductRequest, CleanUpProductResponse, CleanUpScheduledServiceRequest, CleanUpScheduledServiceResponse, CloseDayScheduleRequest, CloseDayScheduleResponse, CloseWorkOrderRequest, CloseWorkOrderResponse, CompletePaymentRequest, CompletePaymentResponse, ConfirmBookingRequest, ConfirmBookingResponse, ConfirmBudgetRequest, ConfirmBudgetResponse, ConfirmPrebookingRequest, ConfirmPrebookingResponse, CreditSalesInvoiceRequest, CreditSalesInvoiceResponse, DeleteActivityCategoryRequest, DeleteActivityCategoryResponse, DeleteActivityRequest, DeleteActivityResponse, DeleteActivityScheduleRequest, DeleteActivityScheduleResponse, DeleteActivitySheetRequest, DeleteActivitySheetResponse, DeleteAgencyRequest, DeleteAgencyResponse, DeleteAutomaticNotificationRequest, DeleteAutomaticNotificationResponse, DeleteAutomaticNotificationRuleRequest, DeleteAutomaticNotificationRuleResponse, DeleteBookingInvoicingSlotRequest, DeleteBookingInvoicingSlotResponse, DeleteBookingRequest, DeleteBookingResponse, DeleteBudgetRequest, DeleteBudgetResponse, DeleteCarrierRequest, DeleteCarrierResponse, DeleteContentElementRequest, DeleteContentElementResponse, DeleteDayScheduleScheduledServiceRequest, DeleteDayScheduleScheduledServiceResponse, DeleteDocumentRequest, DeleteDocumentResponse, DeleteEmployeeRequest, DeleteEmployeeResponse, DeleteGuideRateRequest, DeleteGuideRateResponse, DeleteGuideRequest, DeleteGuideResponse, DeleteHelpPageRequest, DeleteHelpPageResponse, DeleteHotelRequest, DeleteHotelResponse, DeleteImageCategoryRequest, DeleteImageCategoryResponse, DeleteImageRequest, DeleteImageResponse, DeleteIncidentRequest, DeleteIncidentResponse, DeleteIntegrationHotelMappingRequest, DeleteIntegrationHotelMappingResponse, DeleteIntegrationMeetingPointMappingRequest, DeleteIntegrationMeetingPointMappingResponse, DeleteIntegrationProductMappingRequest, DeleteIntegrationProductMappingResponse, DeleteIntegrationRequest, DeleteIntegrationResponse, DeleteKeyRequest, DeleteKeyResponse, DeleteLeadRequest, DeleteLeadResponse, DeleteLocalMessageRequest, DeleteLocalMessageResponse, DeleteMailAccountRequest, DeleteMailAccountResponse, DeleteMeetingPointRequest, DeleteMeetingPointResponse, DeleteMessageTemplateRequest, DeleteMessageTemplateResponse, DeleteNotificationRequest, DeleteNotificationResponse, DeleteOldNotificationsRequest, DeleteOldNotificationsResponse, DeleteOperatorRequest, DeleteOperatorResponse, DeleteOrganizationRequest, DeleteOrganizationResponse, DeletePageRequest, DeletePageResponse, DeletePaymentMethodRequest, DeletePaymentMethodResponse, DeletePaymentRequest, DeletePaymentResponse, DeletePostRequest, DeletePostResponse, DeletePrebookingRequest, DeletePrebookingResponse, DeleteProductRequest, DeleteProductResponse, DeleteProfileRequest, DeleteProfileResponse, DeleteProviderRequest, DeleteProviderResponse, DeletePurchaseInvoiceRequest, DeletePurchaseInvoiceResponse, DeletePurchaseRateRequest, DeletePurchaseRateResponse, DeleteRateRequest, DeleteRateResponse, DeleteReportCategoryRequest, DeleteReportCategoryResponse, DeleteReportRequest, DeleteReportResponse, DeleteRouteRequest, DeleteRouteResponse, DeleteSalesInvoiceRequest, DeleteSalesInvoiceResponse, DeleteScheduledServiceRequest, DeleteScheduledServiceResponse, DeleteScheduledServiceVoucherRequest, DeleteScheduledServiceVoucherResponse, DeleteSeasonRequest, DeleteSeasonResponse, DeleteSeriesRequest, DeleteSeriesResponse, DeleteServiceRequest, DeleteServiceResponse, DeleteSettlementRuleRequest, DeleteSettlementRuleResponse, DeleteTaxRequest, DeleteTaxResponse, DeleteTimeRecordRequest, DeleteTimeRecordResponse, DeleteTransferBookingRequest, DeleteTransferBookingResponse, DeleteTransferExtraRequest, DeleteTransferExtraResponse, DeleteTransferJourneyRequest, DeleteTransferJourneyResponse, DeleteTransferProductRequest, DeleteTransferProductResponse, DeleteTransferRateRequest, DeleteTransferRateResponse, DeleteTransferZoneRequest, DeleteTransferZoneResponse, DeleteUserRequest, DeleteUserResponse, DeleteWebsiteRequest, DeleteWebsiteResponse, DeleteWhatsAppAccountRequest, DeleteWhatsAppAccountResponse, DeleteWorkFlowRequest, DeleteWorkFlowResponse, DeleteWorkOrderRequest, DeleteWorkOrderResponse, DeleteZoneRequest, DeleteZoneResponse, DisableEmployeeRequest, DisableEmployeeResponse, DisableIntegrationRequest, DisableIntegrationResponse, DisableMailAccountRequest, DisableMailAccountResponse, DisableWebsiteFilterRequest, DisableWebsiteFilterResponse, DownloadHotelListingReportRequest, DownloadMasterDataReportRequest, DownloadRateSeasonSummaryRequest, DownloadRateSeasonSummaryResponse, DownloadTimeRecordMonthlyOrYearlyViewRequest, DownloadTimeRecordMonthlyOrYearlyViewResponse, DownloadTimeRecordRequest, DownloadTimeRecordResponse, DownloadYearTimeRecordRequest, DownloadYearTimeRecordResponse, DownloadZoneRateReportRequest, DownloadZoneTimingReportRequest, DuplicateProductRequest, DuplicateProductResponse, DuplicateRateRequest, DuplicateRateResponse, DuplicateReportRequest, DuplicateReportResponse, DuplicateRouteRequest, DuplicateRouteResponse, EditActivityCategoryRequest, EditActivityCategoryResponse, EditActivityRequest, EditActivityResponse, EditActivityScheduleRequest, EditActivityScheduleResponse, EditActivitySheetRequest, EditActivitySheetResponse, EditAgencyPricingRequest, EditAgencyPricingResponse, EditAgencyRequest, EditAgencyResponse, EditAutomaticNotificationRequest, EditAutomaticNotificationResponse, EditAutomaticNotificationRuleRequest, EditAutomaticNotificationRuleResponse, EditBookingAffiliateRequest, EditBookingAffiliateResponse, EditBookingInvoicingSlotRequest, EditBookingInvoicingSlotResponse, EditBookingLanguageRequest, EditBookingLanguageResponse, EditBookingOccupancyRequest, EditBookingOccupancyResponse, EditBookingOperatorSettlementRequest, EditBookingOperatorSettlementResponse, EditBookingOrganizationAndAgencyRequest, EditBookingOrganizationAndAgencyResponse, EditBookingRequest, EditBookingResponse, EditBookingSettlementRequest, EditBookingSettlementResponse, EditBudgetRequest, EditBudgetResponse, EditCarrierRequest, EditCarrierResponse, EditConfigurationRequest, EditConfigurationResponse, EditContentElementRequest, EditContentElementResponse, EditDocumentRequest, EditDocumentResponse, EditEmployeeRequest, EditEmployeeResponse, EditEmployeeSeasonRequest, EditEmployeeSeasonResponse, EditGuideRateRequest, EditGuideRateResponse, EditGuideRequest, EditGuideResponse, EditHelpPageRequest, EditHelpPageResponse, EditHotelRequest, EditHotelResponse, EditImageCategoryRequest, EditImageCategoryResponse, EditImageRequest, EditImageResponse, EditIncidentRequest, EditIncidentResponse, EditIntegrationHotelMappingRequest, EditIntegrationHotelMappingResponse, EditIntegrationProductMappingRequest, EditIntegrationProductMappingResponse, EditIntegrationRequest, EditIntegrationResponse, EditKeyRequest, EditKeyResponse, EditLeadRequest, EditLeadResponse, EditLocalMessageRequest, EditLocalMessageResponse, EditMailAccountRequest, EditMailAccountResponse, EditMeetingPointRequest, EditMeetingPointResponse, EditMessageTemplateRequest, EditMessageTemplateResponse, EditOperatorPricingRequest, EditOperatorPricingResponse, EditOperatorRequest, EditOperatorResponse, EditOrganizationRequest, EditOrganizationResponse, EditPageRequest, EditPageResponse, EditPaymentMethodRequest, EditPaymentMethodResponse, EditPaymentRequest, EditPaymentResponse, EditPostRequest, EditPostResponse, EditProductPricingRequest, EditProductPricingResponse, EditProductRequest, EditProductResponse, EditProductScheduleRequest, EditProductScheduleResponse, EditProfileRequest, EditProfileResponse, EditProviderRequest, EditProviderResponse, EditPurchaseInvoiceRequest, EditPurchaseInvoiceResponse, EditPurchaseRateRequest, EditPurchaseRateResponse, EditPurchaseRateScheduleRequest, EditPurchaseRateScheduleResponse, EditRatePricingRequest, EditRatePricingResponse, EditRateRequest, EditRateResponse, EditReportCategoryRequest, EditReportCategoryResponse, EditReportRequest, EditReportResponse, EditRouteRequest, EditRouteResponse, EditSalesInvoiceRequest, EditSalesInvoiceResponse, EditScheduledServiceSettlementRequest, EditScheduledServiceSettlementResponse, EditSeasonRequest, EditSeasonResponse, EditSeriesRequest, EditSeriesResponse, EditServiceRequest, EditServiceResponse, EditSettlementRuleRequest, EditSettlementRuleResponse, EditTaxRequest, EditTaxResponse, EditTimeRecordRequest, EditTimeRecordResponse, EditTransferBookingRequest, EditTransferBookingResponse, EditTransferExtraRequest, EditTransferExtraResponse, EditTransferJourneyRequest, EditTransferJourneyResponse, EditTransferProductRequest, EditTransferProductResponse, EditTransferRateRequest, EditTransferRateResponse, EditTransferZoneRequest, EditTransferZoneResponse, EditUserRequest, EditUserResponse, EditWebsiteFilterRequest, EditWebsiteFilterResponse, EditWebsiteHomeContentRequest, EditWebsiteHomeContentResponse, EditWebsiteRequest, EditWebsiteResponse, EditWhatsAppAccountRequest, EditWhatsAppAccountResponse, EditWorkFlowRequest, EditWorkFlowResponse, EditWorkOrderRequest, EditWorkOrderResponse, EditWorkOrderSettlementRequest, EditWorkOrderSettlementResponse, EditZoneRequest, EditZoneResponse, EnableEmployeeRequest, EnableEmployeeResponse, EnableIntegrationRequest, EnableIntegrationResponse, EnableMailAccountRequest, EnableMailAccountResponse, EnableWebsiteFilterRequest, EnableWebsiteFilterResponse, EndMailAccountConnectionRequest, EndMailAccountConnectionResponse, EndTimeRecordForCurrentUserRequest, EndTimeRecordForCurrentUserResponse, EndTimeRecordRequest, EndTimeRecordResponse, EvaluateAgencyProductPricingRequest, EvaluateAgencyProductPricingResponse, EvaluateBookingInvoicingSlotsRequest, EvaluateBookingInvoicingSlotsResponse, ExecuteReportRequest, ExecuteReportResponse, FindTransferZoneFromLatitudeAndLongitudeRequest, FindTransferZoneFromLatitudeAndLongitudeResponse, ForceIntegrationPullRequest, ForceIntegrationPullResponse, ForcePurchaseInvoiceSettlementRequest, ForcePurchaseInvoiceSettlementResponse, GenerateAgencyQRBrochureRequest, GenerateAllAutomaticNotificationsRequest, GenerateAllAutomaticNotificationsResponse, GenerateBudgetProFormaRequest, GenerateBudgetProFormaResponse, GenerateDayScheduleListRequest, GenerateDayScheduleListResponse, GenerateDayScheduleRouteReportRequest, GenerateDayScheduleVoucherRequest, GenerateDayScheduleVoucherResponse, GenerateGuideQRBrochureRequest, GenerateMultipleReportsRequest, GeneratePostUsingAIRequest, GeneratePostUsingAIResponse, GenerateSalesInvoicesCSVRequest, GenerateTimeRecordSignatureVoucherRequest, GenerateTimeRecordSignatureVoucherResponse, GenerateTransferBookingVoucherRequest, GetActivityCategoryRequest, GetActivityCategoryResponse, GetActivityRequest, GetActivityResponse, GetActivityScheduleRequest, GetActivityScheduleResponse, GetActivitySheetRequest, GetActivitySheetResponse, GetAgencyNextReferenceRequest, GetAgencyNextReferenceResponse, GetAgencyRequest, GetAgencyResponse, GetAllActivitiesResponse, GetAllActivityCategoriesResponse, GetAllActivitySchedulesResponse, GetAllActivitySheetsResponse, GetAllAgenciesResponse, GetAllAreasResponse, GetAllAutomaticNotificationRulesResponse, GetAllAutomaticNotificationsResponse, GetAllBookingsResponse, GetAllBudgetsResponse, GetAllCarriersResponse, GetAllContentElementsResponse, GetAllConversationsResponse, GetAllDocumentsResponse, GetAllEmployeesResponse, GetAllGuideRatesResponse, GetAllGuidesResponse, GetAllHelpPagesResponse, GetAllHotelsResponse, GetAllImageCategoriesResponse, GetAllImagesResponse, GetAllIncidentsResponse, GetAllIntegrationProcessorsResponse, GetAllIntegrationsResponse, GetAllKeysResponse, GetAllLeadsResponse, GetAllLocalMessagesResponse, GetAllMailAccountsResponse, GetAllMeetingPointsResponse, GetAllMessageTemplatesResponse, GetAllNotificationsResponse, GetAllOperatorsResponse, GetAllOrganizationsResponse, GetAllPagesResponse, GetAllPaymentGatewaysResponse, GetAllPaymentMethodsResponse, GetAllPaymentsResponse, GetAllPostsResponse, GetAllPrebookingsResponse, GetAllProductRestrictionsRequest, GetAllProductRestrictionsResponse, GetAllProductSchedulingRequest, GetAllProductSchedulingResponse, GetAllProductsResponse, GetAllProfilesResponse, GetAllProvidersResponse, GetAllPurchaseInvoicesRequest, GetAllPurchaseInvoicesResponse, GetAllPurchaseRatesResponse, GetAllRatesResponse, GetAllReportCategoriesResponse, GetAllReportsResponse, GetAllRoutesResponse, GetAllSalesInvoicesRequest, GetAllSalesInvoicesResponse, GetAllSeasonsResponse, GetAllSeriesResponse, GetAllServicesResponse, GetAllSettlementRulesResponse, GetAllTasksResponse, GetAllTaxesResponse, GetAllTimeRecordsResponse, GetAllTransferExtrasResponse, GetAllTransferJourneysResponse, GetAllTransferProductsResponse, GetAllTransferRatesResponse, GetAllTransferZonesResponse, GetAllUsersResponse, GetAllWebsitesResponse, GetAllWhatsAppAccountsResponse, GetAllWorkFlowsResponse, GetAllWorkOrdersResponse, GetAllZonesResponse, GetAutomaticNotificationRequest, GetAutomaticNotificationResponse, GetAutomaticNotificationRuleRequest, GetAutomaticNotificationRuleResponse, GetAvailableProfilePermissionsResponse, GetBookingPickupInformationRequest, GetBookingPickupInformationResponse, GetBookingRequest, GetBookingResponse, GetBudgetRequest, GetBudgetResponse, GetCarrierRequest, GetCarrierResponse, GetConfigurationRequest, GetConfigurationResponse, GetContentElementRequest, GetContentElementResponse, GetConversationRequest, GetConversationResponse, GetDayScheduleBusRoutesRequest, GetDayScheduleBusRoutesResponse, GetDayScheduleGuidePreferencesRequest, GetDayScheduleGuidePreferencesResponse, GetDayScheduleListsRequest, GetDayScheduleListsResponse, GetDayScheduleServicesRequest, GetDayScheduleServicesResponse, GetDayScheduleStatusRequest, GetDayScheduleStatusResponse, GetDayScheduleVouchersRequest, GetDayScheduleVouchersResponse, GetDocumentRequest, GetDocumentResponse, GetEmployeeRequest, GetEmployeeResponse, GetGuideRateRequest, GetGuideRateResponse, GetGuideRequest, GetGuideResponse, GetHelpPageRequest, GetHelpPageResponse, GetHotelProductsRequest, GetHotelProductsResponse, GetHotelRequest, GetHotelResponse, GetImageCategoryRequest, GetImageCategoryResponse, GetImageRequest, GetImageResponse, GetIncidentRequest, GetIncidentResponse, GetIntegrationRequest, GetIntegrationResponse, GetKeyRequest, GetKeyResponse, GetLeadRequest, GetLeadResponse, GetLocalMessageRequest, GetLocalMessageResponse, GetMailAccountRequest, GetMailAccountResponse, GetMeetingPointRequest, GetMeetingPointResponse, GetMessageTemplateRequest, GetMessageTemplateResponse, GetNearestMeetingPointsRequest, GetNearestMeetingPointsResponse, GetNotificationRequest, GetNotificationResponse, GetOpenOrCloseProductSalesMessageRequest, GetOpenOrCloseProductSalesMessageResponse, GetOperatorRequest, GetOperatorResponse, GetOrganizationRequest, GetOrganizationResponse, GetPageRequest, GetPageResponse, GetPaymentMethodRequest, GetPaymentMethodResponse, GetPaymentRequest, GetPaymentResponse, GetPendingSettlementBookingsRequest, GetPendingSettlementBookingsResponse, GetPendingSettlementBudgetsRequest, GetPendingSettlementBudgetsResponse, GetPendingSettlementCarriersRequest, GetPendingSettlementCarriersResponse, GetPendingSettlementGuidesRequest, GetPendingSettlementGuidesResponse, GetPendingSettlementInvoicesRequest, GetPendingSettlementInvoicesResponse, GetPendingSettlementOperatorsRequest, GetPendingSettlementOperatorsResponse, GetPendingSettlementProvidersRequest, GetPendingSettlementProvidersResponse, GetPendingSettlementPurchaseInvoicesRequest, GetPendingSettlementPurchaseInvoicesResponse, GetPostRequest, GetPostResponse, GetPrebookingRequest, GetPrebookingResponse, GetProductPickupTimeRequest, GetProductPickupTimeResponse, GetProductPickupTimesRequest, GetProductPickupTimesResponse, GetProductRequest, GetProductResponse, GetProfileRequest, GetProfileResponse, GetProviderRequest, GetProviderResponse, GetPurchaseInvoiceRequest, GetPurchaseInvoiceResponse, GetPurchaseRateRequest, GetPurchaseRateResponse, GetRateRequest, GetRateResponse, GetRateSeasonSummaryRequest, GetRateSeasonSummaryResponse, GetReportAvailableDataSourcesResponse, GetReportCategoryRequest, GetReportCategoryResponse, GetReportDataSourceRequest, GetReportDataSourceResponse, GetReportRequest, GetReportResponse, GetRouteRequest, GetRouteResponse, GetSalesInvoiceRequest, GetSalesInvoiceResponse, GetScheduledServiceRequest, GetScheduledServiceResponse, GetScheduledServiceSiblingsRequest, GetScheduledServiceSiblingsResponse, GetSeasonRequest, GetSeasonResponse, GetSeriesRequest, GetSeriesResponse, GetServiceRequest, GetServiceResponse, GetSettlementPurchaseInvoiceRequest, GetSettlementPurchaseInvoiceResponse, GetSettlementRuleRequest, GetSettlementRuleResponse, GetSettlementSalesInvoiceRequest, GetSettlementSalesInvoiceResponse, GetTaxRequest, GetTaxResponse, GetTimeRecordForCurrentUserResponse, GetTimeRecordMonthlyViewRequest, GetTimeRecordMonthlyViewResponse, GetTimeRecordRequest, GetTimeRecordResponse, GetTimeRecordYearlyViewRequest, GetTimeRecordYearlyViewResponse, GetTransferBookingRequest, GetTransferBookingResponse, GetTransferExtraRequest, GetTransferExtraResponse, GetTransferJourneyRequest, GetTransferJourneyResponse, GetTransferProductRequest, GetTransferProductResponse, GetTransferRateRequest, GetTransferRateResponse, GetTransferRateSummaryRequest, GetTransferRateSummaryResponse, GetTransferZoneAutocompletionDetailsRequest, GetTransferZoneAutocompletionDetailsResponse, GetTransferZoneAutocompletionRequest, GetTransferZoneAutocompletionResponse, GetTransferZoneRequest, GetTransferZoneResponse, GetUserRequest, GetUserResponse, GetWebsiteHomeContentRequest, GetWebsiteHomeContentResponse, GetWebsiteRequest, GetWebsiteResponse, GetWhatsAppAccountRequest, GetWhatsAppAccountResponse, GetWorkCalendarRequest, GetWorkCalendarResponse, GetWorkFlowRequest, GetWorkFlowResponse, GetWorkOrderDetailsRequest, GetWorkOrderDetailsResponse, GetWorkOrderRequest, GetWorkOrderResponse, GetZoneRequest, GetZoneResponse, ImpersonateScheduledServiceRequest, ImpersonateScheduledServiceResponse, ImpersonateUserRequest, ImpersonateUserResponse, ImportRateSeasonSummaryRequest, ImportRateSeasonSummaryResponse, IntegrateLocalMessageRequest, IntegrateLocalMessageResponse, InvoiceSalesInvoiceRequest, InvoiceSalesInvoiceResponse, JoinMeetingPointsRequest, JoinMeetingPointsResponse, LinkEmployeeRequest, LinkEmployeeResponse, LinkGuideRequest, LinkGuideResponse, LogUserInRequest, LogUserInResponse, LogUserOutRequest, LogUserOutResponse, LookupMeetingPointsRequest, LookupMeetingPointsResponse, LookupProfilesResponse, LookupPurchaseRatesRequest, LookupPurchaseRatesResponse, LookupZonesRequest, LookupZonesResponse, MoveLocalMessageToFolderRequest, MoveLocalMessageToFolderResponse, MoveReportToCategoryRequest, MoveReportToCategoryResponse, MoveWebsiteFilterDownRequest, MoveWebsiteFilterDownResponse, MoveWebsiteFilterUpRequest, MoveWebsiteFilterUpResponse, NoShowBookingRequest, NoShowBookingResponse, NotifyBookingConfirmationRequest, NotifyBookingConfirmationResponse, NotifyBookingEventRequest, NotifyBookingEventResponse, NotifyScheduledServiceGuideRequest, NotifyScheduledServiceGuideResponse, OpenOrCloseProductSalesRequest, OpenOrCloseProductSalesResponse, OverrideScheduledServicePickupOrderRequest, OverrideScheduledServicePickupOrderResponse, PortableAggregateList, PreviewPrebookingMappingRequest, PreviewPrebookingMappingResponse, RecalculateEmployeeSeasonWorkedTimeRequest, RecalculateEmployeeSeasonWorkedTimeResponse, ReceiveWorkOrderFromCarrierRequest, ReceiveWorkOrderFromCarrierResponse, RecordPurchaseInvoicesRequest, RecordSalesInvoicesRequest, RecoverUserPasswordRequest, RecoverUserPasswordResponse, RefreshBookingRequest, RefreshBookingResponse, RefreshEmployeesRelatedContactInformationRequest, RefreshEmployeesRelatedContactInformationResponse, RefreshScheduledServiceVouchersRequest, RefreshScheduledServiceVouchersResponse, RefreshSharedAgencyCollectionRequest, RefreshSharedAgencyCollectionResponse, RemoveActivityScheduleDocumentRequest, RemoveActivityScheduleDocumentResponse, RemoveAgencyPricingRequest, RemoveAgencyPricingResponse, RemoveAgencyRateRequest, RemoveAgencyRateResponse, RemoveBookingFromDayScheduleRequest, RemoveBookingFromDayScheduleResponse, RemoveDocumentFromBookingRequest, RemoveDocumentFromBookingResponse, RemoveEmployeeDocumentRequest, RemoveEmployeeDocumentResponse, RemoveEmployeeSeasonRequest, RemoveEmployeeSeasonResponse, RemoveImageFromBookingRequest, RemoveImageFromBookingResponse, RemoveItemsFromSalesInvoiceRequest, RemoveItemsFromSalesInvoiceResponse, RemoveOperatorPricingRequest, RemoveOperatorPricingResponse, RemoveProductPricingRequest, RemoveProductPricingResponse, RemoveProductScheduleRequest, RemoveProductScheduleResponse, RemovePurchaseRateScheduleRequest, RemovePurchaseRateScheduleResponse, RemoveRatePricingRequest, RemoveRatePricingResponse, RemoveWebsiteFilterRequest, RemoveWebsiteFilterResponse, RenameActivityCategoryRequest, RenameActivityCategoryResponse, RenameActivityRequest, RenameActivityResponse, RenameActivitySheetRequest, RenameActivitySheetResponse, RenameAgencyRequest, RenameAgencyResponse, RenameAutomaticNotificationRequest, RenameAutomaticNotificationResponse, RenameAutomaticNotificationRuleRequest, RenameAutomaticNotificationRuleResponse, RenameBudgetRequest, RenameBudgetResponse, RenameCarrierRequest, RenameCarrierResponse, RenameContentElementRequest, RenameContentElementResponse, RenameDocumentRequest, RenameDocumentResponse, RenameGuideRateRequest, RenameGuideRateResponse, RenameGuideRequest, RenameGuideResponse, RenameHelpPageRequest, RenameHelpPageResponse, RenameHotelRequest, RenameHotelResponse, RenameImageCategoryRequest, RenameImageCategoryResponse, RenameIncidentRequest, RenameIncidentResponse, RenameIntegrationRequest, RenameIntegrationResponse, RenameKeyRequest, RenameKeyResponse, RenameLocalMessageRequest, RenameLocalMessageResponse, RenameMailAccountRequest, RenameMailAccountResponse, RenameMeetingPointRequest, RenameMeetingPointResponse, RenameMessageTemplateRequest, RenameMessageTemplateResponse, RenameOperatorRequest, RenameOperatorResponse, RenamePageRequest, RenamePageResponse, RenamePaymentMethodRequest, RenamePaymentMethodResponse, RenamePaymentRequest, RenamePaymentResponse, RenamePostRequest, RenamePostResponse, RenameProductRequest, RenameProductResponse, RenameProfilePermissionRequest, RenameProfilePermissionResponse, RenameProfileRequest, RenameProfileResponse, RenameProviderRequest, RenameProviderResponse, RenamePurchaseInvoiceRequest, RenamePurchaseInvoiceResponse, RenamePurchaseRateRequest, RenamePurchaseRateResponse, RenameRateRequest, RenameRateResponse, RenameReportCategoryRequest, RenameReportCategoryResponse, RenameReportRequest, RenameReportResponse, RenameRouteRequest, RenameRouteResponse, RenameSalesInvoiceRequest, RenameSalesInvoiceResponse, RenameSeasonRequest, RenameSeasonResponse, RenameSeriesRequest, RenameSeriesResponse, RenameServiceRequest, RenameServiceResponse, RenameSettlementRuleRequest, RenameSettlementRuleResponse, RenameTaxRequest, RenameTaxResponse, RenameTimeRecordRequest, RenameTimeRecordResponse, RenameUserRequest, RenameUserResponse, RenameWebsiteRequest, RenameWebsiteResponse, RenameWhatsAppAccountRequest, RenameWhatsAppAccountResponse, RenameWorkFlowRequest, RenameWorkFlowResponse, RenameWorkOrderRequest, RenameWorkOrderResponse, RenameZoneRequest, RenameZoneResponse, RenderMessageTemplateRequest, RenderMessageTemplateResponse, ReopenDayScheduleRequest, ReopenDayScheduleResponse, ReorderActivitiesRequest, ReorderActivitiesResponse, RepairDayScheduleRequest, RepairDayScheduleResponse, ReplaceSalesInvoiceAttachmentRequest, ReplaceSalesInvoiceAttachmentResponse, ReplaceSalesInvoiceRequest, ReplaceSalesInvoiceResponse, ResetDayScheduleRequest, ResetDayScheduleResponse, ResetOrganizationCountersRequest, ResetOrganizationCountersResponse, ResetUserPasswordRequest, ResetUserPasswordResponse, ResolveIncidentRequest, ResolveIncidentResponse, ResolveNameRequest, ResolveNameResponse, ResolvePrebookingRequest, ResolvePrebookingResponse, RetryNotificationRequest, RetryNotificationResponse, RunTaskRequest, RunTaskResponse, SearchBookingsRequest, SearchBookingsResponse, SearchCommandCenterRequest, SearchCommandCenterResponse, SearchLogsRequest, SearchLogsResponse, SearchNotificationsRequest, SearchNotificationsResponse, SearchTimeRecordsRequest, SearchTimeRecordsResponse, SearchTransferBookingsRequest, SearchTransferBookingsResponse, SearchWorkOrdersRequest, SearchWorkOrdersResponse, SendBookingProformaRequest, SendBookingProformaResponse, SendBookingVoucherRequest, SendBookingVoucherResponse, SendBudgetProFormaRequest, SendBudgetProFormaResponse, SendConversationMessageRequest, SendConversationMessageResponse, SendDayScheduleListRequest, SendDayScheduleListResponse, SendDayScheduleMassiveListsRequest, SendDayScheduleMassiveListsResponse, SendDayScheduleVoucherToProviderRequest, SendDayScheduleVoucherToProviderResponse, SendMultipleReportsRequest, SendMultipleReportsResponse, SendReportRequest, SendReportResponse, SendSalesInvoiceRequest, SendSalesInvoiceResponse, SendScheduledServiceCathedralVouchersRequest, SendScheduledServiceCathedralVouchersResponse, SendTimeRecordSignatureToEmployeeRequest, SendTimeRecordSignatureToEmployeeResponse, SendWorkOrderToCarrierRequest, SendWorkOrderToCarrierResponse, SetAgencySimpleBookingPinRequest, SetAgencySimpleBookingPinResponse, SetAgencyTrainRateRequest, SetAgencyTrainRateResponse, SetDayScheduleGuidePreferencesRequest, SetDayScheduleServiceBusNumberRequest, SetDayScheduleServiceBusNumberResponse, SetDayScheduleServiceCarrierRequest, SetDayScheduleServiceCarrierResponse, SetDayScheduleServiceCommentsRequest, SetDayScheduleServiceCommentsResponse, SetDayScheduleServiceForecastRequest, SetDayScheduleServiceForecastResponse, SetDayScheduleServiceGuideRequest, SetDayScheduleServiceGuideResponse, SetDayScheduleServiceOperatorRequest, SetDayScheduleServiceOperatorResponse, SetHelpPageVisibilityRequest, SetHelpPageVisibilityResponse, SetHotelAsReviewedRequest, SetHotelAsReviewedResponse, SetHotelAsUnreviewedRequest, SetHotelAsUnreviewedResponse, SetHotelRelevanceRequest, SetHotelRelevanceResponse, SetScheduledServiceElistStatusRequest, SetScheduledServiceElistStatusResponse, SetScheduledServiceOrderRequest, SetScheduledServiceOrderResponse, SetScheduledServicePickupTimeRequest, SetScheduledServicePickupTimeResponse, SetServiceDurationRequest, SetServiceDurationResponse, SetWhatsAppAccountOrganizationRequest, SetWhatsAppAccountOrganizationResponse, SetWorkCalendarWorkingHoursRequest, SetWorkCalendarWorkingHoursResponse, SetWorkOrderOperatorRequest, SetWorkOrderOperatorResponse, SettleAgencyBookingsRequest, SettleAgencyBookingsResponse, SettleCarrierWorkOrdersRequest, SettleCarrierWorkOrdersResponse, SettleGuideWorkOrdersRequest, SettleGuideWorkOrdersResponse, SettleOperatorBookingsRequest, SettleOperatorBookingsResponse, SettleProviderWorkOrdersRequest, SettleProviderWorkOrdersResponse, ShareReportRequest, ShareReportResponse, ShowBookingRequest, ShowBookingResponse, SignalMailAccountErrorRequest, SignalMailAccountErrorResponse, SplitBookingRequest, SplitBookingResponse, SplitDayScheduleServiceRequest, SplitDayScheduleServiceResponse, StartTimeRecordForCurrentUserRequest, StartTimeRecordForCurrentUserResponse, SynchronizeIPCProductsRequest, SynchronizeIPCProductsResponse, TestMailAccountRequest, TestMailAccountResponse, TestWhatsAppAccountRequest, TestWhatsAppAccountResponse, ToggleAutomaticNotificationRuleRequest, ToggleAutomaticNotificationRuleResponse, ToggleDayScheduleVoucherRequest, ToggleDayScheduleVoucherResponse, ToggleMailAccountTagRequest, ToggleMailAccountTagResponse, TogglePaymentMethodRequest, TogglePaymentMethodResponse, TogglePostPublicationRequest, TogglePostPublicationResponse, ToggleTaskRequest, ToggleTaskResponse, ToggleUserStatusRequest, ToggleUserStatusResponse, ToggleWhatsAppAccountRequest, ToggleWhatsAppAccountResponse, ToggleWhatsAppAccountTagRequest, ToggleWhatsAppAccountTagResponse, ToggleWorkCalendarPublicHolidayRequest, ToggleWorkCalendarPublicHolidayResponse, TranslatePostRequest, TranslatePostResponse, TranslateTextRequest, TranslateTextResponse, UnassignBookingsFromDayScheduleSupportRequest, UnassignBookingsFromDayScheduleSupportResponse, UnassignDayScheduleServiceFromExistingWorkOrderRequest, UnassignDayScheduleServiceFromExistingWorkOrderResponse, UncancelBookingRequest, UncancelBookingResponse, UncheckBookingRequest, UncheckBookingResponse, UnrecordPurchaseInvoicesRequest, UnrecordPurchaseInvoicesResponse, UnsettleAgencyBookingsRequest, UnsettleAgencyBookingsResponse, UnsettleCarrierWorkOrdersRequest, UnsettleCarrierWorkOrdersResponse, UnsettleGuideWorkOrdersRequest, UnsettleGuideWorkOrdersResponse, UnsettleOperatorBookingsRequest, UnsettleOperatorBookingsResponse, UnsettleProviderWorkOrdersRequest, UnsettleProviderWorkOrdersResponse, UpdateAgenciesBookingCountRequest, UpdateAgenciesBookingCountResponse, UpdatePurchaseInvoiceFiscalInformationRequest, UpdatePurchaseInvoiceFiscalInformationResponse, UpdateSalesInvoiceCodeRequest, UpdateSalesInvoiceCodeResponse, UpdateSalesInvoiceFiscalInformationRequest, UpdateSalesInvoiceFiscalInformationResponse, UploadScheduledServiceVoucherRequest, UploadScheduledServiceVoucherResponse } from "@/services/ClientInterfaces";
import { BaseService } from "./BaseService";


export class DataClient {

    static get IPC(): IPCService {
        return IPCService.instance;
    }

    static get TransferJourneys(): TransferJourneysService {
        return TransferJourneysService.instance;
    }

    static get TransferRates(): TransferRatesService {
        return TransferRatesService.instance;
    }

    static get TransferExtras(): TransferExtrasService {
        return TransferExtrasService.instance;
    }

    static get Leads(): LeadsService {
        return LeadsService.instance;
    }

    static get WhatsAppAccounts(): WhatsAppAccountsService {
        return WhatsAppAccountsService.instance;
    }

    static get WorkCalendars(): WorkCalendarsService {
        return WorkCalendarsService.instance;
    }

    static get TransferProducts(): TransferProductsService {
        return TransferProductsService.instance;
    }

    static get ActivitySchedules(): ActivitySchedulesService {
        return ActivitySchedulesService.instance;
    }

    static get Organizations(): OrganizationsService {
        return OrganizationsService.instance;
    }

    static get TransferBookings(): TransferBookingsService {
        return TransferBookingsService.instance;
    }

    static get TransferZones(): TransferZonesService {
        return TransferZonesService.instance;
    }

    static get Configurations(): ConfigurationsService {
        return ConfigurationsService.instance;
    }

    static get Employees(): EmployeesService {
        return EmployeesService.instance;
    }

    static get TimeRecords(): TimeRecordsService {
        return TimeRecordsService.instance;
    }

    static get Rates(): RatesService {
        return RatesService.instance;
    }

    static get Keys(): KeysService {
        return KeysService.instance;
    }

    static get Seasons(): SeasonsService {
        return SeasonsService.instance;
    }

    static get Budgets(): BudgetsService {
        return BudgetsService.instance;
    }

    static get AutomaticNotifications(): AutomaticNotificationsService {
        return AutomaticNotificationsService.instance;
    }

    static get AutomaticNotificationRules(): AutomaticNotificationRulesService {
        return AutomaticNotificationRulesService.instance;
    }

    static get PaymentGateways(): PaymentGatewaysService {
        return PaymentGatewaysService.instance;
    }

    static get PaymentMethods(): PaymentMethodsService {
        return PaymentMethodsService.instance;
    }

    static get Pages(): PagesService {
        return PagesService.instance;
    }

    static get Incidents(): IncidentsService {
        return IncidentsService.instance;
    }

    static get Logs(): LogsService {
        return LogsService.instance;
    }

    static get DataSources() {
        return {
            Agencies: "1a53a4f5-27ec-4251-8aab-c838ad85e54e",
            Bookings: "7a109b26-bdcb-4bd9-86e9-dab17638e405",
            WorkOrders: "8e96fd16-25da-49b0-b214-d080491e1bac",
            PurchaseInvoiceDetails: "bdc322e8-ddf0-4f17-8a92-de49d6143b3c",
            PurchaseInvoices: "598f2303-d859-4254-b3f3-1be0851aedeb",
            SalesInvoices: "891bdc54-0acc-4be0-9f2c-1b51dd141198",
            Employees: "3a543c10-59f4-4b6c-9a6d-c756d55d9991",
        };
    }

    static get ReportCategories(): ReportCategoriesService {
        return ReportCategoriesService.instance;
    }

    static get WorkFlows(): WorkFlowsService {
        return WorkFlowsService.instance;
    }

    static get GuideRates(): GuideRatesService {
        return GuideRatesService.instance;
    }

    static get HelpPages(): HelpPagesService {
        return HelpPagesService.instance;
    }

    static get Reports(): ReportsService {
        return ReportsService.instance;
    }

    static get Posts(): PostsService {
        return PostsService.instance;
    }

    static get PurchaseInvoices(): PurchaseInvoicesService {
        return PurchaseInvoicesService.instance;
    }

    static get SettlementRules(): SettlementRulesService {
        return SettlementRulesService.instance;
    }

    static get Taxes(): TaxesService {
        return TaxesService.instance;
    }

    static get Settlements(): SettlementsService {
        return SettlementsService.instance;
    }

    static get SalesInvoices(): SalesInvoicesService {
        return SalesInvoicesService.instance;
    }

    static get Series(): SeriesService {
        return SeriesService.instance;
    }

    static get Payments(): PaymentsService {
        return PaymentsService.instance;
    }

    static get availableLanguages(): string[] {
        return ["es", "en", "fr", "de", "it", "cz", "pt", "ru", "ro", "pl"];
    }

    static get ScheduledServices(): ScheduledServicesService {
        return ScheduledServicesService.instance;
    }

    static get Administration(): AdministrationService {
        return AdministrationService.instance;
    }

    static get Notifications(): NotificationsService {
        return NotificationsService.instance;
    }

    static get MessageTemplates(): MessageTemplatesService {
        return MessageTemplatesService.instance;
    }

    static get Prebookings(): PrebookingsService {
        return PrebookingsService.instance;
    }

    static get IntegrationProcessors(): IntegrationProcessorsService {
        return IntegrationProcessorsService.instance;
    }

    static get Integrations(): IntegrationsService {
        return IntegrationsService.instance;
    }

    static get Tasks(): TasksService {
        return TasksService.instance;
    }

    static get LocalMessages(): LocalMessagesService {
        return LocalMessagesService.instance;
    }

    static get MailAccounts(): MailAccountsService {
        return MailAccountsService.instance;
    }

    static get WorkOrders(): WorkOrdersService {
        return WorkOrdersService.instance;
    }

    static get DaySchedules(): DaySchedulesService {
        return DaySchedulesService.instance;
    }

    static get ActivityCategories(): ActivityCategoriesService {
        return ActivityCategoriesService.instance;
    }

    static get Routes(): RoutesService {
        return RoutesService.instance;
    }

    static get Areas(): AreasService {
        return AreasService.instance;
    }

    static get Operators(): OperatorsService {
        return OperatorsService.instance;
    }

    static get Bookings(): BookingsService {
        return BookingsService.instance;
    }

    static get ActivitySheets(): ActivitySheetsService {
        return ActivitySheetsService.instance;
    }

    static get Guides(): GuidesService {
        return GuidesService.instance;
    }

    static get PurchaseRates(): PurchaseRatesService {
        return PurchaseRatesService.instance;
    }

    static get Services(): ServicesService {
        return ServicesService.instance;
    }

    static get Websites(): WebsitesService {
        return WebsitesService.instance;
    }

    static get Products(): ProductsService {
        return ProductsService.instance;
    }

    static get Documents(): DocumentsService {
        return DocumentsService.instance;
    }

    static get ContentElements(): ContentElementsService {
        return ContentElementsService.instance;
    }

    static get Activities(): ActivitiesService {
        return ActivitiesService.instance;
    }

    static get ImageCategories(): ImageCategoriesService {
        return ImageCategoriesService.instance;
    }

    static get GalleryService() {
        return GalleryService.instance;
    }

    static get Profiles(): ProfilesService {
        return ProfilesService.instance;
    }

    static get Users(): UsersService {
        return UsersService.instance;
    }

    static get Carriers(): CarriersService {
        return CarriersService.instance;
    }

    static get Providers(): ProvidersService {
        return ProvidersService.instance;
    }

    static get Agencies(): AgenciesService {
        return AgenciesService.instance;
    }

    static get TextTranslation(): TextTranslationService {
        return TextTranslationService.instance;
    }

    static get NameResolution(): NameResolutionService {
        return NameResolutionService.instance;
    }

    static get StaticMapService(): StaticMapService {
        return StaticMapService.instance;
    }

    static get Hotels(): HotelsService {
        return HotelsService.instance;
    }

    static get MeetingPoints(): MeetingPointsService {
        return MeetingPointsService.instance;
    }

    static get Zones(): ZonesService {
        return ZonesService.instance;
    }

    static get Channels(): ChannelsService {
        return ChannelsService.instance;
    }

    static get Reporting(): ReportingService {
        return ReportingService.instance;
    }

    static get Images(): ImagesService {
        return ImagesService.instance;
    }

    static get Dialogs(): DialogService {
        return DialogService.instance;
    }

    static get Conversations(): ConversationsService {
        return ConversationsService.instance;
    }

    static get Crm(): CrmService {
        return CrmService.instance;
    }

    static get CommandCenter(): CommandCenterService {
        return CommandCenterService.instance;
    }
}

class DaySchedulesService extends BaseService {

    static instance = new DaySchedulesService();

    public async getStatus(request: GetDayScheduleStatusRequest): Promise<GetDayScheduleStatusResponse> {
        return await this.httpGet(["day-schedules", request.date, "status"]);
    }

    public async reset(request: ResetDayScheduleRequest): Promise<ResetDayScheduleResponse> {
        return await this.httpPost(["day-schedules", request.date, "reset"], request);
    }

    public async repair(request: RepairDayScheduleRequest): Promise<RepairDayScheduleResponse> {
        return await this.httpPost(["day-schedules", request.date, "repair"], request);
    }

    public async close(request: CloseDayScheduleRequest): Promise<CloseDayScheduleResponse> {
        return await this.httpPost(["day-schedules", request.date, "close"], request);
    }

    public async reopen(request: ReopenDayScheduleRequest): Promise<ReopenDayScheduleResponse> {
        return await this.httpPost(["day-schedules", request.date, "reopen"], request);
    }

    public async addBooking(request: AddBookingToDayScheduleRequest): Promise<AddBookingToDayScheduleResponse> {
        return await this.httpPost(["day-schedules", request.date, "add-booking"], request);
    }

    public async removeBooking(request: RemoveBookingFromDayScheduleRequest): Promise<RemoveBookingFromDayScheduleResponse> {
        return await this.httpPost(["day-schedules", request.date, "remove-booking"], request);
    }

    public async getServices(request: GetDayScheduleServicesRequest): Promise<GetDayScheduleServicesResponse> {
        return await this.httpGet(["day-schedules", request.date, "services"], { onlyEnvelopes: request.onlyEnvelopes });
    }

    public async getLists(request: GetDayScheduleListsRequest): Promise<GetDayScheduleListsResponse> {
        return await this.httpGet(["day-schedules", request.date, "lists"]);
    }

    public async getVouchers(request: GetDayScheduleVouchersRequest): Promise<GetDayScheduleVouchersResponse> {
        return await this.httpGet(["day-schedules", request.date, "vouchers"]);
    }

    public async deleteScheduledService(request: DeleteDayScheduleScheduledServiceRequest): Promise<DeleteDayScheduleScheduledServiceResponse> {
        return await this.httpPost(["day-schedules", request.date, "delete-scheduled-service"], request);
    }

    public async assignServiceToNewWorkOrder(request: AssignDayScheduleServiceToNewWorkOrderRequest): Promise<AssignDayScheduleServiceToNewWorkOrderResponse> {
        return await this.httpPost(["day-schedules", request.date, "assign-service-to-new-work-order"], request);
    }

    public async assignServiceToExistingWorkOrder(request: AssignDayScheduleServiceToExistingWorkOrderRequest): Promise<AssignDayScheduleServiceToExistingWorkOrderResponse> {
        return await this.httpPost(["day-schedules", request.date, "assign-service-to-existing-work-order"], request);
    }

    public async unassignServiceFromExistingWorkOrder(request: UnassignDayScheduleServiceFromExistingWorkOrderRequest): Promise<UnassignDayScheduleServiceFromExistingWorkOrderResponse> {
        return await this.httpPost(["day-schedules", request.date, "unassign-service-from-existing-work-order"], request);
    }

    public async setServiceForecast(request: SetDayScheduleServiceForecastRequest): Promise<SetDayScheduleServiceForecastResponse> {
        return await this.httpPost(["day-schedules", request.date, "set-service-forecast"], request);
    }

    public async setServiceBusNumber(request: SetDayScheduleServiceBusNumberRequest): Promise<SetDayScheduleServiceBusNumberResponse> {
        return await this.httpPost(["day-schedules", request.date, "set-service-bus-number"], request);
    }

    public async setServiceComments(request: SetDayScheduleServiceCommentsRequest): Promise<SetDayScheduleServiceCommentsResponse> {
        return await this.httpPost(["day-schedules", request.date, "set-service-comments"], request);
    }

    public async setServiceOperator(request: SetDayScheduleServiceOperatorRequest): Promise<SetDayScheduleServiceOperatorResponse> {
        return await this.httpPost(["day-schedules", request.date, "set-service-operator"], request);
    }

    public async setServiceCarrier(request: SetDayScheduleServiceCarrierRequest): Promise<SetDayScheduleServiceCarrierResponse> {
        return await this.httpPost(["day-schedules", request.date, "set-service-carrier"], request);
    }

    public async setServiceGuide(request: SetDayScheduleServiceGuideRequest): Promise<SetDayScheduleServiceGuideResponse> {
        return await this.httpPost(["day-schedules", request.date, "set-service-guide"], request);
    }

    public async splitService(request: SplitDayScheduleServiceRequest): Promise<SplitDayScheduleServiceResponse> {
        return await this.httpPost(["day-schedules", request.date, "split-service"], request);
    }

    public async assignBookingsToSupportService(request: AssignBookingsToDayScheduleSupportRequest): Promise<AssignBookingsToDayScheduleSupportResponse> {
        return await this.httpPost(["day-schedules", request.date, "assign-bookings-to-support"], request);
    }

    public async unassignBookingsFromSupportService(request: UnassignBookingsFromDayScheduleSupportRequest): Promise<UnassignBookingsFromDayScheduleSupportResponse> {
        return await this.httpPost(["day-schedules", request.date, "unassign-bookings-from-support"], request);
    }

    public async generatetList(request: GenerateDayScheduleListRequest): Promise<GenerateDayScheduleListResponse> {
        return await this.httpPost(["day-schedules", request.date, "lists", request.scheduledServiceId, "generate"], request);
    }

    public async generateVoucher(request: GenerateDayScheduleVoucherRequest): Promise<GenerateDayScheduleVoucherResponse> {
        return await this.httpPost(["day-schedules", request.date, "vouchers", request.scheduledServiceId, request.purchaseRateId, "generate"], request);
    }

    public async sendVoucherToProvider(request: SendDayScheduleVoucherToProviderRequest): Promise<SendDayScheduleVoucherToProviderResponse> {
        return await this.httpPost(["day-schedules", request.date, "vouchers", request.scheduledServiceId, request.purchaseRateId, "send"], request);
    }

    public async toggleVoucher(request: ToggleDayScheduleVoucherRequest): Promise<ToggleDayScheduleVoucherResponse> {
        return await this.httpPost(["day-schedules", request.date, "vouchers", request.scheduledServiceId, request.purchaseRateId, "toggle"], request);
    }

    public getListDownloadLink(date: string, scheduledServiceId: string, type?: string): string {
        if (type) {
            return this.buildTargetUrl(["day-schedules", date, "lists", scheduledServiceId, type]);
        } else {
            return this.buildTargetUrl(["day-schedules", date, "lists", scheduledServiceId]);
        }
    }

    public getVoucherDownloadLink(date: string, scheduledServiceId: string, purchaseRateId: string): string {
        return this.buildTargetUrl(["day-schedules", date, "vouchers", scheduledServiceId, purchaseRateId]);
    }

    public async sendList(request: SendDayScheduleListRequest): Promise<SendDayScheduleListResponse> {
        return await this.httpPost(["day-schedules", "0000-00-00", "lists", request.scheduledServiceId, "send"], request);
    }

    public async getBusRoutes(request: GetDayScheduleBusRoutesRequest): Promise<GetDayScheduleBusRoutesResponse> {
        return await this.httpGet(["day-schedules", request.date, "bus-routes"]);
    }

    public async generateRouteReport(request: GenerateDayScheduleRouteReportRequest): Promise<void> {
        const blob = await this.httpPostAsBlob(["day-schedules", request.date, "route-report"], request);

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "resumen-rutas-" + request.date + ".docx";
        a.click();
    }

    public async generateDirectReport(date: string): Promise<void> {
        const blob = await this.httpGetAsBlob(["day-schedules", date, "lists", "direct"]);

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "resumen-rutas-directos-" + date + ".pdf";
        a.click();
    }

    public async sendMassiveLists(request: SendDayScheduleMassiveListsRequest): Promise<SendDayScheduleMassiveListsResponse> {
        return await this.httpPost(["day-schedules", request.date, "send-massive-lists"], request);
    }

    public async getGuidePreferences(request: GetDayScheduleGuidePreferencesRequest): Promise<GetDayScheduleGuidePreferencesResponse> {
        return await this.httpGet(["day-schedules", request.from, request.to, "guide-preferences"]);
    }

    public async setGuidePreferences(request: SetDayScheduleGuidePreferencesRequest): Promise<GetDayScheduleGuidePreferencesResponse> {
        return await this.httpPost(["day-schedules", request.date, "guide-preferences"], request);
    }

}


class TextTranslationService extends BaseService {

    static instance = new TextTranslationService();

    public async translate(request: TranslateTextRequest): Promise<TranslateTextResponse> {
        return await this.httpPost(["text-translation", "translate"], request);
    }

}

class NameResolutionService extends BaseService {

    static instance = new NameResolutionService();

    public async resolve(request: ResolveNameRequest): Promise<ResolveNameResponse> {
        return await this.httpPost(["name-resolution", "resolve"], request);
    }

}

class StaticMapService extends BaseService {

    static instance = new StaticMapService();

    public generate(longitude: number, latitude: number, zoom: number, options?: {
        text?: string
        size?: number
    }): string {
        return this.buildTargetUrl(
            ["static-map", "generate", longitude.toString(), latitude.toString(), zoom.toString()],
            {
                text: options?.text,
                size: options?.size
            }
        );
    }

}


class UsersService extends BaseService {

    public static readonly instance = new UsersService();

    public async add(request: AddUserRequest): Promise<AddUserResponse> {
        return this.httpPost(["users"], request);
    }

    public async edit(request: EditUserRequest): Promise<EditUserResponse> {
        return this.httpPost(["users", request.id, "edit"], request);
    }

    public async getAll(): Promise<GetAllUsersResponse> {
        return await this.httpGet<GetAllUsersResponse>(["users"]);
    }

    public async get(request: GetUserRequest): Promise<GetUserResponse> {
        return this.httpGet(["users", request.id]);
    }

    public async delete(request: DeleteUserRequest): Promise<DeleteUserResponse> {
        return this.httpDelete(["users", request.id]);
    }

    public async rename(request: RenameUserRequest): Promise<RenameUserResponse> {
        return this.httpPost(["users", request.id, "rename"], request);
    }

    public async logIn(request: LogUserInRequest): Promise<LogUserInResponse> {
        return this.httpRawPost(["users/login"], request);
    }

    public async resetPassword(request: ResetUserPasswordRequest): Promise<ResetUserPasswordResponse> {
        return await this.httpPost<ResetUserPasswordResponse>(["users/reset-password"], request);
    }

    public async logOut(request: LogUserOutRequest): Promise<LogUserOutResponse> {
        return this.httpPost(["users/logout"], request);
    }

    public async toggleStatus(request: ToggleUserStatusRequest): Promise<ToggleUserStatusResponse> {
        return this.httpPost(["users", request.id, "toggle-status"], request);
    }

    public async recoverPassword(request: RecoverUserPasswordRequest): Promise<RecoverUserPasswordResponse> {
        return this.httpPost(["users", request.id, "recover"], request);
    }

    public async changePassword(request: ChangeUserPasswordRequest): Promise<ChangeUserPasswordResponse> {
        return this.httpPost(["users", request.id, "password"], request);
    }

    public async impersonate(request: ImpersonateUserRequest): Promise<ImpersonateUserResponse> {
        return this.httpPost(["users", request.id, "impersonate"], request);
    }

}

class ProfilesService extends BaseService {

    public static readonly instance = new ProfilesService();

    public async getAll(): Promise<GetAllProfilesResponse> {
        return await this.httpGet<GetAllProfilesResponse>(["profiles"]);
    }

    public async get(request: GetProfileRequest): Promise<GetProfileResponse> {
        return await this.httpGet<GetProfileResponse>(["profiles", request.id]);
    }

    public async delete(request: DeleteProfileRequest): Promise<DeleteProfileResponse> {
        return await this.httpDelete<DeleteProfileResponse>(["profiles", request.id]);
    }

    public async rename(request: RenameProfileRequest): Promise<RenameProfileResponse> {
        return await this.httpPost<RenameProfileResponse>(["profiles", request.id, "rename"], request);
    }

    public async add(request: AddProfileRequest): Promise<AddProfileResponse> {
        return await this.httpPost<AddProfileResponse>(["profiles"], request);
    }

    public async edit(request: EditProfileRequest): Promise<EditProfileResponse> {
        return await this.httpPost<EditProfileResponse>(["profiles", request.id, "edit"], request);
    }

    public async lookup(): Promise<LookupProfilesResponse> {
        return await this.httpGet<LookupProfilesResponse>(["profiles", "lookup"]);
    }

    public async changeDescription(request: ChangeProfileDescriptionRequest): Promise<ChangeProfileDescriptionResponse> {
        return await this.httpPost<ChangeProfileDescriptionResponse>(["profiles", request.id, "change-description"], request);
    }

    public async changePermissions(request: ChangeProfilePermissionsRequest): Promise<ChangeProfilePermissionsResponse> {
        return await this.httpPost<ChangeProfilePermissionsResponse>(["profiles", request.id, "change-permissions"], request);
    }

    public async getAvailablePermissions(): Promise<GetAvailableProfilePermissionsResponse> {
        return await this.httpGet<GetAvailableProfilePermissionsResponse>(["profiles", "available-permissions"]);
    }

    public async renamePermission(request: RenameProfilePermissionRequest): Promise<RenameProfilePermissionResponse> {
        return await this.httpPost<RenameProfilePermissionResponse>(["profiles", "rename-permission"], request);
    }

}

class ZonesService extends BaseService {

    private lookupCache?: LookupZonesResponse;

    public static readonly instance = new ZonesService();

    public async getAll(): Promise<GetAllZonesResponse> {
        return await this.httpGet<GetAllZonesResponse>(["zones"]);
    }

    public async get(request: GetZoneRequest): Promise<GetZoneResponse> {
        return await this.httpGet<GetZoneResponse>(["zones", request.id]);
    }

    public async delete(request: DeleteZoneRequest): Promise<DeleteZoneResponse> {
        return await this.httpDelete<DeleteZoneResponse>(["zones", request.id]);
    }

    public async rename(request: RenameZoneRequest): Promise<RenameZoneResponse> {
        return await this.httpPost<RenameZoneResponse>(["zones", request.id, "rename"], request);
    }

    public async changeCode(request: ChangeZoneCodeRequest): Promise<ChangeZoneCodeResponse> {
        return await this.httpPost<ChangeZoneCodeResponse>(["zones", request.id, "change-code"], request);
    }

    public async changeDescription(request: ChangeZoneDescriptionRequest): Promise<ChangeZoneDescriptionResponse> {
        return await this.httpPost<ChangeZoneDescriptionResponse>(["zones", request.id, "change-description"], request);
    }

    public async add(request: AddZoneRequest): Promise<AddZoneResponse> {
        return await this.httpPost<AddZoneResponse>(["zones"], request);
    }

    public async lookup(request: LookupZonesRequest = {}): Promise<LookupZonesResponse> {
        if (this.lookupCache) {
            return this.lookupCache;
        }

        this.lookupCache = await this.httpGet<LookupZonesResponse>(["zones", "lookup"]);
        return this.lookupCache;
    }

    public async edit(request: EditZoneRequest): Promise<EditZoneResponse> {
        return await this.httpPost<EditZoneResponse>(["zones", request.id, "edit"], request);
    }

}


export interface SelectionDialogRequest {
    type: "agency" | "organization" | "employee" | "provider" | "carrier" | "guide" | "user" | "operator" | "product" | "meeting-point" | "transfer-extra" | "purchase-rate";
    organizationId?: string;

    filter?: string;
    filterIds?: string[];

    title?: string;
    message?: string;
    warningMessage?: string;
    icon?: string;
    iconColor?: string;
}

export interface ConfirmationDialogRequest {
    title: string;
    message?: string;
    messages?: string[];
    debug?: any;
    warningMessage?: string;
    questions?: string[];
    inputs?: ({
        type?: "text" | "date" | "text-area" | "select" | "number" | "switch" | "time-range" | "aggregate-list";
        label: string;
        value?: string | boolean | PortableAggregateList;
        items?: Array<{ id: string, name: string }>;
        required?: boolean;
        rows?: number;
        disabled?: boolean;
        comment?: string;
        minimumValue?: string;
        maximumValue?: string;
        aggregateType?: string;
    } | undefined)[];
    nocancel?: boolean;
    color?: string;
    width?: string;
    icon?: string;
    iconColor?: string;
    buttonColor?: string;
    cancelButtonColor?: string;
    acceptButtonText?: string;
    cancelButtonText?: string;
    attach?: any;
    persistent?: boolean;
}

export interface ToastRequest {
    title: string;

    message?: string;
    color?: string;

    buttonText?: string;
    buttonColor?: string;
    buttonIcon?: string;
    buttonRoute?: any;
}

export interface BookingContextMenuRequest {
    id: string;
    event: MouseEvent;
    attach?: any;

    onChange?: () => void;
    onEdit?: () => void;
    onSelectService?: (id: string, date: string) => void;
}

export interface OpenProgressRequest {
    title: string;
}

export interface UpdateProgressRequest {
    message?: string;
    error?: string;
}

class DialogService {

    private internalBookingContextVisible = false;

    public static readonly instance = new DialogService();

    public readonly OpenToastEvent = "toast:open";

    public readonly OpenConfirmationDialogEvent = "dialog:confirmation:open";
    public readonly CloseConfirmationDialogEvent = "dialog:confirmation:close";

    public readonly OpenSelectionDialogEvent = "dialog:selection:open";
    public readonly CloseSelectionDialogEvent = "dialog:selection:close";

    public readonly OpenErrorDialogEvent = "dialog:error:open";
    public readonly CloseErrorDialogEvent = "dialog:error:close";

    public readonly OpenBookingContextEvent = "menu:bookingcontext:open";
    public readonly CloseBookingContextEvent = "menu:bookingcontext:close";

    public readonly OpenProgressDialogEvent = "dialog:progress:open";
    public readonly CloseProgressDialogEvent = "dialog:progress:close";
    public readonly UpdateProgressDialogEvent = "dialog:progress:update";

    public get bookingContextVisible(): boolean {
        return this.internalBookingContextVisible;
    }

    public toast(request: ToastRequest) {
        EventBus.$emit(this.OpenToastEvent, request);
    }

    public openProgress(data: OpenProgressRequest): void {
        EventBus.$emit(this.OpenProgressDialogEvent, data);
    }

    public closeProgress(): void {
        EventBus.$emit(this.CloseProgressDialogEvent);
    }

    public updateProgress(data: UpdateProgressRequest): void {
        EventBus.$emit(this.UpdateProgressDialogEvent, data);
    }

    public bookingContext(request: BookingContextMenuRequest | undefined, close = false): void {
        if (close) {
            this.internalBookingContextVisible = false;
        } else {
            this.internalBookingContextVisible = true;

            EventBus.$emit(this.OpenBookingContextEvent, request);
        }
    }

    public selection(request: SelectionDialogRequest | string, close = false): Promise<string> {
        if (close) {
            EventBus.$emit(this.CloseSelectionDialogEvent, request);
            return Promise.resolve("");
        } else {
            EventBus.$emit(this.OpenSelectionDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseSelectionDialogEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

    public confirmation(request: ConfirmationDialogRequest | boolean, close = false): Promise<boolean> {
        if (close) {
            EventBus.$emit(this.CloseConfirmationDialogEvent, request);
            return Promise.resolve(false);
        } else {
            EventBus.$emit(this.OpenConfirmationDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseConfirmationDialogEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

    public confirmationWithQuestions(request: ConfirmationDialogRequest | boolean[], close = false): Promise<boolean[]> {
        if (close) {
            EventBus.$emit(this.CloseConfirmationDialogEvent, request);
            return Promise.resolve([false]);
        } else {
            EventBus.$emit(this.OpenConfirmationDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseConfirmationDialogEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

    public confirmationWithInputs(request: ConfirmationDialogRequest | [result: boolean, ...inputs: string[]], close = false): Promise<[result: boolean, ...inputs: string[]]> {
        if (close) {
            EventBus.$emit(this.CloseConfirmationDialogEvent, request);
            return Promise.resolve([false]);
        } else {
            EventBus.$emit(this.OpenConfirmationDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseConfirmationDialogEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

    public confirmationWithQuestionsAndInputs(request: ConfirmationDialogRequest | [result: boolean, questions: boolean[], inputs: string[]], close = false): Promise<[result: boolean, questions: boolean[], inputs: string[]]> {
        if (close) {
            EventBus.$emit(this.CloseConfirmationDialogEvent, request);
            return Promise.resolve([false, [], []]);
        } else {
            EventBus.$emit(this.OpenConfirmationDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseConfirmationDialogEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

    public loadImage(): Promise<{ name: string; data: string }> {
        return new Promise((resolve) => {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*";

            input.onchange = () => {
                const file = input.files?.[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const name = file.name;
                        const data = e.target?.result as string;

                        resolve({ name, data });
                    };
                    reader.readAsDataURL(file);
                }
            };

            input.click();

            setTimeout(() => {
                input.remove();
            }, 100);
        });
    }

    public loadDocument(): Promise<{ name: string; data: string }> {
        return new Promise((resolve) => {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "application/pdf";

            input.onchange = () => {
                const file = input.files?.[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const name = file.name;
                        const data = e.target?.result as string;
                        const base64 = data.split(",")[1];

                        resolve({ name, data: base64 });
                    };
                    reader.readAsDataURL(file);
                }
            };

            document.body.appendChild(input);
            input.click();

            setTimeout(() => {
                input.remove();
            }, 100);
        });
    }

    public loadExcel(): Promise<{ name: string; data: string }> {
        return new Promise((resolve) => {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            input.style.display = "none";

            input.onchange = () => {
                const file = input.files?.[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const name = file.name;
                        const data = e.target?.result as string;
                        const base64 = data.split(",")[1];

                        resolve({ name, data: base64 });
                    };
                    reader.readAsDataURL(file);
                }
            };

            document.body.appendChild(input);
            input.click();

            setTimeout(() => {
                input.remove();
            }, 100);

        });
    }


}

export type GetMeetingPointInMapRequest = {
    mode: "hotel";
    hotelId: string;
    productId?: string;
} | {
    mode: "address";
    address: string;
    productId?: string;
};

export interface GetMeetingPointInMapResponse {
    id: string;
    name: string;
    distanceInMeters: number;
}

class MeetingPointsService extends BaseService {

    public static readonly instance = new MeetingPointsService();

    public readonly OpenMapEvent = "meetingpointsmap:open";
    public readonly CloseMapEvent = "meetingpointsmap:close";

    public getInMap(request: GetMeetingPointInMapRequest): Promise<GetMeetingPointInMapResponse | undefined>;
    public getInMap(request: GetMeetingPointInMapResponse | undefined, close: true): void;
    public getInMap(request: GetMeetingPointInMapRequest | GetMeetingPointInMapResponse | undefined, close = false): Promise<GetMeetingPointInMapResponse | undefined> | void {
        if (close) {
            EventBus.$emit(this.CloseMapEvent, request);
        } else {
            EventBus.$emit(this.OpenMapEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseMapEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

    public async getAll(): Promise<GetAllMeetingPointsResponse> {
        return await this.httpGet<GetAllMeetingPointsResponse>(["meetingpoints"]);
    }

    public async get(request: GetMeetingPointRequest): Promise<GetMeetingPointResponse> {
        return await this.httpGet<GetMeetingPointResponse>(["meetingpoints", request.id]);
    }

    public async delete(request: DeleteMeetingPointRequest): Promise<DeleteMeetingPointResponse> {
        return await this.httpDelete<DeleteMeetingPointResponse>(["meetingpoints", request.id]);
    }

    public async edit(request: EditMeetingPointRequest): Promise<EditMeetingPointResponse> {
        return await this.httpPost<EditMeetingPointResponse>(["meetingpoints", request.id, "edit"], request);
    }

    public async rename(request: RenameMeetingPointRequest): Promise<RenameMeetingPointResponse> {
        return await this.httpPost<RenameMeetingPointResponse>(["meetingpoints", request.id, "rename"], request);
    }

    public async add(request: AddMeetingPointRequest): Promise<AddMeetingPointResponse> {
        return await this.httpPost<AddMeetingPointResponse>(["meetingpoints"], request);
    }

    public async lookup(request: LookupMeetingPointsRequest = {}): Promise<LookupMeetingPointsResponse> {
        return await this.httpGet<LookupMeetingPointsResponse>(["meetingpoints", "lookup"]);
    }

    public async changeDescription(request: ChangeMeetingPointDescriptionRequest): Promise<ChangeMeetingPointDescriptionResponse> {
        return await this.httpPost<ChangeMeetingPointDescriptionResponse>(["meetingpoints", request.id, "change-description"], request);
    }

    public async changeZone(request: ChangeMeetingPointZoneRequest): Promise<ChangeMeetingPointZoneResponse> {
        return await this.httpPost<ChangeMeetingPointZoneResponse>(["meetingpoints", request.id, "change-zone"], request);
    }

    public async changeLocality(request: ChangeMeetingPointLocalityRequest): Promise<ChangeMeetingPointLocalityResponse> {
        return await this.httpPost<ChangeMeetingPointLocalityResponse>(["meetingpoints", request.id, "change-locality"], request);
    }

    public async changeOrder(request: ChangeMeetingPointOrderRequest): Promise<ChangeMeetingPointOrderResponse> {
        return await this.httpPost<ChangeMeetingPointOrderResponse>(["meetingpoints", request.id, "change-order"], request);
    }

    public async changeGeolocation(request: ChangeMeetingPointGeolocationRequest): Promise<ChangeMeetingPointGeolocationResponse> {
        return await this.httpPost<ChangeMeetingPointGeolocationResponse>(["meetingpoints", request.id, "change-geolocation"], request);
    }

    public async getNearest(request: GetNearestMeetingPointsRequest): Promise<GetNearestMeetingPointsResponse> {
        return await this.httpPost<GetNearestMeetingPointsResponse>(["meetingpoints", "nearest"], request);
    }

    public async bulkDelete(request: BulkDeleteMeetingPointsRequest): Promise<BulkDeleteMeetingPointsResponse> {
        return await this.httpPost<BulkDeleteMeetingPointsResponse>(["meetingpoints", "bulk-delete"], request);
    }

    public async join(request: JoinMeetingPointsRequest): Promise<JoinMeetingPointsResponse> {
        return await this.httpPost<JoinMeetingPointsResponse>(["meetingpoints", "join"], request);
    }
}

class HotelsService extends BaseService {

    public static readonly instance = new HotelsService();

    public async getAll(): Promise<GetAllHotelsResponse> {
        return await this.httpGet<GetAllHotelsResponse>(["hotels"]);
    }

    public async get(request: GetHotelRequest): Promise<GetHotelResponse> {
        return await this.httpGet<GetHotelResponse>(["hotels", request.id]);
    }

    public async delete(request: DeleteHotelRequest): Promise<DeleteHotelResponse> {
        return await this.httpDelete<DeleteHotelResponse>(["hotels", request.id]);
    }

    public async edit(request: EditHotelRequest): Promise<EditHotelResponse> {
        return await this.httpPost<EditHotelResponse>(["hotels", request.id, "edit"], request);
    }

    public async rename(request: RenameHotelRequest): Promise<RenameHotelResponse> {
        return await this.httpPost<RenameHotelResponse>(["hotels", request.id, "rename"], request);
    }

    public async add(request: AddHotelRequest): Promise<AddHotelResponse> {
        return await this.httpPost<AddHotelResponse>(["hotels"], request);
    }

    public async bulkDelete(request: BulkDeleteHotelsRequest): Promise<BulkDeleteHotelsResponse> {
        return await this.httpPost<BulkDeleteHotelsResponse>(["hotels", "bulk-delete"], request);
    }

    public async setAsReviewed(request: SetHotelAsReviewedRequest): Promise<SetHotelAsReviewedResponse> {
        return await this.httpPost<SetHotelAsReviewedResponse>(["hotels", request.id, "set-as-reviewed"], request);
    }

    public async setAsUnreviewed(request: SetHotelAsUnreviewedRequest): Promise<SetHotelAsUnreviewedResponse> {
        return await this.httpPost<SetHotelAsUnreviewedResponse>(["hotels", request.id, "set-as-unreviewed"], request);
    }

    public async setRelevance(request: SetHotelRelevanceRequest): Promise<SetHotelRelevanceResponse> {
        return await this.httpPost<SetHotelRelevanceResponse>(["hotels", request.id, "set-relevance"], request);
    }

    public async bulkSetRelevance(request: BulkSetHotelRelevanceRequest): Promise<BulkSetHotelRelevanceResponse> {
        return await this.httpPost<BulkSetHotelRelevanceResponse>(["hotels", "bulk-set-relevance"], request);
    }

    public async getProducts(request: GetHotelProductsRequest): Promise<GetHotelProductsResponse> {
        return await this.httpGet<GetHotelProductsResponse>(["hotels", request.id, "products"]);
    }

}

class ChannelsService extends BaseService {

    public static readonly instance = new ChannelsService();

    public async getAll(): Promise<{ id: string, name: string }[]> {
        return [
            {
                id: "CRS",
                name: "CRS",
            },
            {
                id: "WEB",
                name: "Website",
            },
            {
                id: "API",
                name: "API",
            },
            {
                id: "AGENT",
                name: "Agent Center",
            },
            {
                id: "FORM",
                name: "Formulario",
            },
            {
                id: "INTEGRATION",
                name: "Integración",
            },
        ];
    }
}

class AgenciesService extends BaseService {

    public static readonly instance = new AgenciesService();

    public async getTypes(): Promise<{ id: string, name: string }[]> {
        return [
            {
                id: "ttoo",
                name: "Touroperador",
            },
            {
                id: "ota",
                name: "OTA",
            },
            {
                id: "pos",
                name: "Punto de Venta",
            },
            {
                id: "direct",
                name: "Grupo",
            },
            {
                id: "business",
                name: "Empresa",
            },
            {
                id: "affiliate",
                name: "Afiliado",
            },
        ];
    }

    public async getAll(): Promise<GetAllAgenciesResponse> {
        return await this.httpGet<GetAllAgenciesResponse>(["agencies"]);
    }

    public async get(request: GetAgencyRequest): Promise<GetAgencyResponse> {
        return await this.httpGet<GetAgencyResponse>(["agencies", request.id]);
    }

    public async delete(request: DeleteAgencyRequest): Promise<DeleteAgencyResponse> {
        return await this.httpDelete<DeleteAgencyResponse>(["agencies", request.id]);
    }

    public async rename(request: RenameAgencyRequest): Promise<RenameAgencyResponse> {
        return await this.httpPost<RenameAgencyResponse>(["agencies", request.id, "rename"], request);
    }

    public async edit(request: EditAgencyRequest): Promise<EditAgencyResponse> {
        return await this.httpPost<EditAgencyResponse>(["agencies", request.id, "edit"], request);
    }

    public async add(request: AddAgencyRequest): Promise<AddAgencyResponse> {
        return await this.httpPost<AddAgencyResponse>(["agencies"], request);
    }

    public async bulkDelete(request: BulkDeleteAgenciesRequest): Promise<BulkDeleteAgenciesResponse> {
        return await this.httpPost<BulkDeleteAgenciesResponse>(["agencies", "bulk-delete"], request);
    }

    public async addPricing(request: AddAgencyPricingRequest): Promise<AddAgencyPricingResponse> {
        return await this.httpPost<AddAgencyPricingResponse>(["agencies", request.id, "add-pricing"], request);
    }

    public async editPricing(request: EditAgencyPricingRequest): Promise<EditAgencyPricingResponse> {
        return await this.httpPost<EditAgencyPricingResponse>(["agencies", request.id, "edit-pricing"], request);
    }

    public async removePricing(request: RemoveAgencyPricingRequest): Promise<RemoveAgencyPricingResponse> {
        return await this.httpPost<RemoveAgencyPricingResponse>(["agencies", request.id, "remove-pricing"], request);
    }

    public async getNextReference(request: GetAgencyNextReferenceRequest): Promise<GetAgencyNextReferenceResponse> {
        return await this.httpGet<GetAgencyNextReferenceResponse>(["agencies", request.id, "next-reference"]);
    }

    public async bulkSetRate(request: BulkSetAgencyRateRequest): Promise<BulkSetAgencyRateResponse> {
        return await this.httpPost<BulkSetAgencyRateResponse>(["agencies", "bulk-set-rate"], request);
    }

    public async bulkSetDocumentationSent(request: BulkSetAgencyDocumentationSentRequest): Promise<BulkSetAgencyDocumentationSentResponse> {
        return await this.httpPost<BulkSetAgencyDocumentationSentResponse>(["agencies", "bulk-set-documentation-sent"], request);
    }

    public async removeRate(request: RemoveAgencyRateRequest): Promise<RemoveAgencyRateResponse> {
        return await this.httpPost<RemoveAgencyRateResponse>(["agencies", request.id, "remove-rate"], request);
    }

    public async getQRBrochure(request: GenerateAgencyQRBrochureRequest): Promise<void> {
        await this.httpPostAsBlob(["agencies", request.id, "generate-brochure"], request, true);
    }

    public async setTrainRate(request: SetAgencyTrainRateRequest): Promise<SetAgencyTrainRateResponse> {
        return await this.httpPost<SetAgencyTrainRateResponse>(["agencies", request.id, "train-rate"], request);
    }

    public async bulkSetTrainRate(request: BulkSetAgencyTrainRateRequest): Promise<BulkSetAgencyTrainRateResponse> {
        return await this.httpPost<BulkSetAgencyTrainRateResponse>(["agencies", "bulk-set-train-rate"], request);
    }

    public async setSimpleBookingPin(request: SetAgencySimpleBookingPinRequest): Promise<SetAgencySimpleBookingPinResponse> {
        return await this.httpPost<SetAgencySimpleBookingPinResponse>(["agencies", request.id, "simple-booking-pin"], request);
    }

    public async bulkSetParentAgency(request: BulkSetAgencyParentAgencyRequest): Promise<BulkSetAgencyParentAgencyResponse> {
        return await this.httpPost<BulkSetAgencyParentAgencyResponse>(["agencies", "bulk-set-parent-agency"], request);
    }

    public async refreshSharedCollection(request: RefreshSharedAgencyCollectionRequest): Promise<RefreshSharedAgencyCollectionResponse> {
        return await this.httpPost<RefreshSharedAgencyCollectionResponse>(["agencies", "refresh-shared-collection"], request);
    }

    public async evaluateProductPricing(request: EvaluateAgencyProductPricingRequest): Promise<EvaluateAgencyProductPricingResponse> {
        return await this.httpPost<EvaluateAgencyProductPricingResponse>(["agencies", request.id, "evaluate-product-pricing"], request);
    }

    public async updateBookingCount(request: UpdateAgenciesBookingCountRequest): Promise<UpdateAgenciesBookingCountResponse> {
        return await this.httpPost<UpdateAgenciesBookingCountResponse>(["agencies", "update-booking-count"], request);
    }

}

class ProvidersService extends BaseService {

    public static readonly instance = new ProvidersService();

    public async getAll(): Promise<GetAllProvidersResponse> {
        return await this.httpGet<GetAllProvidersResponse>(["providers"]);
    }

    public async get(request: GetProviderRequest): Promise<GetProviderResponse> {
        return await this.httpGet<GetProviderResponse>(["providers", request.id]);
    }

    public async delete(request: DeleteProviderRequest): Promise<DeleteProviderResponse> {
        return await this.httpDelete<DeleteProviderResponse>(["providers", request.id]);
    }

    public async rename(request: RenameProviderRequest): Promise<RenameProviderResponse> {
        return await this.httpPost<RenameProviderResponse>(["providers", request.id, "rename"], request);
    }

    public async edit(request: EditProviderRequest): Promise<EditProviderResponse> {
        return await this.httpPost<EditProviderResponse>(["providers", request.id, "edit"], request);
    }

    public async add(request: AddProviderRequest): Promise<AddProviderResponse> {
        return await this.httpPost<AddProviderResponse>(["providers"], request);
    }

    public async bulkDelete(request: BulkDeleteProvidersRequest): Promise<BulkDeleteProvidersResponse> {
        return await this.httpPost<BulkDeleteProvidersResponse>(["providers", "bulk-delete"], request);
    }

}

class CarriersService extends BaseService {

    public static readonly instance = new CarriersService();

    public async getAll(): Promise<GetAllCarriersResponse> {
        return await this.httpGet<GetAllCarriersResponse>(["carriers"]);
    }

    public async get(request: GetCarrierRequest): Promise<GetCarrierResponse> {
        return await this.httpGet<GetCarrierResponse>(["carriers", request.id]);
    }

    public async delete(request: DeleteCarrierRequest): Promise<DeleteCarrierResponse> {
        return await this.httpDelete<DeleteCarrierResponse>(["carriers", request.id]);
    }

    public async rename(request: RenameCarrierRequest): Promise<RenameCarrierResponse> {
        return await this.httpPost<RenameCarrierResponse>(["carriers", request.id, "rename"], request);
    }

    public async edit(request: EditCarrierRequest): Promise<EditCarrierResponse> {
        return await this.httpPost<EditCarrierResponse>(["carriers", request.id, "edit"], request);
    }

    public async add(request: AddCarrierRequest): Promise<AddCarrierResponse> {
        return await this.httpPost<AddCarrierResponse>(["carriers"], request);
    }

    public async bulkDelete(request: BulkDeleteCarriersRequest): Promise<BulkDeleteCarriersResponse> {
        return await this.httpPost<BulkDeleteCarriersResponse>(["carriers", "bulk-delete"], request);
    }

}


class ReportingService extends BaseService {

    public static readonly instance = new ReportingService();

    public async downloadHotelListingReport(request: DownloadHotelListingReportRequest): Promise<void> {
        const blob = await this.httpPostAsBlob(["reporting", "hotel-listing"], request);

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "listado-hoteles.pdf";
        a.click();
    }

    public async downloadZoneTimingReport(request: DownloadZoneTimingReportRequest): Promise<void> {
        const blob = await this.httpPostAsBlob(["reporting", "zone-timing"], request);

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "horarios-zona.docx";
        a.click();
    }

    public async downloadZoneRateReport(request: DownloadZoneRateReportRequest): Promise<void> {
        await this.httpPostAsBlob(["reporting", "zone-rate"], request, true);
    }

    public async generateMultipleReports(request: GenerateMultipleReportsRequest): Promise<void> {
        await this.httpPostAsBlob(["reporting", "generate-multiple"], request, true);
    }

    public async sendMultipleReports(request: SendMultipleReportsRequest): Promise<SendMultipleReportsResponse> {
        return this.httpPost(["reporting", "send-multiple"], request);
    }

    public async downloadMasterDataReport(request: DownloadMasterDataReportRequest): Promise<void> {
        const blob = await this.httpPostAsBlob(["reporting", "master-data"], request);

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "intrabooking-master-data.xlsx";
        a.click();
    }
}


class ImagesService extends BaseService {

    public static readonly instance = new ImagesService();

    public async add(request: AddImageRequest): Promise<AddImageResponse> {
        return await this.httpPost<AddImageResponse>(["images"], request);
    }

    public async getAll(): Promise<GetAllImagesResponse> {
        return await this.httpGet<GetAllImagesResponse>(["images"]);
    }

    public async get(request: GetImageRequest): Promise<GetImageResponse> {
        return await this.httpGet<GetImageResponse>(["images", request.id]);
    }

    public async edit(request: EditImageRequest): Promise<EditImageResponse> {
        return await this.httpPost<EditImageResponse>(["images", request.id, "edit"], request);
    }

    public async delete(request: DeleteImageRequest): Promise<DeleteImageResponse> {
        return await this.httpDelete<DeleteImageResponse>(["images", request.id]);
    }

    public async bulkDelete(request: BulkDeleteImagesRequest): Promise<BulkDeleteImagesResponse> {
        return await this.httpPost<BulkDeleteImagesResponse>(["images", "bulk-delete"], request);
    }

    public async bulkSetCategory(request: BulkSetImageCategoryRequest): Promise<BulkSetImageCategoryResponse> {
        return await this.httpPost<BulkSetImageCategoryResponse>(["images", "bulk-set-category"], request);
    }
}


export interface GalleryRequest {
    category?: string;
    multiple?: boolean;
}

export interface GalleryResponse {
    selection: string[];
}

class GalleryService {

    public static readonly instance = new GalleryService();

    public readonly OpenGalleryEvent = "gallery:open";
    public readonly CloseGalleryEvent = "gallery:close";

    public open(data: GalleryRequest): Promise<GalleryResponse | undefined> {
        EventBus.$emit(this.OpenGalleryEvent, data);

        return new Promise((resolve) => {
            EventBus.$on(this.CloseGalleryEvent, (result: any) => {
                resolve(result);
            });
        })
    }

    public close(result?: GalleryResponse): void {
        EventBus.$emit(this.CloseGalleryEvent, result);
    }

}

class ImageCategoriesService extends BaseService {

    public static readonly instance = new ImageCategoriesService();

    public async getAll(): Promise<GetAllImageCategoriesResponse> {
        return await this.httpGet<GetAllImageCategoriesResponse>(["imagecategories"]);
    }

    public async get(request: GetImageCategoryRequest): Promise<GetImageCategoryResponse> {
        return await this.httpGet<GetImageCategoryResponse>(["imagecategories", request.id]);
    }

    public async delete(request: DeleteImageCategoryRequest): Promise<DeleteImageCategoryResponse> {
        return await this.httpDelete<DeleteImageCategoryResponse>(["imagecategories", request.id]);
    }

    public async rename(request: RenameImageCategoryRequest): Promise<RenameImageCategoryResponse> {
        return await this.httpPost<RenameImageCategoryResponse>(["imagecategories", request.id, "rename"], request);
    }

    public async edit(request: EditImageCategoryRequest): Promise<EditImageCategoryResponse> {
        return await this.httpPost<EditImageCategoryResponse>(["imagecategories", request.id, "edit"], request);
    }

    public async add(request: AddImageCategoryRequest): Promise<AddImageCategoryResponse> {
        return await this.httpPost<AddImageCategoryResponse>(["imagecategories"], request);
    }

    public async bulkDelete(request: BulkDeleteImageCategoriesRequest): Promise<BulkDeleteImageCategoriesResponse> {
        return await this.httpPost<BulkDeleteImageCategoriesResponse>(["imagecategories", "bulk-delete"], request);
    }

}

class ActivitiesService extends BaseService {

    public static readonly instance = new ActivitiesService();

    public async getAll(): Promise<GetAllActivitiesResponse> {
        return await this.httpGet<GetAllActivitiesResponse>(["activities"]);
    }

    public async get(request: GetActivityRequest): Promise<GetActivityResponse> {
        return await this.httpGet<GetActivityResponse>(["activities", request.id]);
    }

    public async delete(request: DeleteActivityRequest): Promise<DeleteActivityResponse> {
        return await this.httpDelete<DeleteActivityResponse>(["activities", request.id]);
    }

    public async rename(request: RenameActivityRequest): Promise<RenameActivityResponse> {
        return await this.httpPost<RenameActivityResponse>(["activities", request.id, "rename"], request);
    }

    public async edit(request: EditActivityRequest): Promise<EditActivityResponse> {
        return await this.httpPost<EditActivityResponse>(["activities", request.id, "edit"], request);
    }

    public async add(request: AddActivityRequest): Promise<AddActivityResponse> {
        return await this.httpPost<AddActivityResponse>(["activities"], request);
    }

    public async addUsingAI(request: AddActivityUsingAIRequest): Promise<AddActivityUsingAIResponse> {
        return await this.httpPost<AddActivityUsingAIResponse>(["activities", "ai"], request);
    }

    public async bulkDelete(request: BulkDeleteActivitiesRequest): Promise<BulkDeleteActivitiesResponse> {
        return await this.httpPost<BulkDeleteActivitiesResponse>(["activities", "bulk-delete"], request);
    }

    public async bulkSetExternalOperator(request: BulkSetActivityExternalOperatorRequest): Promise<BulkSetActivityExternalOperatorResponse> {
        return await this.httpPost<BulkSetActivityExternalOperatorResponse>(["activities", "bulk-set-external-operator"], request);
    }

    public async reorder(request: ReorderActivitiesRequest): Promise<ReorderActivitiesResponse> {
        return await this.httpPost<ReorderActivitiesResponse>(["activities", "reorder"], request);
    }

}


export interface ContentSelectorRequest {
    type?: string;
    multiple?: boolean;
}

export interface ContentSelectorResponse {
    newDataAdded: boolean;
    selection: string[];
}

class ContentElementsService extends BaseService {

    public static readonly instance = new ContentElementsService();

    public readonly OpenSelectorEvent = "contentelementsselector:open";
    public readonly CloseSelectorEvent = "contentelementsselector:close";

    public openSelector(data: ContentSelectorRequest): Promise<ContentSelectorResponse | undefined> {
        EventBus.$emit(this.OpenSelectorEvent, data);

        return new Promise((resolve) => {
            EventBus.$on(this.CloseSelectorEvent, (result: any) => {
                resolve(result);
            });
        })
    }

    public closeSelector(result?: ContentSelectorResponse): void {
        EventBus.$emit(this.CloseSelectorEvent, result);
    }

    public async getAll(): Promise<GetAllContentElementsResponse> {
        return await this.httpGet<GetAllContentElementsResponse>(["contentelements"]);
    }

    public async get(request: GetContentElementRequest): Promise<GetContentElementResponse> {
        return await this.httpGet<GetContentElementResponse>(["contentelements", request.id]);
    }

    public async delete(request: DeleteContentElementRequest): Promise<DeleteContentElementResponse> {
        return await this.httpDelete<DeleteContentElementResponse>(["contentelements", request.id]);
    }

    public async rename(request: RenameContentElementRequest): Promise<RenameContentElementResponse> {
        return await this.httpPost<RenameContentElementResponse>(["contentelements", request.id, "rename"], request);
    }

    public async edit(request: EditContentElementRequest): Promise<EditContentElementResponse> {
        return await this.httpPost<EditContentElementResponse>(["contentelements", request.id, "edit"], request);
    }

    public async add(request: AddContentElementRequest): Promise<AddContentElementResponse> {
        return await this.httpPost<AddContentElementResponse>(["contentelements"], request);
    }

    public async bulkDelete(request: BulkDeleteContentElementsRequest): Promise<BulkDeleteContentElementsResponse> {
        return await this.httpPost<BulkDeleteContentElementsResponse>(["contentelements", "bulk-delete"], request);
    }

}

class DocumentsService extends BaseService {

    public static readonly instance = new DocumentsService();

    public async getAll(): Promise<GetAllDocumentsResponse> {
        return await this.httpGet<GetAllDocumentsResponse>(["documents"]);
    }

    public async get(request: GetDocumentRequest): Promise<GetDocumentResponse> {
        return await this.httpGet<GetDocumentResponse>(["documents", request.id]);
    }

    public async delete(request: DeleteDocumentRequest): Promise<DeleteDocumentResponse> {
        return await this.httpDelete<DeleteDocumentResponse>(["documents", request.id]);
    }

    public async rename(request: RenameDocumentRequest): Promise<RenameDocumentResponse> {
        return await this.httpPost<RenameDocumentResponse>(["documents", request.id, "rename"], request);
    }

    public async edit(request: EditDocumentRequest): Promise<EditDocumentResponse> {
        return await this.httpPost<EditDocumentResponse>(["documents", request.id, "edit"], request);
    }

    public async add(request: AddDocumentRequest): Promise<AddDocumentResponse> {
        return await this.httpPost<AddDocumentResponse>(["documents"], request);
    }

    public async bulkDelete(request: BulkDeleteDocumentsRequest): Promise<BulkDeleteDocumentsResponse> {
        return await this.httpPost<BulkDeleteDocumentsResponse>(["documents", "bulk-delete"], request);
    }

}

class ProductsService extends BaseService {

    public static readonly instance = new ProductsService();

    public async getAll(): Promise<GetAllProductsResponse> {
        return await this.httpGet<GetAllProductsResponse>(["products"]);
    }

    public async get(request: GetProductRequest): Promise<GetProductResponse> {
        return await this.httpGet<GetProductResponse>(["products", request.id]);
    }

    public async delete(request: DeleteProductRequest): Promise<DeleteProductResponse> {
        return await this.httpDelete<DeleteProductResponse>(["products", request.id]);
    }

    public async rename(request: RenameProductRequest): Promise<RenameProductResponse> {
        return await this.httpPost<RenameProductResponse>(["products", request.id, "rename"], request);
    }

    public async edit(request: EditProductRequest): Promise<EditProductResponse> {
        return await this.httpPost<EditProductResponse>(["products", request.id, "edit"], request);
    }

    public async add(request: AddProductRequest): Promise<AddProductResponse> {
        return await this.httpPost<AddProductResponse>(["products"], request);
    }

    public async bulkDelete(request: BulkDeleteProductsRequest): Promise<BulkDeleteProductsResponse> {
        return await this.httpPost<BulkDeleteProductsResponse>(["products", "bulk-delete"], request);
    }

    public async getRestrictions(request: GetAllProductRestrictionsRequest): Promise<GetAllProductRestrictionsResponse> {
        return await this.httpGet<GetAllProductRestrictionsResponse>(["products", "restrictions", request.date]);
    }

    public async openOrCloseSales(request: OpenOrCloseProductSalesRequest): Promise<OpenOrCloseProductSalesResponse> {
        return await this.httpPost<OpenOrCloseProductSalesResponse>(["products", "open-close-sales"], request);
    }

    public async getOpenOrCloseSalesMessage(request: GetOpenOrCloseProductSalesMessageRequest): Promise<GetOpenOrCloseProductSalesMessageResponse> {
        return await this.httpPost<GetOpenOrCloseProductSalesMessageResponse>(["products", "get-open-close-sales-message"], request);
    }

    public async getScheduling(request: GetAllProductSchedulingRequest): Promise<GetAllProductSchedulingResponse> {
        return await this.httpPost<GetAllProductSchedulingResponse>(["products", "scheduling"], request);
    }

    public addSchedule(request: AddProductScheduleRequest): Promise<AddProductScheduleResponse> {
        return this.httpPost<AddProductScheduleResponse>(["products", request.id, "add-schedule"], request);
    }

    public editSchedule(request: EditProductScheduleRequest): Promise<EditProductScheduleResponse> {
        return this.httpPost<EditProductScheduleResponse>(["products", request.id, "edit-schedule"], request);
    }

    public removeSchedule(request: RemoveProductScheduleRequest): Promise<RemoveProductScheduleResponse> {
        return this.httpPost<RemoveProductScheduleResponse>(["products", request.id, "remove-schedule"], request);
    }

    public async addPricing(request: AddProductPricingRequest): Promise<AddProductPricingResponse> {
        return await this.httpPost<AddProductPricingResponse>(["products", request.id, "add-pricing"], request);
    }

    public async editPricing(request: EditProductPricingRequest): Promise<EditProductPricingResponse> {
        return await this.httpPost<EditProductPricingResponse>(["products", request.id, "edit-pricing"], request);
    }

    public async removePricing(request: RemoveProductPricingRequest): Promise<RemoveProductPricingResponse> {
        return await this.httpPost<RemoveProductPricingResponse>(["products", request.id, "remove-pricing"], request);
    }

    public async bulkAddPricing(request: BulkAddProductPricingRequest): Promise<BulkAddProductPricingResponse> {
        return await this.httpPost<BulkAddProductPricingResponse>(["products", "bulk-add-pricing"], request);
    }

    public bulkAddSchedule(request: BulkAddProductScheduleRequest): Promise<BulkAddProductScheduleResponse> {
        return this.httpPost<BulkAddProductScheduleResponse>(["products", "bulk-add-schedule"], request);
    }

    public getPickupTimes(request: GetProductPickupTimesRequest): Promise<GetProductPickupTimesResponse> {
        return this.httpGet<GetProductPickupTimesResponse>(["products", request.productId, "pickup-times"]);
    }

    public getPickupTime(request: GetProductPickupTimeRequest): Promise<GetProductPickupTimeResponse> {
        return this.httpGet<GetProductPickupTimeResponse>(["products", request.productId, "pickup-time", request.meetingPointId]);
    }

    public duplicate(request: DuplicateProductRequest): Promise<DuplicateProductResponse> {
        return this.httpPost<DuplicateProductResponse>(["products", request.id, "duplicate"], request);
    }

    public cleanUp(request: CleanUpProductRequest): Promise<CleanUpProductResponse> {
        return this.httpPost<CleanUpProductResponse>(["products", request.id, "clean-up"], request);
    }

}

class WebsitesService extends BaseService {

    public static readonly instance = new WebsitesService();

    public async getAll(): Promise<GetAllWebsitesResponse> {
        return await this.httpGet<GetAllWebsitesResponse>(["websites"]);
    }

    public async get(request: GetWebsiteRequest): Promise<GetWebsiteResponse> {
        return await this.httpGet<GetWebsiteResponse>(["websites", request.id]);
    }

    public async delete(request: DeleteWebsiteRequest): Promise<DeleteWebsiteResponse> {
        return await this.httpDelete<DeleteWebsiteResponse>(["websites", request.id]);
    }

    public async rename(request: RenameWebsiteRequest): Promise<RenameWebsiteResponse> {
        return await this.httpPost<RenameWebsiteResponse>(["websites", request.id, "rename"], request);
    }

    public async edit(request: EditWebsiteRequest): Promise<EditWebsiteResponse> {
        return await this.httpPost<EditWebsiteResponse>(["websites", request.id, "edit"], request);
    }

    public async add(request: AddWebsiteRequest): Promise<AddWebsiteResponse> {
        return await this.httpPost<AddWebsiteResponse>(["websites"], request);
    }

    public async bulkDelete(request: BulkDeleteWebsitesRequest): Promise<BulkDeleteWebsitesResponse> {
        return await this.httpPost<BulkDeleteWebsitesResponse>(["websites", "bulk-delete"], request);
    }

    public async getHomeContent(request: GetWebsiteHomeContentRequest): Promise<GetWebsiteHomeContentResponse> {
        return await this.httpGet<GetWebsiteHomeContentResponse>(["websites", request.id, "content"]);
    }

    public async editHomeContent(request: EditWebsiteHomeContentRequest): Promise<EditWebsiteHomeContentResponse> {
        return await this.httpPost<EditWebsiteHomeContentResponse>(["websites", request.id, "content"], request);
    }

    public async addFilter(request: AddWebsiteFilterRequest): Promise<AddWebsiteFilterResponse> {
        return await this.httpPost<AddWebsiteFilterResponse>(["websites", request.id, "add-filter"], request);
    }

    public async editFilter(request: EditWebsiteFilterRequest): Promise<EditWebsiteFilterResponse> {
        return await this.httpPost<EditWebsiteFilterResponse>(["websites", request.id, "edit-filter"], request);
    }

    public async removeFilter(request: RemoveWebsiteFilterRequest): Promise<RemoveWebsiteFilterResponse> {
        return await this.httpPost<RemoveWebsiteFilterResponse>(["websites", request.id, "remove-filter"], request);
    }

    public async moveFilterUp(request: MoveWebsiteFilterUpRequest): Promise<MoveWebsiteFilterUpResponse> {
        return await this.httpPost<MoveWebsiteFilterUpResponse>(["websites", request.id, "move-filter-up"], request);
    }

    public async moveFilterDown(request: MoveWebsiteFilterDownRequest): Promise<MoveWebsiteFilterDownResponse> {
        return await this.httpPost<MoveWebsiteFilterDownResponse>(["websites", request.id, "move-filter-down"], request);
    }

    public async enableFilter(request: EnableWebsiteFilterRequest): Promise<EnableWebsiteFilterResponse> {
        return await this.httpPost<EnableWebsiteFilterResponse>(["websites", request.id, "enable-filter"], request);
    }

    public async disableFilter(request: DisableWebsiteFilterRequest): Promise<DisableWebsiteFilterResponse> {
        return await this.httpPost<DisableWebsiteFilterResponse>(["websites", request.id, "disable-filter"], request);
    }

}

class ServicesService extends BaseService {

    public static readonly instance = new ServicesService();

    public async getAll(): Promise<GetAllServicesResponse> {
        return await this.httpGet<GetAllServicesResponse>(["services"]);
    }

    public async get(request: GetServiceRequest): Promise<GetServiceResponse> {
        return await this.httpGet<GetServiceResponse>(["services", request.id]);
    }

    public async delete(request: DeleteServiceRequest): Promise<DeleteServiceResponse> {
        return await this.httpDelete<DeleteServiceResponse>(["services", request.id]);
    }

    public async rename(request: RenameServiceRequest): Promise<RenameServiceResponse> {
        return await this.httpPost<RenameServiceResponse>(["services", request.id, "rename"], request);
    }

    public async edit(request: EditServiceRequest): Promise<EditServiceResponse> {
        return await this.httpPost<EditServiceResponse>(["services", request.id, "edit"], request);
    }

    public async add(request: AddServiceRequest): Promise<AddServiceResponse> {
        return await this.httpPost<AddServiceResponse>(["services"], request);
    }

    public async setDuration(request: SetServiceDurationRequest): Promise<SetServiceDurationResponse> {
        return await this.httpPost<SetServiceDurationResponse>(["services", request.id, "duration"], request);
    }

    public async bulkDelete(request: BulkDeleteServicesRequest): Promise<BulkDeleteServicesResponse> {
        return await this.httpPost<BulkDeleteServicesResponse>(["services", "bulk-delete"], request);
    }

    public async bulkSetType(request: BulkSetServiceTypeRequest): Promise<BulkSetServiceTypeResponse> {
        return await this.httpPost<BulkSetServiceTypeResponse>(["services", "bulk-set-type"], request);
    }

    public async bulkSetListType(request: BulkSetServiceListTypeRequest): Promise<BulkSetServiceListTypeResponse> {
        return await this.httpPost<BulkSetServiceListTypeResponse>(["services", "bulk-set-list-type"], request);
    }

    public async bulkSetGuideRate(request: BulkSetServiceGuideRateRequest): Promise<BulkSetServiceGuideRateResponse> {
        return await this.httpPost<BulkSetServiceGuideRateResponse>(["services", "bulk-set-guide-rate"], request);
    }

    public async bulkSetDuration(request: BulkSetServiceDurationRequest): Promise<BulkSetServiceDurationResponse> {
        return await this.httpPost<BulkSetServiceDurationResponse>(["services", "bulk-set-duration"], request);
    }

}

class PurchaseRatesService extends BaseService {

    public static readonly instance = new PurchaseRatesService();

    public async getAll(): Promise<GetAllPurchaseRatesResponse> {
        return await this.httpGet<GetAllPurchaseRatesResponse>(["purchase-rates"]);
    }

    public async getAllByParent(parentId: string): Promise<GetAllPurchaseRatesResponse> {
        return await this.httpGet<GetAllPurchaseRatesResponse>(["purchase-rates", "by-parent", parentId]);
    }

    public async get(request: GetPurchaseRateRequest): Promise<GetPurchaseRateResponse> {
        return await this.httpGet<GetPurchaseRateResponse>(["purchase-rates", request.id]);
    }

    public async delete(request: DeletePurchaseRateRequest): Promise<DeletePurchaseRateResponse> {
        return await this.httpDelete<DeletePurchaseRateResponse>(["purchase-rates", request.id]);
    }

    public async rename(request: RenamePurchaseRateRequest): Promise<RenamePurchaseRateResponse> {
        return await this.httpPost<RenamePurchaseRateResponse>(["purchase-rates", request.id, "rename"], request);
    }

    public async edit(request: EditPurchaseRateRequest): Promise<EditPurchaseRateResponse> {
        return await this.httpPost<EditPurchaseRateResponse>(["purchase-rates", request.id, "edit"], request);
    }

    public async add(request: AddPurchaseRateRequest): Promise<AddPurchaseRateResponse> {
        return await this.httpPost<AddPurchaseRateResponse>(["purchase-rates"], request);
    }

    public async bulkDelete(request: BulkDeletePurchaseRatesRequest): Promise<BulkDeletePurchaseRatesResponse> {
        return await this.httpPost<BulkDeletePurchaseRatesResponse>(["purchase-rates", "bulk-delete"], request);
    }

    public async addSchedule(request: AddPurchaseRateScheduleRequest): Promise<AddPurchaseRateScheduleResponse> {
        return await this.httpPost<AddPurchaseRateScheduleResponse>(["purchase-rates", request.id, "add-schedule"], request);
    }

    public async editSchedule(request: EditPurchaseRateScheduleRequest): Promise<EditPurchaseRateScheduleResponse> {
        return await this.httpPost<EditPurchaseRateScheduleResponse>(["purchase-rates", request.id, "edit-schedule"], request);
    }

    public async removeSchedule(request: RemovePurchaseRateScheduleRequest): Promise<RemovePurchaseRateScheduleResponse> {
        return await this.httpPost<RemovePurchaseRateScheduleResponse>(["purchase-rates", request.id, "remove-schedule"], request);
    }

    public async lookup(request: LookupPurchaseRatesRequest): Promise<LookupPurchaseRatesResponse> {
        return await this.httpGet<LookupPurchaseRatesResponse>(["purchase-rates", "lookup"]);
    }

}

class GuidesService extends BaseService {

    public static readonly instance = new GuidesService();

    public async getAll(): Promise<GetAllGuidesResponse> {
        return await this.httpGet<GetAllGuidesResponse>(["guides"]);
    }

    public async get(request: GetGuideRequest): Promise<GetGuideResponse> {
        return await this.httpGet<GetGuideResponse>(["guides", request.id]);
    }

    public async delete(request: DeleteGuideRequest): Promise<DeleteGuideResponse> {
        return await this.httpDelete<DeleteGuideResponse>(["guides", request.id]);
    }

    public async rename(request: RenameGuideRequest): Promise<RenameGuideResponse> {
        return await this.httpPost<RenameGuideResponse>(["guides", request.id, "rename"], request);
    }

    public async edit(request: EditGuideRequest): Promise<EditGuideResponse> {
        return await this.httpPost<EditGuideResponse>(["guides", request.id, "edit"], request);
    }

    public async add(request: AddGuideRequest): Promise<AddGuideResponse> {
        return await this.httpPost<AddGuideResponse>(["guides"], request);
    }

    public async bulkDelete(request: BulkDeleteGuidesRequest): Promise<BulkDeleteGuidesResponse> {
        return await this.httpPost<BulkDeleteGuidesResponse>(["guides", "bulk-delete"], request);
    }

    public async getQRBrochure(request: GenerateGuideQRBrochureRequest): Promise<void> {
        await this.httpPostAsBlob(["guides", request.id, "generate-brochure"], request, true);
    }

    public async link(request: LinkGuideRequest): Promise<LinkGuideResponse> {
        return this.httpPost(["guides", request.id, "link"], request);
    }

}

class ActivitySheetsService extends BaseService {

    public static readonly instance = new ActivitySheetsService();

    public async getAll(): Promise<GetAllActivitySheetsResponse> {
        return await this.httpGet<GetAllActivitySheetsResponse>(["activity-sheets"]);
    }

    public async get(request: GetActivitySheetRequest): Promise<GetActivitySheetResponse> {
        return await this.httpGet<GetActivitySheetResponse>(["activity-sheets", request.id]);
    }

    public async delete(request: DeleteActivitySheetRequest): Promise<DeleteActivitySheetResponse> {
        return await this.httpDelete<DeleteActivitySheetResponse>(["activity-sheets", request.id]);
    }

    public async rename(request: RenameActivitySheetRequest): Promise<RenameActivitySheetResponse> {
        return await this.httpPost<RenameActivitySheetResponse>(["activity-sheets", request.id, "rename"], request);
    }

    public async edit(request: EditActivitySheetRequest): Promise<EditActivitySheetResponse> {
        return await this.httpPost<EditActivitySheetResponse>(["activity-sheets", request.id, "edit"], request);
    }

    public async add(request: AddActivitySheetRequest): Promise<AddActivitySheetResponse> {
        return await this.httpPost<AddActivitySheetResponse>(["activity-sheets"], request);
    }

    public async bulkDelete(request: BulkDeleteActivitySheetsRequest): Promise<BulkDeleteActivitySheetsResponse> {
        return await this.httpPost<BulkDeleteActivitySheetsResponse>(["activity-sheets", "bulk-delete"], request);
    }

}

class BookingsService extends BaseService {

    public static readonly instance = new BookingsService();

    public async getAll(): Promise<GetAllBookingsResponse> {
        return await this.httpGet<GetAllBookingsResponse>(["bookings"]);
    }

    public async get(request: GetBookingRequest): Promise<GetBookingResponse> {
        return await this.httpGet<GetBookingResponse>(["bookings", request.id]);
    }

    public async delete(request: DeleteBookingRequest): Promise<DeleteBookingResponse> {
        return await this.httpDelete<DeleteBookingResponse>(["bookings", request.id]);
    }

    public async edit(request: EditBookingRequest): Promise<EditBookingResponse> {
        return await this.httpPost<EditBookingResponse>(["bookings", request.id, "edit"], request);
    }

    public async editAffiliate(request: EditBookingAffiliateRequest): Promise<EditBookingAffiliateResponse> {
        return await this.httpPost<EditBookingAffiliateResponse>(["bookings", request.id, "affiliate"], request);
    }

    public async editOccupancy(request: EditBookingOccupancyRequest): Promise<EditBookingOccupancyResponse> {
        return await this.httpPost<EditBookingOccupancyResponse>(["bookings", request.id, "occupancy"], request);
    }

    public async split(request: SplitBookingRequest): Promise<SplitBookingResponse> {
        return await this.httpPost<SplitBookingResponse>(["bookings", request.id, "split"], request);
    }

    public editLanguage(request: EditBookingLanguageRequest): Promise<EditBookingLanguageResponse> {
        return this.httpPost<EditBookingLanguageResponse>(["bookings", request.id, "language"], request);
    }

    public async add(request: AddBookingRequest): Promise<AddBookingResponse> {
        return await this.httpPost<AddBookingResponse>(["bookings"], request);
    }

    public async bulkDelete(request: BulkDeleteBookingsRequest): Promise<BulkDeleteBookingsResponse> {
        return await this.httpPost<BulkDeleteBookingsResponse>(["bookings", "bulk-delete"], request);
    }

    public async cancel(request: CancelBookingRequest): Promise<CancelBookingResponse> {
        return await this.httpPost<CancelBookingResponse>(["bookings", request.id, "cancel"], request);
    }

    public async noShow(request: NoShowBookingRequest): Promise<NoShowBookingResponse> {
        return await this.httpPost<NoShowBookingResponse>(["bookings", request.id, "no-show"], request);
    }

    public async show(request: ShowBookingRequest): Promise<ShowBookingResponse> {
        return await this.httpPost<ShowBookingResponse>(["bookings", request.id, "show"], request);
    }

    public async search(request: SearchBookingsRequest): Promise<SearchBookingsResponse> {
        return await this.httpPost<SearchBookingsResponse>(["bookings", "search"], request);
    }

    public async notifyConfirmation(request: NotifyBookingConfirmationRequest): Promise<NotifyBookingConfirmationResponse> {
        return await this.httpPost<NotifyBookingConfirmationResponse>(["bookings", request.id, "notify-confirmation"], request);
    }

    public async sendVoucher(request: SendBookingVoucherRequest): Promise<SendBookingVoucherResponse> {
        return await this.httpPost<SendBookingVoucherResponse>(["bookings", request.id, "voucher", "send"], request);
    }

    public async confirm(request: ConfirmBookingRequest): Promise<ConfirmBookingResponse> {
        return await this.httpPost<ConfirmBookingResponse>(["bookings", request.id, "confirm"], request);
    }

    public async uncancel(request: UncancelBookingRequest): Promise<UncancelBookingResponse> {
        return await this.httpPost<UncancelBookingResponse>(["bookings", request.id, "uncancel"], request);
    }

    public async editSettlement(request: EditBookingSettlementRequest): Promise<EditBookingSettlementResponse> {
        return await this.httpPost<EditBookingSettlementResponse>(["bookings", request.id, "edit-settlement"], request);
    }

    public async editInvoicingSlot(request: EditBookingInvoicingSlotRequest): Promise<EditBookingInvoicingSlotResponse> {
        return await this.httpPost<EditBookingInvoicingSlotResponse>(["bookings", request.id, "invoicing-slot"], request);
    }

    public async editOperatorSettlement(request: EditBookingOperatorSettlementRequest): Promise<EditBookingOperatorSettlementResponse> {
        return await this.httpPost<EditBookingOperatorSettlementResponse>(["bookings", request.id, "edit-operator-settlement"], request);
    }

    public async check(request: CheckBookingRequest): Promise<CheckBookingResponse> {
        return await this.httpPost<CheckBookingResponse>(["bookings", request.id, "check"], request);
    }

    public async uncheck(request: UncheckBookingRequest): Promise<UncheckBookingResponse> {
        return await this.httpPost<UncheckBookingResponse>(["bookings", request.id, "uncheck"], request);
    }

    public async notifyEvent(request: NotifyBookingEventRequest): Promise<NotifyBookingEventResponse> {
        return await this.httpPost<NotifyBookingEventResponse>(["bookings", "notify-event"], request);
    }

    public async getPickupInformation(request: GetBookingPickupInformationRequest): Promise<GetBookingPickupInformationResponse> {
        return await this.httpGet<GetBookingPickupInformationResponse>(["bookings", request.id, "pickup-information"]);
    }

    public async addGroupPayment(request: AddBookingGroupPaymentRequest): Promise<AddBookingGroupPaymentResponse> {
        return await this.httpPost<AddBookingGroupPaymentResponse>(["bookings", request.id, "add-group-payment"], request);
    }

    public getProFormaDownloadLink(id: string, includePayments = true): string {
        const url = this.buildTargetUrl(["bookings", id, "proforma"]);
        return url + "?output=pdf&includePayments=" + includePayments;
    }

    public addImage(request: AddImageToBookingRequest): Promise<AddImageToBookingResponse> {
        return this.httpPost<AddImageToBookingResponse>(["bookings", request.id, "add-image"], request);
    }

    public removeImage(request: RemoveImageFromBookingRequest): Promise<RemoveImageFromBookingResponse> {
        return this.httpPost<RemoveImageFromBookingResponse>(["bookings", request.id, "remove-image"], request);
    }

    public addDocument(request: AddDocumentToBookingRequest): Promise<AddDocumentToBookingResponse> {
        return this.httpPost<AddDocumentToBookingResponse>(["bookings", request.id, "add-document"], request);
    }

    public removeDocument(request: RemoveDocumentFromBookingRequest): Promise<RemoveDocumentFromBookingResponse> {
        return this.httpPost<RemoveDocumentFromBookingResponse>(["bookings", request.id, "remove-document"], request);
    }

    public sendProforma(request: SendBookingProformaRequest): Promise<SendBookingProformaResponse> {
        return this.httpPost<SendBookingProformaResponse>(["bookings", request.id, "send-proforma"], request);
    }

    public refresh(request: RefreshBookingRequest): Promise<RefreshBookingResponse> {
        return this.httpPost<RefreshBookingResponse>(["bookings", request.id, "refresh"], request);
    }

    public async evaluateInvoicingSlots(request: EvaluateBookingInvoicingSlotsRequest): Promise<EvaluateBookingInvoicingSlotsResponse> {
        return await this.httpPost<EvaluateBookingInvoicingSlotsResponse>(["bookings", request.id, "evaluate-invoicing-slots"], request);
    }

    public async deleteInvoicingSlot(request: DeleteBookingInvoicingSlotRequest): Promise<DeleteBookingInvoicingSlotResponse> {
        return await this.httpPost<DeleteBookingInvoicingSlotResponse>(["bookings", request.id, "delete-invoicing-slot"], request);
    }

    public async editOrganizationAndAgency(request: EditBookingOrganizationAndAgencyRequest): Promise<EditBookingOrganizationAndAgencyResponse> {
        return await this.httpPost<EditBookingOrganizationAndAgencyResponse>(["bookings", request.id, "organization-agency"], request);
    }

    public async checkRequirements(request: CheckBookingRequirementsRequest): Promise<CheckBookingRequirementsResponse> {
        return await this.httpPost<CheckBookingRequirementsResponse>(["bookings", "check-requirements"], request);
    }

}

class OperatorsService extends BaseService {

    public static readonly instance = new OperatorsService();

    public async getAll(): Promise<GetAllOperatorsResponse> {
        return await this.httpGet<GetAllOperatorsResponse>(["operators"]);
    }

    public async get(request: GetOperatorRequest): Promise<GetOperatorResponse> {
        return await this.httpGet<GetOperatorResponse>(["operators", request.id]);
    }

    public async delete(request: DeleteOperatorRequest): Promise<DeleteOperatorResponse> {
        return await this.httpDelete<DeleteOperatorResponse>(["operators", request.id]);
    }

    public async rename(request: RenameOperatorRequest): Promise<RenameOperatorResponse> {
        return await this.httpPost<RenameOperatorResponse>(["operators", request.id, "rename"], request);
    }

    public async edit(request: EditOperatorRequest): Promise<EditOperatorResponse> {
        return await this.httpPost<EditOperatorResponse>(["operators", request.id, "edit"], request);
    }

    public async add(request: AddOperatorRequest): Promise<AddOperatorResponse> {
        return await this.httpPost<AddOperatorResponse>(["operators"], request);
    }

    public async bulkDelete(request: BulkDeleteOperatorsRequest): Promise<BulkDeleteOperatorsResponse> {
        return await this.httpPost<BulkDeleteOperatorsResponse>(["operators", "bulk-delete"], request);
    }

    public async addPricing(request: AddOperatorPricingRequest): Promise<AddOperatorPricingResponse> {
        return await this.httpPost<AddOperatorPricingResponse>(["operators", request.id, "add-pricing"], request);
    }

    public async editPricing(request: EditOperatorPricingRequest): Promise<EditOperatorPricingResponse> {
        return await this.httpPost<EditOperatorPricingResponse>(["operators", request.id, "edit-pricing"], request);
    }

    public async removePricing(request: RemoveOperatorPricingRequest): Promise<RemoveOperatorPricingResponse> {
        return await this.httpPost<RemoveOperatorPricingResponse>(["operators", request.id, "remove-pricing"], request);
    }

}

class AreasService extends BaseService {

    public static readonly instance = new AreasService();

    public async getAll(): Promise<GetAllAreasResponse> {
        return await this.httpGet<GetAllAreasResponse>(["areas"]);
    }

}

class RoutesService extends BaseService {

    public static readonly instance = new RoutesService();

    public async getAll(): Promise<GetAllRoutesResponse> {
        return await this.httpGet<GetAllRoutesResponse>(["routes"]);
    }

    public async get(request: GetRouteRequest): Promise<GetRouteResponse> {
        return await this.httpGet<GetRouteResponse>(["routes", request.id]);
    }

    public async delete(request: DeleteRouteRequest): Promise<DeleteRouteResponse> {
        return await this.httpDelete<DeleteRouteResponse>(["routes", request.id]);
    }

    public async rename(request: RenameRouteRequest): Promise<RenameRouteResponse> {
        return await this.httpPost<RenameRouteResponse>(["routes", request.id, "rename"], request);
    }

    public async edit(request: EditRouteRequest): Promise<EditRouteResponse> {
        return await this.httpPost<EditRouteResponse>(["routes", request.id, "edit"], request);
    }

    public async add(request: AddRouteRequest): Promise<AddRouteResponse> {
        return await this.httpPost<AddRouteResponse>(["routes"], request);
    }

    public async bulkDelete(request: BulkDeleteRoutesRequest): Promise<BulkDeleteRoutesResponse> {
        return await this.httpPost<BulkDeleteRoutesResponse>(["routes", "bulk-delete"], request);
    }

    public async duplicate(request: DuplicateRouteRequest): Promise<DuplicateRouteResponse> {
        return await this.httpPost<DuplicateRouteResponse>(["routes", request.id, "duplicate"], request);
    }

    public async changeZone(request: ChangeRouteZoneRequest): Promise<ChangeRouteZoneResponse> {
        return await this.httpPost<ChangeRouteZoneResponse>(["routes", request.id, "change-zone"], request);
    }

}

class ActivityCategoriesService extends BaseService {

    public static readonly instance = new ActivityCategoriesService();

    public async getAll(): Promise<GetAllActivityCategoriesResponse> {
        return await this.httpGet<GetAllActivityCategoriesResponse>(["activitycategories"]);
    }

    public async get(request: GetActivityCategoryRequest): Promise<GetActivityCategoryResponse> {
        return await this.httpGet<GetActivityCategoryResponse>(["activitycategories", request.id]);
    }

    public async delete(request: DeleteActivityCategoryRequest): Promise<DeleteActivityCategoryResponse> {
        return await this.httpDelete<DeleteActivityCategoryResponse>(["activitycategories", request.id]);
    }

    public async rename(request: RenameActivityCategoryRequest): Promise<RenameActivityCategoryResponse> {
        return await this.httpPost<RenameActivityCategoryResponse>(["activitycategories", request.id, "rename"], request);
    }

    public async edit(request: EditActivityCategoryRequest): Promise<EditActivityCategoryResponse> {
        return await this.httpPost<EditActivityCategoryResponse>(["activitycategories", request.id, "edit"], request);
    }

    public async add(request: AddActivityCategoryRequest): Promise<AddActivityCategoryResponse> {
        return await this.httpPost<AddActivityCategoryResponse>(["activitycategories"], request);
    }

    public async bulkDelete(request: BulkDeleteActivityCategoriesRequest): Promise<BulkDeleteActivityCategoriesResponse> {
        return await this.httpPost<BulkDeleteActivityCategoriesResponse>(["activitycategories", "bulk-delete"], request);
    }

}

class WorkOrdersService extends BaseService {

    public static readonly instance = new WorkOrdersService();

    public async getAll(): Promise<GetAllWorkOrdersResponse> {
        return await this.httpGet<GetAllWorkOrdersResponse>(["workorders"]);
    }

    public async get(request: GetWorkOrderRequest): Promise<GetWorkOrderResponse> {
        return await this.httpGet<GetWorkOrderResponse>(["workorders", request.id]);
    }

    public async getDetails(request: GetWorkOrderDetailsRequest): Promise<GetWorkOrderDetailsResponse> {
        return await this.httpGet<GetWorkOrderDetailsResponse>(["workorders", request.id, "details"]);
    }

    public async delete(request: DeleteWorkOrderRequest): Promise<DeleteWorkOrderResponse> {
        return await this.httpDelete<DeleteWorkOrderResponse>(["workorders", request.id]);
    }

    public async rename(request: RenameWorkOrderRequest): Promise<RenameWorkOrderResponse> {
        return await this.httpPost<RenameWorkOrderResponse>(["workorders", request.id, "rename"], request);
    }

    public async edit(request: EditWorkOrderRequest): Promise<EditWorkOrderResponse> {
        return await this.httpPost<EditWorkOrderResponse>(["workorders", request.id, "edit"], request);
    }

    public async add(request: AddWorkOrderRequest): Promise<AddWorkOrderResponse> {
        return await this.httpPost<AddWorkOrderResponse>(["workorders"], request);
    }

    public async bulkDelete(request: BulkDeleteWorkOrdersRequest): Promise<BulkDeleteWorkOrdersResponse> {
        return await this.httpPost<BulkDeleteWorkOrdersResponse>(["workorders", "bulk-delete"], request);
    }

    public async setOperator(request: SetWorkOrderOperatorRequest): Promise<SetWorkOrderOperatorResponse> {
        return await this.httpPost<SetWorkOrderOperatorResponse>(["workorders", request.id, "set-operator"], request);
    }

    public async editSettlement(request: EditWorkOrderSettlementRequest): Promise<EditWorkOrderSettlementResponse> {
        return await this.httpPost<EditWorkOrderSettlementResponse>(["workorders", request.id, "edit-settlement"], request);
    }

    public async search(request: SearchWorkOrdersRequest): Promise<SearchWorkOrdersResponse> {
        return await this.httpPost<SearchWorkOrdersResponse>(["work-orders", "search"], request);
    }

    public async close(request: CloseWorkOrderRequest): Promise<CloseWorkOrderResponse> {
        return await this.httpPost<CloseWorkOrderResponse>(["work-orders", request.id, "close"], request);
    }

    public async sendToCarrier(request: SendWorkOrderToCarrierRequest): Promise<SendWorkOrderToCarrierResponse> {
        // WARNING: This endpoint is not intended to be used by the client, just for testing purposes
        return await this.httpPost<SendWorkOrderToCarrierResponse>(["work-orders", request.id || "", "send-to-carrier"], request);
    }

    public async receiveFromCarrier(request: ReceiveWorkOrderFromCarrierRequest): Promise<ReceiveWorkOrderFromCarrierResponse> {
        return await this.httpPost<ReceiveWorkOrderFromCarrierResponse>(["work-orders", typeof request.id === "string" ? request.id : request.id[0], "receive-from-carrier"], request);
    }

}

class MailAccountsService extends BaseService {

    public static readonly instance = new MailAccountsService();

    public async getAll(): Promise<GetAllMailAccountsResponse> {
        return await this.httpGet<GetAllMailAccountsResponse>(["mail-accounts"]);
    }

    public async get(request: GetMailAccountRequest): Promise<GetMailAccountResponse> {
        return await this.httpGet<GetMailAccountResponse>(["mail-accounts", request.id]);
    }

    public async delete(request: DeleteMailAccountRequest): Promise<DeleteMailAccountResponse> {
        return await this.httpDelete<DeleteMailAccountResponse>(["mail-accounts", request.id]);
    }

    public async rename(request: RenameMailAccountRequest): Promise<RenameMailAccountResponse> {
        return await this.httpPost<RenameMailAccountResponse>(["mail-accounts", request.id, "rename"], request);
    }

    public async edit(request: EditMailAccountRequest): Promise<EditMailAccountResponse> {
        return await this.httpPost<EditMailAccountResponse>(["mail-accounts", request.id, "edit"], request);
    }

    public async add(request: AddMailAccountRequest): Promise<AddMailAccountResponse> {
        return await this.httpPost<AddMailAccountResponse>(["mail-accounts"], request);
    }

    public async toggleTag(request: ToggleMailAccountTagRequest): Promise<ToggleMailAccountTagResponse> {
        return await this.httpPost<ToggleMailAccountTagResponse>(["mail-accounts", request.id, "toggle-tag"], request);
    }

    public async bulkDelete(request: BulkDeleteMailAccountsRequest): Promise<BulkDeleteMailAccountsResponse> {
        return await this.httpPost<BulkDeleteMailAccountsResponse>(["mail-accounts", "bulk-delete"], request);
    }

    public async beginConnection(request: BeginMailAccountConnectionRequest): Promise<BeginMailAccountConnectionResponse> {
        return await this.httpPost<BeginMailAccountConnectionResponse>(["mail-accounts", request.id, "begin-connection"], request);
    }

    public async endConnection(request: EndMailAccountConnectionRequest): Promise<EndMailAccountConnectionResponse> {
        return await this.httpPost<EndMailAccountConnectionResponse>(["mail-accounts", request.id, "end-connection"], request);
    }

    public async enable(request: EnableMailAccountRequest): Promise<EnableMailAccountResponse> {
        return await this.httpPost<EnableMailAccountResponse>(["mail-accounts", request.id, "enable"], request);
    }

    public async disable(request: DisableMailAccountRequest): Promise<DisableMailAccountResponse> {
        return await this.httpPost<DisableMailAccountResponse>(["mail-accounts", request.id, "disable"], request);
    }

    public async test(request: TestMailAccountRequest): Promise<TestMailAccountResponse> {
        return await this.httpPost<TestMailAccountResponse>(["mail-accounts", request.id, "test"], request);
    }

    public async signalError(request: SignalMailAccountErrorRequest): Promise<SignalMailAccountErrorResponse> {
        return await this.httpPost<SignalMailAccountErrorResponse>(["mail-accounts", request.id, "signal-error"], request);
    }

}

class LocalMessagesService extends BaseService {

    public static readonly instance = new LocalMessagesService();

    public async getAll(): Promise<GetAllLocalMessagesResponse> {
        return await this.httpGet<GetAllLocalMessagesResponse>(["local-messages"]);
    }

    public async get(request: GetLocalMessageRequest): Promise<GetLocalMessageResponse> {
        return await this.httpGet<GetLocalMessageResponse>(["local-messages", request.id]);
    }

    public async delete(request: DeleteLocalMessageRequest): Promise<DeleteLocalMessageResponse> {
        return await this.httpDelete<DeleteLocalMessageResponse>(["local-messages", request.id]);
    }

    public async rename(request: RenameLocalMessageRequest): Promise<RenameLocalMessageResponse> {
        return await this.httpPost<RenameLocalMessageResponse>(["local-messages", request.id, "rename"], request);
    }

    public async edit(request: EditLocalMessageRequest): Promise<EditLocalMessageResponse> {
        return await this.httpPost<EditLocalMessageResponse>(["local-messages", request.id, "edit"], request);
    }

    public async add(request: AddLocalMessageRequest): Promise<AddLocalMessageResponse> {
        return await this.httpPost<AddLocalMessageResponse>(["local-messages"], request);
    }

    public async bulkDelete(request: BulkDeleteLocalMessagesRequest): Promise<BulkDeleteLocalMessagesResponse> {
        return await this.httpPost<BulkDeleteLocalMessagesResponse>(["local-messages", "bulk-delete"], request);
    }

    public async integrate(request: IntegrateLocalMessageRequest): Promise<IntegrateLocalMessageResponse> {
        return await this.httpPost<IntegrateLocalMessageResponse>(["local-messages", request.id, "integrate"], request);
    }

    public async moveToFolder(request: MoveLocalMessageToFolderRequest): Promise<MoveLocalMessageToFolderResponse> {
        return await this.httpPost<MoveLocalMessageToFolderResponse>(["local-messages", request.id, "move-to-folder"], request);
    }


}

class IntegrationsService extends BaseService {

    public static readonly instance = new IntegrationsService();

    public async getAll(): Promise<GetAllIntegrationsResponse> {
        return await this.httpGet<GetAllIntegrationsResponse>(["integrations"]);
    }

    public async get(request: GetIntegrationRequest): Promise<GetIntegrationResponse> {
        return await this.httpGet<GetIntegrationResponse>(["integrations", request.id]);
    }

    public async delete(request: DeleteIntegrationRequest): Promise<DeleteIntegrationResponse> {
        return await this.httpDelete<DeleteIntegrationResponse>(["integrations", request.id]);
    }

    public async rename(request: RenameIntegrationRequest): Promise<RenameIntegrationResponse> {
        return await this.httpPost<RenameIntegrationResponse>(["integrations", request.id, "rename"], request);
    }

    public async edit(request: EditIntegrationRequest): Promise<EditIntegrationResponse> {
        return await this.httpPost<EditIntegrationResponse>(["integrations", request.id, "edit"], request);
    }

    public async add(request: AddIntegrationRequest): Promise<AddIntegrationResponse> {
        return await this.httpPost<AddIntegrationResponse>(["integrations"], request);
    }

    public async bulkDelete(request: BulkDeleteIntegrationsRequest): Promise<BulkDeleteIntegrationsResponse> {
        return await this.httpPost<BulkDeleteIntegrationsResponse>(["integrations", "bulk-delete"], request);
    }

    public async enable(request: EnableIntegrationRequest): Promise<EnableIntegrationResponse> {
        return await this.httpPost<EnableIntegrationResponse>(["integrations", request.id, "enable"], request);
    }

    public async disable(request: DisableIntegrationRequest): Promise<DisableIntegrationResponse> {
        return await this.httpPost<DisableIntegrationResponse>(["integrations", request.id, "disable"], request);
    }

    public async forcePull(request: ForceIntegrationPullRequest): Promise<ForceIntegrationPullResponse> {
        return await this.httpPost<ForceIntegrationPullResponse>(["integrations", request.id, "force-pull"], request);
    }

    public async deleteProductMapping(request: DeleteIntegrationProductMappingRequest): Promise<DeleteIntegrationProductMappingResponse> {
        return await this.httpPost<DeleteIntegrationProductMappingResponse>(["integrations", request.id, "delete-product-mapping"], request);
    }

    public async editProductMapping(request: EditIntegrationProductMappingRequest): Promise<EditIntegrationProductMappingResponse> {
        return await this.httpPost<EditIntegrationProductMappingResponse>(["integrations", request.id, "edit-product-mapping"], request);
    }

    public async deleteMeetingPointMapping(request: DeleteIntegrationMeetingPointMappingRequest): Promise<DeleteIntegrationMeetingPointMappingResponse> {
        return await this.httpPost<DeleteIntegrationMeetingPointMappingResponse>(["integrations", request.id, "delete-meeting-point-mapping"], request);
    }

    public async editHotelMapping(request: EditIntegrationHotelMappingRequest): Promise<EditIntegrationHotelMappingResponse> {
        return await this.httpPost<EditIntegrationHotelMappingResponse>(["integrations", request.id, "edit-hotel-mapping"], request);
    }

    public async deleteHotelMapping(request: DeleteIntegrationHotelMappingRequest): Promise<DeleteIntegrationHotelMappingResponse> {
        return await this.httpPost<DeleteIntegrationHotelMappingResponse>(["integrations", request.id, "delete-hotel-mapping"], request);
    }

}

class IntegrationProcessorsService extends BaseService {

    public static readonly instance = new IntegrationProcessorsService();

    public async getAll(): Promise<GetAllIntegrationProcessorsResponse> {
        return await this.httpGet<GetAllIntegrationProcessorsResponse>(["integration-processors"]);
    }

}

class PrebookingsService extends BaseService {

    public static readonly instance = new PrebookingsService();

    public async getAll(): Promise<GetAllPrebookingsResponse> {
        return await this.httpGet<GetAllPrebookingsResponse>(["prebookings"]);
    }

    public async get(request: GetPrebookingRequest): Promise<GetPrebookingResponse> {
        return await this.httpGet<GetPrebookingResponse>(["prebookings", request.id]);
    }

    public async delete(request: DeletePrebookingRequest): Promise<DeletePrebookingResponse> {
        return await this.httpDelete<DeletePrebookingResponse>(["prebookings", request.id]);
    }

    public async archive(request: ArchivePrebookingRequest): Promise<ArchivePrebookingResponse> {
        return await this.httpPost<ArchivePrebookingResponse>(["prebookings", request.id, "archive"], request);
    }

    public async previewMapping(request: PreviewPrebookingMappingRequest): Promise<PreviewPrebookingMappingResponse> {
        return await this.httpPost<PreviewPrebookingMappingResponse>(["prebookings", request.id, "preview-mapping"], request);
    }

    public async resolve(request: ResolvePrebookingRequest): Promise<ResolvePrebookingResponse> {
        return await this.httpPost<ResolvePrebookingResponse>(["prebookings", request.id, "resolve"], request);
    }

    public async confirm(request: ConfirmPrebookingRequest): Promise<ConfirmPrebookingResponse> {
        return await this.httpPost<ConfirmPrebookingResponse>(["prebookings", request.id, "confirm"], request);
    }

    public async cancel(request: CancelPrebookingRequest): Promise<CancelPrebookingResponse> {
        return await this.httpPost<CancelPrebookingResponse>(["prebookings", request.id, "cancel"], request);
    }
}

class MessageTemplatesService extends BaseService {

    public static readonly instance = new MessageTemplatesService();

    public async getAll(): Promise<GetAllMessageTemplatesResponse> {
        return await this.httpGet<GetAllMessageTemplatesResponse>(["message-templates"]);
    }

    public async get(request: GetMessageTemplateRequest): Promise<GetMessageTemplateResponse> {
        return await this.httpGet<GetMessageTemplateResponse>(["message-templates", request.id]);
    }

    public async delete(request: DeleteMessageTemplateRequest): Promise<DeleteMessageTemplateResponse> {
        return await this.httpDelete<DeleteMessageTemplateResponse>(["message-templates", request.id]);
    }

    public async rename(request: RenameMessageTemplateRequest): Promise<RenameMessageTemplateResponse> {
        return await this.httpPost<RenameMessageTemplateResponse>(["message-templates", request.id, "rename"], request);
    }

    public async edit(request: EditMessageTemplateRequest): Promise<EditMessageTemplateResponse> {
        return await this.httpPost<EditMessageTemplateResponse>(["message-templates", request.id, "edit"], request);
    }

    public async add(request: AddMessageTemplateRequest): Promise<AddMessageTemplateResponse> {
        return await this.httpPost<AddMessageTemplateResponse>(["message-templates"], request);
    }

    public async bulkDelete(request: BulkDeleteMessageTemplatesRequest): Promise<BulkDeleteMessageTemplatesResponse> {
        return await this.httpPost<BulkDeleteMessageTemplatesResponse>(["message-templates", "bulk-delete"], request);
    }

    public async render(request: RenderMessageTemplateRequest): Promise<RenderMessageTemplateResponse> {
        return await this.httpPost<RenderMessageTemplateResponse>(["message-templates", request.id, "render"], request);
    }

}

class NotificationsService extends BaseService {

    public static readonly instance = new NotificationsService();

    public async getAll(): Promise<GetAllNotificationsResponse> {
        return await this.httpGet<GetAllNotificationsResponse>(["notifications"]);
    }

    public async get(request: GetNotificationRequest): Promise<GetNotificationResponse> {
        return await this.httpGet<GetNotificationResponse>(["notifications", request.id]);
    }

    public async delete(request: DeleteNotificationRequest): Promise<DeleteNotificationResponse> {
        return await this.httpDelete<DeleteNotificationResponse>(["notifications", request.id]);
    }

    public async add(request: AddNotificationRequest): Promise<AddNotificationResponse> {
        return await this.httpPost<AddNotificationResponse>(["notifications"], request);
    }

    public async bulkDelete(request: BulkDeleteNotificationsRequest): Promise<BulkDeleteNotificationsResponse> {
        return await this.httpPost<BulkDeleteNotificationsResponse>(["notifications", "bulk-delete"], request);
    }

    public async retry(request: RetryNotificationRequest): Promise<RetryNotificationResponse> {
        return await this.httpPost<RetryNotificationResponse>(["notifications", request.id, "retry"], request);
    }

    public async deleteOld(request: DeleteOldNotificationsRequest): Promise<DeleteOldNotificationsResponse> {
        return await this.httpPost<DeleteOldNotificationsResponse>(["notifications", "delete-old"], request);
    }

    public async search(request: SearchNotificationsRequest): Promise<SearchNotificationsResponse> {
        return await this.httpPost<SearchNotificationsResponse>(["notifications", "search"], request);
    }

}

class ScheduledServicesService extends BaseService {

    public static readonly instance = new ScheduledServicesService();

    public async add(request: AddScheduledServiceRequest): Promise<AddScheduledServiceResponse> {
        return await this.httpPost<AddScheduledServiceResponse>(["scheduled-services"], request);
    }

    public async delete(request: DeleteScheduledServiceRequest): Promise<DeleteScheduledServiceResponse> {
        return await this.httpDelete(["scheduled-services", request.id]);
    }

    public async get(request: GetScheduledServiceRequest): Promise<GetScheduledServiceResponse> {
        return await this.httpGet<GetScheduledServiceResponse>(["scheduled-services", request.id]);
    }

    public async getSiblings(request: GetScheduledServiceSiblingsRequest): Promise<GetScheduledServiceSiblingsResponse> {
        return await this.httpGet<GetScheduledServiceSiblingsResponse>(["scheduled-services", request.id, "siblings"]);
    }

    public async overridePickupOrder(request: OverrideScheduledServicePickupOrderRequest): Promise<OverrideScheduledServicePickupOrderResponse> {
        return await this.httpPost<OverrideScheduledServicePickupOrderResponse>(["scheduled-services", request.id, "override-pickup-order"], request);
    }

    public async refreshVouchers(request: RefreshScheduledServiceVouchersRequest): Promise<RefreshScheduledServiceVouchersResponse> {
        return await this.httpPost<RefreshScheduledServiceVouchersResponse>(["scheduled-services", request.id, "refresh-vouchers"], request);
    }

    public async uploadVoucher(request: UploadScheduledServiceVoucherRequest): Promise<UploadScheduledServiceVoucherResponse> {
        return await this.httpPost<UploadScheduledServiceVoucherResponse>(["scheduled-services", request.id, "upload-voucher"], request);
    }

    public async check(request: CheckScheduledServiceRequest): Promise<CheckScheduledServiceResponse> {
        return await this.httpPost<CheckScheduledServiceResponse>(["scheduled-services", request.id, "check"], request);
    }

    public async editSettlement(request: EditScheduledServiceSettlementRequest): Promise<EditScheduledServiceSettlementResponse> {
        return await this.httpPost<EditScheduledServiceSettlementResponse>(["scheduled-services", request.id, "edit-settlement"], request);
    }

    public async setElistStatus(request: SetScheduledServiceElistStatusRequest): Promise<SetScheduledServiceElistStatusResponse> {
        return await this.httpPost<SetScheduledServiceElistStatusResponse>(["scheduled-services", request.id, "set-elist-status"], request);
    }

    public async impersonate(request: ImpersonateScheduledServiceRequest): Promise<ImpersonateScheduledServiceResponse> {
        return await this.httpGet<ImpersonateScheduledServiceResponse>(["scheduled-services", request.id, "impersonate"], { type: request.type });
    }

    public async setOrder(request: SetScheduledServiceOrderRequest): Promise<SetScheduledServiceOrderResponse> {
        return await this.httpPost<SetScheduledServiceOrderResponse>(["scheduled-services", request.id, "order"], request);
    }

    public async addManualVoucher(request: AddManualVoucherToScheduledServiceRequest): Promise<AddManualVoucherToScheduledServiceResponse> {
        return await this.httpPost<AddManualVoucherToScheduledServiceResponse>(["scheduled-services", request.id, "add-manual-voucher"], request);
    }

    public async deleteVoucher(request: DeleteScheduledServiceVoucherRequest): Promise<DeleteScheduledServiceVoucherResponse> {
        return await this.httpPost<DeleteScheduledServiceVoucherResponse>(["scheduled-services", request.id, "delete-voucher"], request);
    }

    public async bookCathedralVoucher(request: BookScheduledServiceCathedralVouchersRequest): Promise<BookScheduledServiceCathedralVouchersResponse> {
        return await this.httpPost<BookScheduledServiceCathedralVouchersResponse>(["scheduled-services", request.id, "book-cathedral-vouchers"], request);
    }

    public async sendCathedralVoucher(request: SendScheduledServiceCathedralVouchersRequest): Promise<SendScheduledServiceCathedralVouchersResponse> {
        return await this.httpPost<SendScheduledServiceCathedralVouchersResponse>(["scheduled-services", request.id, "send-cathedral-vouchers"], request);
    }

    public async cleanUp(request: CleanUpScheduledServiceRequest): Promise<CleanUpScheduledServiceResponse> {
        return await this.httpPost<CleanUpScheduledServiceResponse>(["scheduled-services", request.id, "clean-up"], request);
    }

    public async setPickupTime(request: SetScheduledServicePickupTimeRequest): Promise<SetScheduledServicePickupTimeResponse> {
        return await this.httpPost<SetScheduledServicePickupTimeResponse>(["scheduled-services", request.id, "pickup-time"], request);
    }

    public async notifyGuide(request: NotifyScheduledServiceGuideRequest): Promise<NotifyScheduledServiceGuideResponse> {
        return await this.httpPost<NotifyScheduledServiceGuideResponse>(["scheduled-services", request.id, "notify-guide"], request);
    }

}

class AdministrationService extends BaseService {

    public static readonly instance = new AdministrationService();

    public async restartInbox(): Promise<void> {
        await this.httpPost<void>(["admin", "inbox", "restart"], {});
    }

    public async getAvailableCathedralQuotas(): Promise<number> {
        return await this.httpGet<number>(["admin", "cathedral-quotas"]);
    }

}


class PaymentsService extends BaseService {

    public static readonly instance = new PaymentsService();

    public async getAll(): Promise<GetAllPaymentsResponse> {
        return await this.httpGet<GetAllPaymentsResponse>(["payments"]);
    }

    public async get(request: GetPaymentRequest): Promise<GetPaymentResponse> {
        return await this.httpGet<GetPaymentResponse>(["payments", request.id]);
    }

    public async delete(request: DeletePaymentRequest): Promise<DeletePaymentResponse> {
        return await this.httpDelete<DeletePaymentResponse>(["payments", request.id]);
    }

    public async rename(request: RenamePaymentRequest): Promise<RenamePaymentResponse> {
        return await this.httpPost<RenamePaymentResponse>(["payments", request.id, "rename"], request);
    }

    public async edit(request: EditPaymentRequest): Promise<EditPaymentResponse> {
        return await this.httpPost<EditPaymentResponse>(["payments", request.id, "edit"], request);
    }

    public async add(request: AddPaymentRequest): Promise<AddPaymentResponse> {
        return await this.httpPost<AddPaymentResponse>(["payments"], request);
    }

    public async bulkDelete(request: BulkDeletePaymentsRequest): Promise<BulkDeletePaymentsResponse> {
        return await this.httpPost<BulkDeletePaymentsResponse>(["payments", "bulk-delete"], request);
    }

    public async complete(request: CompletePaymentRequest): Promise<CompletePaymentResponse> {
        return await this.httpPost<CompletePaymentResponse>(["payments", request.id, "complete"], request);
    }

}

class SeriesService extends BaseService {

    public static readonly instance = new SeriesService();

    public async getAll(): Promise<GetAllSeriesResponse> {
        return await this.httpGet<GetAllSeriesResponse>(["series"]);
    }

    public async get(request: GetSeriesRequest): Promise<GetSeriesResponse> {
        return await this.httpGet<GetSeriesResponse>(["series", request.id]);
    }

    public async delete(request: DeleteSeriesRequest): Promise<DeleteSeriesResponse> {
        return await this.httpDelete<DeleteSeriesResponse>(["series", request.id]);
    }

    public async rename(request: RenameSeriesRequest): Promise<RenameSeriesResponse> {
        return await this.httpPost<RenameSeriesResponse>(["series", request.id, "rename"], request);
    }

    public async edit(request: EditSeriesRequest): Promise<EditSeriesResponse> {
        return await this.httpPost<EditSeriesResponse>(["series", request.id, "edit"], request);
    }

    public async add(request: AddSeriesRequest): Promise<AddSeriesResponse> {
        return await this.httpPost<AddSeriesResponse>(["series"], request);
    }

    public async bulkDelete(request: BulkDeleteSeriesRequest): Promise<BulkDeleteSeriesResponse> {
        return await this.httpPost<BulkDeleteSeriesResponse>(["series", "bulk-delete"], request);
    }

}

class SalesInvoicesService extends BaseService {

    public static readonly instance = new SalesInvoicesService();

    public async getAll(request: GetAllSalesInvoicesRequest): Promise<GetAllSalesInvoicesResponse> {
        return await this.httpGet<GetAllSalesInvoicesResponse>(["sales-invoices"], request);
    }

    public async get(request: GetSalesInvoiceRequest): Promise<GetSalesInvoiceResponse> {
        return await this.httpGet<GetSalesInvoiceResponse>(["sales-invoices", request.id]);
    }

    public async delete(request: DeleteSalesInvoiceRequest): Promise<DeleteSalesInvoiceResponse> {
        return await this.httpDelete<DeleteSalesInvoiceResponse>(["sales-invoices", request.id]);
    }

    public async rename(request: RenameSalesInvoiceRequest): Promise<RenameSalesInvoiceResponse> {
        return await this.httpPost<RenameSalesInvoiceResponse>(["sales-invoices", request.id, "rename"], request);
    }

    public async edit(request: EditSalesInvoiceRequest): Promise<EditSalesInvoiceResponse> {
        return await this.httpPost<EditSalesInvoiceResponse>(["sales-invoices", request.id, "edit"], request);
    }

    public async add(request: AddSalesInvoiceRequest): Promise<AddSalesInvoiceResponse> {
        return await this.httpPost<AddSalesInvoiceResponse>(["sales-invoices"], request);
    }

    public async addItems(request: AddItemsToSalesInvoiceRequest): Promise<AddItemsToSalesInvoiceResponse> {
        return await this.httpPost<AddItemsToSalesInvoiceResponse>(["sales-invoices", request.id, "add-items"], request);
    }

    public async removeItems(request: RemoveItemsFromSalesInvoiceRequest): Promise<RemoveItemsFromSalesInvoiceResponse> {
        return await this.httpPost<RemoveItemsFromSalesInvoiceResponse>(["sales-invoices", request.id, "remove-items"], request);
    }

    public getDownloadLink(id: string, output: "pdf" | "xlsx"): string {
        const url = this.buildTargetUrl(["sales-invoices", id, "download"]);

        if (output) {
            return url + "?output=" + output;
        } else {
            return url;
        }
    }

    public getSummaryDownloadLink(id: string, output: "pdf"): string {
        const url = this.buildTargetUrl(["sales-invoices", id, "download-booking-summary"]);

        if (output) {
            return url + "?output=" + output;
        } else {
            return url;
        }
    }

    public async send(request: SendSalesInvoiceRequest): Promise<SendSalesInvoiceResponse> {
        return await this.httpPost<SendSalesInvoiceResponse>(["sales-invoices", request.id, "send"], request);
    }

    public async updateFiscalInformation(request: UpdateSalesInvoiceFiscalInformationRequest): Promise<UpdateSalesInvoiceFiscalInformationResponse> {
        return await this.httpPost<UpdateSalesInvoiceFiscalInformationResponse>(["sales-invoices", request.id, "update-fiscal-information"], request);
    }

    public async bulkUpdateFiscalInformation(request: BulkUpdateSalesInvoiceFiscalInformationRequest): Promise<BulkUpdateSalesInvoiceFiscalInformationResponse> {
        return await this.httpPost<BulkUpdateSalesInvoiceFiscalInformationResponse>(["sales-invoices", "bulk-update-fiscal-information"], request);
    }

    public async record(request: RecordSalesInvoicesRequest): Promise<void> {
        const r = await this.httpPostAsBlob(["sales-invoices", "record"], request, true);

        // const blob = new Blob([r], { type: "application/zip" });

        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = filename || "Contabilizacion.zip";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
    }

    public async updateCode(request: UpdateSalesInvoiceCodeRequest): Promise<UpdateSalesInvoiceCodeResponse> {
        return await this.httpPost<UpdateSalesInvoiceCodeResponse>(["sales-invoices", request.id, "update-code"], request);
    }

    public async generateCSV(request: GenerateSalesInvoicesCSVRequest): Promise<void> {
        await this.httpPostAsBlob(["sales-invoices", "generate-csv"], request, true);
    }

    public async invoiceInvoice(request: InvoiceSalesInvoiceRequest): Promise<InvoiceSalesInvoiceResponse> {
        return await this.httpPost<InvoiceSalesInvoiceResponse>(["sales-invoices", request.id, "invoice"], request);
    }

    public async credit(request: CreditSalesInvoiceRequest): Promise<CreditSalesInvoiceResponse> {
        return await this.httpPost<CreditSalesInvoiceResponse>(["sales-invoices", request.id, "credit"], request);
    }

    public async replace(request: ReplaceSalesInvoiceRequest): Promise<ReplaceSalesInvoiceResponse> {
        return await this.httpPost<ReplaceSalesInvoiceResponse>(["sales-invoices", request.id, "replace"], request);
    }

    public async replaceAttachment(request: ReplaceSalesInvoiceAttachmentRequest): Promise<ReplaceSalesInvoiceAttachmentResponse> {
        return await this.httpPost<ReplaceSalesInvoiceAttachmentResponse>(["sales-invoices", request.id, "replace-attachment"], request);
    }

}


class SettlementsService extends BaseService {

    public static readonly instance = new SettlementsService();

    public async getPendingBookings(request: GetPendingSettlementBookingsRequest): Promise<GetPendingSettlementBookingsResponse> {
        return await this.httpPost<GetPendingSettlementBookingsResponse>(["settlements", "bookings"], request);
    }

    public async getPendingBudgets(request: GetPendingSettlementBudgetsRequest): Promise<GetPendingSettlementBudgetsResponse> {
        return await this.httpPost<GetPendingSettlementBudgetsResponse>(["settlements", "budgets"], request);
    }

    public async getPendingOperators(request: GetPendingSettlementOperatorsRequest): Promise<GetPendingSettlementOperatorsResponse> {
        return await this.httpPost<GetPendingSettlementOperatorsResponse>(["settlements", "operators"], request);
    }

    public async getPendingCarriers(request: GetPendingSettlementCarriersRequest): Promise<GetPendingSettlementCarriersResponse> {
        return await this.httpPost<GetPendingSettlementCarriersResponse>(["settlements", "carriers"], request);
    }

    public async getPendingProviders(request: GetPendingSettlementProvidersRequest): Promise<GetPendingSettlementProvidersResponse> {
        return await this.httpPost<GetPendingSettlementProvidersResponse>(["settlements", "providers"], request);
    }

    public async getPendingGuides(request: GetPendingSettlementGuidesRequest): Promise<GetPendingSettlementGuidesResponse> {
        return await this.httpPost<GetPendingSettlementGuidesResponse>(["settlements", "guides"], request);
    }

    public async getPendingInvoces(request: GetPendingSettlementInvoicesRequest): Promise<GetPendingSettlementInvoicesResponse> {
        return await this.httpPost<GetPendingSettlementInvoicesResponse>(["settlements", "pending-invoices", "agency"], request);
    }

    public async getPendingPurchaseInvoices(request: GetPendingSettlementPurchaseInvoicesRequest): Promise<GetPendingSettlementPurchaseInvoicesResponse> {
        if (request.invoiceId) {
            return await this.httpGet<GetPendingSettlementPurchaseInvoicesResponse>(["settlements", "pending-invoices", request.type, request.ownerId || "", request.invoiceId]);
        } else {
            return await this.httpGet<GetPendingSettlementPurchaseInvoicesResponse>(["settlements", "pending-invoices", request.type, request.ownerId || ""], { organization: request.organizationId });
        }
    }

    public async settleAgencyBookings(request: SettleAgencyBookingsRequest): Promise<SettleAgencyBookingsResponse> {
        return await this.httpPost<SettleAgencyBookingsResponse>(["settlements", "settle-agency-bookings"], request);
    }

    public async unsettleAgencyBookings(request: UnsettleAgencyBookingsRequest): Promise<UnsettleAgencyBookingsResponse> {
        return await this.httpPost<UnsettleAgencyBookingsResponse>(["settlements", "unsettle-agency-bookings"], request);
    }

    public async getSalesInvoice(request: GetSettlementSalesInvoiceRequest): Promise<GetSettlementSalesInvoiceResponse> {
        return await this.httpGet<GetSettlementSalesInvoiceResponse>(["settlements", "sales-invoices", request.salesInvoceId]);
    }

    public async settleOperatorBookings(request: SettleOperatorBookingsRequest): Promise<SettleOperatorBookingsResponse> {
        return await this.httpPost<SettleOperatorBookingsResponse>(["settlements", "settle-operator-bookings"], request);
    }

    public async settleCarrierWorkOrders(request: SettleCarrierWorkOrdersRequest): Promise<SettleCarrierWorkOrdersResponse> {
        return await this.httpPost<SettleCarrierWorkOrdersResponse>(["settlements", "settle-carrier-workorders"], request);
    }

    public async unsettleCarrierWorkOrders(request: UnsettleCarrierWorkOrdersRequest): Promise<UnsettleCarrierWorkOrdersResponse> {
        return await this.httpPost<UnsettleCarrierWorkOrdersResponse>(["settlements", "unsettle-carrier-workorders"], request);
    }

    public async settleProviderWorkOrders(request: SettleProviderWorkOrdersRequest): Promise<SettleProviderWorkOrdersResponse> {
        return await this.httpPost<SettleProviderWorkOrdersResponse>(["settlements", "settle-provider-workorders"], request);
    }

    public async unsettleProviderWorkOrders(request: UnsettleProviderWorkOrdersRequest): Promise<UnsettleProviderWorkOrdersResponse> {
        return await this.httpPost<UnsettleProviderWorkOrdersResponse>(["settlements", "unsettle-provider-workorders"], request);
    }

    public async settleGuideWorkOrders(request: SettleGuideWorkOrdersRequest): Promise<SettleGuideWorkOrdersResponse> {
        return await this.httpPost<SettleGuideWorkOrdersResponse>(["settlements", "settle-guide-workorders"], request);
    }

    public async unsettleGuideWorkOrders(request: UnsettleGuideWorkOrdersRequest): Promise<UnsettleGuideWorkOrdersResponse> {
        return await this.httpPost<UnsettleGuideWorkOrdersResponse>(["settlements", "unsettle-guide-workorders"], request);
    }

    public async unsettleOperatorBookings(request: UnsettleOperatorBookingsRequest): Promise<UnsettleOperatorBookingsResponse> {
        return await this.httpPost<UnsettleOperatorBookingsResponse>(["settlements", "unsettle-operator-bookings"], request);
    }

    public async getPurchaseInvoice(request: GetSettlementPurchaseInvoiceRequest): Promise<GetSettlementPurchaseInvoiceResponse> {
        return await this.httpGet<GetSettlementPurchaseInvoiceResponse>(["settlements", "purchase-invoices", request.purchaseInvoiceId]);
    }

}

class TaxesService extends BaseService {

    public static readonly instance = new TaxesService();

    public async getAll(): Promise<GetAllTaxesResponse> {
        return await this.httpGet<GetAllTaxesResponse>(["taxes"]);
    }

    public async get(request: GetTaxRequest): Promise<GetTaxResponse> {
        return await this.httpGet<GetTaxResponse>(["taxes", request.id]);
    }

    public async delete(request: DeleteTaxRequest): Promise<DeleteTaxResponse> {
        return await this.httpDelete<DeleteTaxResponse>(["taxes", request.id]);
    }

    public async rename(request: RenameTaxRequest): Promise<RenameTaxResponse> {
        return await this.httpPost<RenameTaxResponse>(["taxes", request.id, "rename"], request);
    }

    public async edit(request: EditTaxRequest): Promise<EditTaxResponse> {
        return await this.httpPost<EditTaxResponse>(["taxes", request.id, "edit"], request);
    }

    public async add(request: AddTaxRequest): Promise<AddTaxResponse> {
        return await this.httpPost<AddTaxResponse>(["taxes"], request);
    }

    public async bulkDelete(request: BulkDeleteTaxesRequest): Promise<BulkDeleteTaxesResponse> {
        return await this.httpPost<BulkDeleteTaxesResponse>(["taxes", "bulk-delete"], request);
    }

}

class SettlementRulesService extends BaseService {

    public static readonly instance = new SettlementRulesService();

    public async getAll(): Promise<GetAllSettlementRulesResponse> {
        return await this.httpGet<GetAllSettlementRulesResponse>(["settlementrules"]);
    }

    public async get(request: GetSettlementRuleRequest): Promise<GetSettlementRuleResponse> {
        return await this.httpGet<GetSettlementRuleResponse>(["settlementrules", request.id]);
    }

    public async delete(request: DeleteSettlementRuleRequest): Promise<DeleteSettlementRuleResponse> {
        return await this.httpDelete<DeleteSettlementRuleResponse>(["settlementrules", request.id]);
    }

    public async rename(request: RenameSettlementRuleRequest): Promise<RenameSettlementRuleResponse> {
        return await this.httpPost<RenameSettlementRuleResponse>(["settlementrules", request.id, "rename"], request);
    }

    public async edit(request: EditSettlementRuleRequest): Promise<EditSettlementRuleResponse> {
        return await this.httpPost<EditSettlementRuleResponse>(["settlementrules", request.id, "edit"], request);
    }

    public async add(request: AddSettlementRuleRequest): Promise<AddSettlementRuleResponse> {
        return await this.httpPost<AddSettlementRuleResponse>(["settlementrules"], request);
    }

    public async bulkDelete(request: BulkDeleteSettlementRulesRequest): Promise<BulkDeleteSettlementRulesResponse> {
        return await this.httpPost<BulkDeleteSettlementRulesResponse>(["settlementrules", "bulk-delete"], request);
    }

}

class PurchaseInvoicesService extends BaseService {

    public static readonly instance = new PurchaseInvoicesService();

    public async getAll(request: GetAllPurchaseInvoicesRequest): Promise<GetAllPurchaseInvoicesResponse> {
        return await this.httpGet<GetAllPurchaseInvoicesResponse>(["purchase-invoices"], request);
    }

    public async get(request: GetPurchaseInvoiceRequest): Promise<GetPurchaseInvoiceResponse> {
        return await this.httpGet<GetPurchaseInvoiceResponse>(["purchase-invoices", request.id]);
    }

    public async delete(request: DeletePurchaseInvoiceRequest): Promise<DeletePurchaseInvoiceResponse> {
        return await this.httpDelete<DeletePurchaseInvoiceResponse>(["purchase-invoices", request.id]);
    }

    public async rename(request: RenamePurchaseInvoiceRequest): Promise<RenamePurchaseInvoiceResponse> {
        return await this.httpPost<RenamePurchaseInvoiceResponse>(["purchase-invoices", request.id, "rename"], request);
    }

    public async edit(request: EditPurchaseInvoiceRequest): Promise<EditPurchaseInvoiceResponse> {
        return await this.httpPost<EditPurchaseInvoiceResponse>(["purchase-invoices", request.id, "edit"], request);
    }

    public async add(request: AddPurchaseInvoiceRequest): Promise<AddPurchaseInvoiceResponse> {
        return await this.httpPost<AddPurchaseInvoiceResponse>(["purchase-invoices"], request);
    }

    public async bulkDelete(request: BulkDeletePurchaseInvoicesRequest): Promise<BulkDeletePurchaseInvoicesResponse> {
        return await this.httpPost<BulkDeletePurchaseInvoicesResponse>(["purchase-invoices", "bulk-delete"], request);
    }

    public async updateFiscalInformation(request: UpdatePurchaseInvoiceFiscalInformationRequest): Promise<UpdatePurchaseInvoiceFiscalInformationResponse> {
        return await this.httpPost<UpdatePurchaseInvoiceFiscalInformationResponse>(["purchase-invoices", request.id, "update-fiscal-information"], request);
    }

    public async bulkUpdateFiscalInformation(request: BulkUpdatePurchaseInvoiceFiscalInformationRequest): Promise<BulkUpdatePurchaseInvoiceFiscalInformationResponse> {
        return await this.httpPost<BulkUpdatePurchaseInvoiceFiscalInformationResponse>(["purchase-invoices", "bulk-update-fiscal-information"], request);
    }

    public async record(request: RecordPurchaseInvoicesRequest, filename?: string): Promise<void> {
        const r = await this.httpPostAsBlob(["purchase-invoices", "record"], request, true);

        // const blob = new Blob([r], { type: "application/zip" });

        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = filename || "Contabilizacion.zip";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
    }

    public async forceSettlement(request: ForcePurchaseInvoiceSettlementRequest): Promise<ForcePurchaseInvoiceSettlementResponse> {
        return await this.httpPost<ForcePurchaseInvoiceSettlementResponse>(["purchase-invoices", request.id, "force-settlement"], request);
    }

    public async unrecord(request: UnrecordPurchaseInvoicesRequest): Promise<UnrecordPurchaseInvoicesResponse> {
        return await this.httpPost<UnrecordPurchaseInvoicesResponse>(["purchase-invoices", "unrecord"], request);
    }

}

class ConversationsService extends BaseService {

    public static readonly instance = new ConversationsService();

    public async getAll(): Promise<GetAllConversationsResponse> {
        return await this.httpGet<GetAllConversationsResponse>(["conversations"]);
    }

    public async get(request: GetConversationRequest): Promise<GetConversationResponse> {
        return await this.httpGet<GetConversationResponse>(["conversations", request.id]);
    }

    public async sendMessage(request: SendConversationMessageRequest): Promise<SendConversationMessageResponse> {
        return await this.httpPost<SendConversationMessageResponse>(["conversations", "send-message"], request);
    }

}


export interface OpenLogViewerRequest {
    aggregateId: string;
}

class LogsService extends BaseService {

    public static readonly instance = new LogsService();

    public readonly OpenLogViewerDialogEvent = "log-viewer:dialog:open";
    public readonly CloseLogViewerDialogEvent = "log-viewer:dialog:close";

    public open(request: OpenLogViewerRequest | boolean, close = false): Promise<boolean> {
        if (close) {
            EventBus.$emit(this.CloseLogViewerDialogEvent, request);
            return Promise.resolve(false);
        } else {
            EventBus.$emit(this.OpenLogViewerDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseLogViewerDialogEvent, (result: any) => {
                    resolve(result);
                });
            });
        }
    }

    public async search(request: SearchLogsRequest): Promise<SearchLogsResponse> {
        return await this.httpPost<SearchLogsResponse>(["logs", "search"], request);
    }

}


export interface OpenCommandCenterRequest {
    action?: string;
}

class CommandCenterService extends BaseService {

    public static readonly instance = new CommandCenterService();

    public readonly OpenCommandCenterDialogEvent = "command-center:dialog:open";
    public readonly CloseCommandCenterDialogEvent = "command-center:dialog:close";

    public open(request: OpenCommandCenterRequest | boolean, close = false): Promise<boolean> {
        if (close) {
            EventBus.$emit(this.CloseCommandCenterDialogEvent, request);
            return Promise.resolve(false);
        } else {
            EventBus.$emit(this.OpenCommandCenterDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseCommandCenterDialogEvent, (result: any) => {
                    resolve(result);
                });
            });
        }
    }

    public search(request: SearchCommandCenterRequest): Promise<SearchCommandCenterResponse> {
        return this.httpPost<SearchCommandCenterResponse>(["command-center", "search"], request);
    }

}


export interface OpenCrmRequest {
    messageTemplateType?: string;

    productId?: string;
    hotelId?: string;
    meetingPointId?: string;
    pickupTime?: string;

    bookingId?: string;
    prebookingId?: string;
    transferBookingId?: string;
}

class CrmService extends BaseService {

    public static readonly instance = new CrmService();

    public readonly OpenCrmDialogEvent = "crm:dialog:open";
    public readonly CloseCrmDialogEvent = "crm:dialog:close";

    public open(request: OpenCrmRequest | boolean, close = false): Promise<boolean> {
        if (close) {
            EventBus.$emit(this.CloseCrmDialogEvent, request);
            return Promise.resolve(false);
        } else {
            EventBus.$emit(this.OpenCrmDialogEvent, request);

            return new Promise((resolve) => {
                EventBus.$on(this.CloseCrmDialogEvent, (result: any) => {
                    resolve(result);
                });
            })
        }
    }

}

class PostsService extends BaseService {

    public static readonly instance = new PostsService();

    public async getAll(): Promise<GetAllPostsResponse> {
        return await this.httpGet<GetAllPostsResponse>(["posts"]);
    }

    public async get(request: GetPostRequest): Promise<GetPostResponse> {
        return await this.httpGet<GetPostResponse>(["posts", request.id]);
    }

    public async delete(request: DeletePostRequest): Promise<DeletePostResponse> {
        return await this.httpDelete<DeletePostResponse>(["posts", request.id]);
    }

    public async rename(request: RenamePostRequest): Promise<RenamePostResponse> {
        return await this.httpPost<RenamePostResponse>(["posts", request.id, "rename"], request);
    }

    public async edit(request: EditPostRequest): Promise<EditPostResponse> {
        return await this.httpPost<EditPostResponse>(["posts", request.id, "edit"], request);
    }

    public async add(request: AddPostRequest): Promise<AddPostResponse> {
        return await this.httpPost<AddPostResponse>(["posts"], request);
    }

    public async bulkDelete(request: BulkDeletePostsRequest): Promise<BulkDeletePostsResponse> {
        return await this.httpPost<BulkDeletePostsResponse>(["posts", "bulk-delete"], request);
    }

    public async togglePublication(request: TogglePostPublicationRequest): Promise<TogglePostPublicationResponse> {
        return await this.httpPost<TogglePostPublicationResponse>(["posts", request.id, "toggle-publication"], request);
    }

    public async translate(request: TranslatePostRequest): Promise<TranslatePostResponse> {
        return await this.httpPost<TranslatePostResponse>(["posts", request.id, "translate"], request);
    }

    public async generateUsingAI(request: GeneratePostUsingAIRequest): Promise<GeneratePostUsingAIResponse> {
        return await this.httpPost<GeneratePostUsingAIResponse>(["posts", "generate-using-ai"], request);
    }

}

class ReportsService extends BaseService {

    public static readonly instance = new ReportsService();

    public async getAll(): Promise<GetAllReportsResponse> {
        return await this.httpGet<GetAllReportsResponse>(["reports"]);
    }

    public async get(request: GetReportRequest): Promise<GetReportResponse> {
        return await this.httpGet<GetReportResponse>(["reports", request.id]);
    }

    public async delete(request: DeleteReportRequest): Promise<DeleteReportResponse> {
        return await this.httpDelete<DeleteReportResponse>(["reports", request.id]);
    }

    public async rename(request: RenameReportRequest): Promise<RenameReportResponse> {
        return await this.httpPost<RenameReportResponse>(["reports", request.id, "rename"], request);
    }

    public async edit(request: EditReportRequest): Promise<EditReportResponse> {
        return await this.httpPost<EditReportResponse>(["reports", request.id, "edit"], request);
    }

    public async add(request: AddReportRequest): Promise<AddReportResponse> {
        return await this.httpPost<AddReportResponse>(["reports"], request);
    }

    public async bulkDelete(request: BulkDeleteReportsRequest): Promise<BulkDeleteReportsResponse> {
        return await this.httpPost<BulkDeleteReportsResponse>(["reports", "bulk-delete"], request);
    }

    public async getAvailableDataSources(): Promise<GetReportAvailableDataSourcesResponse> {
        return await this.httpGet<GetReportAvailableDataSourcesResponse>(["reports", "available-data-sources"]);
    }

    public async getDataSource(request: GetReportDataSourceRequest): Promise<GetReportDataSourceResponse> {
        return await this.httpGet<GetReportDataSourceResponse>(["reports", "data-sources", request.id]);
    }

    public async execute(request: ExecuteReportRequest): Promise<ExecuteReportResponse> {
        return await this.httpPost<ExecuteReportResponse>(["reports", request.id, "execute"], request);
    }

    public async executeAndDownload(request: ExecuteReportRequest): Promise<void> {
        await this.httpPostAsBlob<ExecuteReportResponse>(["reports", request.id, "execute"], request, true);
    }

    public async executeAndPreview(request: ExecuteReportRequest): Promise<void> {
        const blob = await this.httpPostAsBlob<ExecuteReportResponse>(["reports", request.id, "execute"], request);
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
    }

    public async duplicate(request: DuplicateReportRequest): Promise<DuplicateReportResponse> {
        return await this.httpPost<DuplicateReportResponse>(["reports", request.id, "duplicate"], request);
    }

    public async send(request: SendReportRequest): Promise<SendReportResponse> {
        return await this.httpPost<SendReportResponse>(["reports", request.id, "send"], request);
    }

    public async share(request: ShareReportRequest): Promise<ShareReportResponse> {
        return await this.httpPost<ShareReportResponse>(["reports", request.id, "share"], request);
    }

    public async moveToCategory(request: MoveReportToCategoryRequest): Promise<MoveReportToCategoryResponse> {
        return await this.httpPost<MoveReportToCategoryResponse>(["reports", request.id, "move-to-category"], request);
    }

}

class HelpPagesService extends BaseService {

    public static readonly instance = new HelpPagesService();

    public async getAll(): Promise<GetAllHelpPagesResponse> {
        return await this.httpGet<GetAllHelpPagesResponse>(["help-pages"]);
    }

    public async get(request: GetHelpPageRequest): Promise<GetHelpPageResponse> {
        return await this.httpGet<GetHelpPageResponse>(["help-pages", request.id]);
    }

    public async delete(request: DeleteHelpPageRequest): Promise<DeleteHelpPageResponse> {
        return await this.httpDelete<DeleteHelpPageResponse>(["help-pages", request.id]);
    }

    public async rename(request: RenameHelpPageRequest): Promise<RenameHelpPageResponse> {
        return await this.httpPost<RenameHelpPageResponse>(["help-pages", request.id, "rename"], request);
    }

    public async edit(request: EditHelpPageRequest): Promise<EditHelpPageResponse> {
        return await this.httpPost<EditHelpPageResponse>(["help-pages", request.id, "edit"], request);
    }

    public async add(request: AddHelpPageRequest): Promise<AddHelpPageResponse> {
        return await this.httpPost<AddHelpPageResponse>(["help-pages"], request);
    }

    public async bulkDelete(request: BulkDeleteHelpPagesRequest): Promise<BulkDeleteHelpPagesResponse> {
        return await this.httpPost<BulkDeleteHelpPagesResponse>(["help-pages", "bulk-delete"], request);
    }

    public async setVisibility(request: SetHelpPageVisibilityRequest): Promise<SetHelpPageVisibilityResponse> {
        return await this.httpPost<SetHelpPageVisibilityResponse>(["help-pages", request.id, "set-visibility"], request);
    }

}

class GuideRatesService extends BaseService {

    public static readonly instance = new GuideRatesService();

    public async getAll(): Promise<GetAllGuideRatesResponse> {
        return await this.httpGet<GetAllGuideRatesResponse>(["guiderates"]);
    }

    public async get(request: GetGuideRateRequest): Promise<GetGuideRateResponse> {
        return await this.httpGet<GetGuideRateResponse>(["guiderates", request.id]);
    }

    public async delete(request: DeleteGuideRateRequest): Promise<DeleteGuideRateResponse> {
        return await this.httpDelete<DeleteGuideRateResponse>(["guiderates", request.id]);
    }

    public async rename(request: RenameGuideRateRequest): Promise<RenameGuideRateResponse> {
        return await this.httpPost<RenameGuideRateResponse>(["guiderates", request.id, "rename"], request);
    }

    public async edit(request: EditGuideRateRequest): Promise<EditGuideRateResponse> {
        return await this.httpPost<EditGuideRateResponse>(["guiderates", request.id, "edit"], request);
    }

    public async add(request: AddGuideRateRequest): Promise<AddGuideRateResponse> {
        return await this.httpPost<AddGuideRateResponse>(["guiderates"], request);
    }

    public async bulkDelete(request: BulkDeleteGuideRatesRequest): Promise<BulkDeleteGuideRatesResponse> {
        return await this.httpPost<BulkDeleteGuideRatesResponse>(["guiderates", "bulk-delete"], request);
    }

}

class WorkFlowsService extends BaseService {

    public static readonly instance = new WorkFlowsService();

    public async getAll(): Promise<GetAllWorkFlowsResponse> {
        return await this.httpGet<GetAllWorkFlowsResponse>(["workflows"]);
    }

    public async get(request: GetWorkFlowRequest): Promise<GetWorkFlowResponse> {
        return await this.httpGet<GetWorkFlowResponse>(["workflows", request.id]);
    }

    public async delete(request: DeleteWorkFlowRequest): Promise<DeleteWorkFlowResponse> {
        return await this.httpDelete<DeleteWorkFlowResponse>(["workflows", request.id]);
    }

    public async rename(request: RenameWorkFlowRequest): Promise<RenameWorkFlowResponse> {
        return await this.httpPost<RenameWorkFlowResponse>(["workflows", request.id, "rename"], request);
    }

    public async edit(request: EditWorkFlowRequest): Promise<EditWorkFlowResponse> {
        return await this.httpPost<EditWorkFlowResponse>(["workflows", request.id, "edit"], request);
    }

    public async add(request: AddWorkFlowRequest): Promise<AddWorkFlowResponse> {
        return await this.httpPost<AddWorkFlowResponse>(["workflows"], request);
    }

    public async bulkDelete(request: BulkDeleteWorkFlowsRequest): Promise<BulkDeleteWorkFlowsResponse> {
        return await this.httpPost<BulkDeleteWorkFlowsResponse>(["workflows", "bulk-delete"], request);
    }

}

class ReportCategoriesService extends BaseService {

    public static readonly instance = new ReportCategoriesService();

    public async getAll(): Promise<GetAllReportCategoriesResponse> {
        return await this.httpGet<GetAllReportCategoriesResponse>(["report-categories"]);
    }

    public async get(request: GetReportCategoryRequest): Promise<GetReportCategoryResponse> {
        return await this.httpGet<GetReportCategoryResponse>(["report-categories", request.id]);
    }

    public async delete(request: DeleteReportCategoryRequest): Promise<DeleteReportCategoryResponse> {
        return await this.httpDelete<DeleteReportCategoryResponse>(["report-categories", request.id]);
    }

    public async rename(request: RenameReportCategoryRequest): Promise<RenameReportCategoryResponse> {
        return await this.httpPost<RenameReportCategoryResponse>(["report-categories", request.id, "rename"], request);
    }

    public async edit(request: EditReportCategoryRequest): Promise<EditReportCategoryResponse> {
        return await this.httpPost<EditReportCategoryResponse>(["report-categories", request.id, "edit"], request);
    }

    public async add(request: AddReportCategoryRequest): Promise<AddReportCategoryResponse> {
        return await this.httpPost<AddReportCategoryResponse>(["report-categories"], request);
    }

    public async bulkDelete(request: BulkDeleteReportCategoriesRequest): Promise<BulkDeleteReportCategoriesResponse> {
        return await this.httpPost<BulkDeleteReportCategoriesResponse>(["report-categories", "bulk-delete"], request);
    }

}

class IncidentsService extends BaseService {

    public static readonly instance = new IncidentsService();

    public async getAll(date: string): Promise<GetAllIncidentsResponse> {
        return await this.httpGet<GetAllIncidentsResponse>(["incidents"], { date: date });
    }

    public async get(request: GetIncidentRequest): Promise<GetIncidentResponse> {
        return await this.httpGet<GetIncidentResponse>(["incidents", request.id]);
    }

    public async delete(request: DeleteIncidentRequest): Promise<DeleteIncidentResponse> {
        return await this.httpDelete<DeleteIncidentResponse>(["incidents", request.id]);
    }

    public async rename(request: RenameIncidentRequest): Promise<RenameIncidentResponse> {
        return await this.httpPost<RenameIncidentResponse>(["incidents", request.id, "rename"], request);
    }

    public async edit(request: EditIncidentRequest): Promise<EditIncidentResponse> {
        return await this.httpPost<EditIncidentResponse>(["incidents", request.id, "edit"], request);
    }

    public async add(request: AddIncidentRequest): Promise<AddIncidentResponse> {
        return await this.httpPost<AddIncidentResponse>(["incidents"], request);
    }

    public async bulkDelete(request: BulkDeleteIncidentsRequest): Promise<BulkDeleteIncidentsResponse> {
        return await this.httpPost<BulkDeleteIncidentsResponse>(["incidents", "bulk-delete"], request);
    }

    public async resolve(request: ResolveIncidentRequest): Promise<ResolveIncidentResponse> {
        return await this.httpPost<ResolveIncidentResponse>(["incidents", request.id, "resolve"], request);
    }

}

class PagesService extends BaseService {

    public static readonly instance = new PagesService();

    public async getAll(): Promise<GetAllPagesResponse> {
        return await this.httpGet<GetAllPagesResponse>(["pages"]);
    }

    public async get(request: GetPageRequest): Promise<GetPageResponse> {
        return await this.httpGet<GetPageResponse>(["pages", request.id]);
    }

    public async delete(request: DeletePageRequest): Promise<DeletePageResponse> {
        return await this.httpDelete<DeletePageResponse>(["pages", request.id]);
    }

    public async rename(request: RenamePageRequest): Promise<RenamePageResponse> {
        return await this.httpPost<RenamePageResponse>(["pages", request.id, "rename"], request);
    }

    public async edit(request: EditPageRequest): Promise<EditPageResponse> {
        return await this.httpPost<EditPageResponse>(["pages", request.id, "edit"], request);
    }

    public async add(request: AddPageRequest): Promise<AddPageResponse> {
        return await this.httpPost<AddPageResponse>(["pages"], request);
    }

    public async bulkDelete(request: BulkDeletePagesRequest): Promise<BulkDeletePagesResponse> {
        return await this.httpPost<BulkDeletePagesResponse>(["pages", "bulk-delete"], request);
    }

}

class PaymentGatewaysService extends BaseService {

    public static readonly instance = new PaymentGatewaysService();

    public async getAll(): Promise<GetAllPaymentGatewaysResponse> {
        return await this.httpGet<GetAllPaymentGatewaysResponse>(["payment-gateways"]);
    }

}

class PaymentMethodsService extends BaseService {

    public static readonly instance = new PaymentMethodsService();

    public async getAll(): Promise<GetAllPaymentMethodsResponse> {
        return await this.httpGet<GetAllPaymentMethodsResponse>(["payment-methods"]);
    }

    public async get(request: GetPaymentMethodRequest): Promise<GetPaymentMethodResponse> {
        return await this.httpGet<GetPaymentMethodResponse>(["payment-methods", request.id]);
    }

    public async delete(request: DeletePaymentMethodRequest): Promise<DeletePaymentMethodResponse> {
        return await this.httpDelete<DeletePaymentMethodResponse>(["payment-methods", request.id]);
    }

    public async rename(request: RenamePaymentMethodRequest): Promise<RenamePaymentMethodResponse> {
        return await this.httpPost<RenamePaymentMethodResponse>(["payment-methods", request.id, "rename"], request);
    }

    public async edit(request: EditPaymentMethodRequest): Promise<EditPaymentMethodResponse> {
        return await this.httpPost<EditPaymentMethodResponse>(["payment-methods", request.id, "edit"], request);
    }

    public async add(request: AddPaymentMethodRequest): Promise<AddPaymentMethodResponse> {
        return await this.httpPost<AddPaymentMethodResponse>(["payment-methods"], request);
    }

    public async bulkDelete(request: BulkDeletePaymentMethodsRequest): Promise<BulkDeletePaymentMethodsResponse> {
        return await this.httpPost<BulkDeletePaymentMethodsResponse>(["payment-methods", "bulk-delete"], request);
    }

    public async toggle(request: TogglePaymentMethodRequest): Promise<TogglePaymentMethodResponse> {
        return await this.httpPost<TogglePaymentMethodResponse>(["payment-methods", request.id, "toggle"], request);
    }

}

class AutomaticNotificationRulesService extends BaseService {

    public static readonly instance = new AutomaticNotificationRulesService();

    public async getAll(): Promise<GetAllAutomaticNotificationRulesResponse> {
        return await this.httpGet<GetAllAutomaticNotificationRulesResponse>(["automatic-notification-rules"]);
    }

    public async get(request: GetAutomaticNotificationRuleRequest): Promise<GetAutomaticNotificationRuleResponse> {
        return await this.httpGet<GetAutomaticNotificationRuleResponse>(["automatic-notification-rules", request.id]);
    }

    public async delete(request: DeleteAutomaticNotificationRuleRequest): Promise<DeleteAutomaticNotificationRuleResponse> {
        return await this.httpDelete<DeleteAutomaticNotificationRuleResponse>(["automatic-notification-rules", request.id]);
    }

    public async rename(request: RenameAutomaticNotificationRuleRequest): Promise<RenameAutomaticNotificationRuleResponse> {
        return await this.httpPost<RenameAutomaticNotificationRuleResponse>(["automatic-notification-rules", request.id, "rename"], request);
    }

    public async edit(request: EditAutomaticNotificationRuleRequest): Promise<EditAutomaticNotificationRuleResponse> {
        return await this.httpPost<EditAutomaticNotificationRuleResponse>(["automatic-notification-rules", request.id, "edit"], request);
    }

    public async add(request: AddAutomaticNotificationRuleRequest): Promise<AddAutomaticNotificationRuleResponse> {
        return await this.httpPost<AddAutomaticNotificationRuleResponse>(["automatic-notification-rules"], request);
    }

    public async bulkDelete(request: BulkDeleteAutomaticNotificationRulesRequest): Promise<BulkDeleteAutomaticNotificationRulesResponse> {
        return await this.httpPost<BulkDeleteAutomaticNotificationRulesResponse>(["automatic-notification-rules", "bulk-delete"], request);
    }

    public async toggle(request: ToggleAutomaticNotificationRuleRequest): Promise<ToggleAutomaticNotificationRuleResponse> {
        return await this.httpPost<ToggleAutomaticNotificationRuleResponse>(["automatic-notification-rules", request.id, "toggle"], request);
    }

}

class AutomaticNotificationsService extends BaseService {

    public static readonly instance = new AutomaticNotificationsService();

    public async getAll(): Promise<GetAllAutomaticNotificationsResponse> {
        return await this.httpGet<GetAllAutomaticNotificationsResponse>(["automatic-notifications"]);
    }

    public async get(request: GetAutomaticNotificationRequest): Promise<GetAutomaticNotificationResponse> {
        return await this.httpGet<GetAutomaticNotificationResponse>(["automatic-notifications", request.id]);
    }

    public async delete(request: DeleteAutomaticNotificationRequest): Promise<DeleteAutomaticNotificationResponse> {
        return await this.httpDelete<DeleteAutomaticNotificationResponse>(["automatic-notifications", request.id]);
    }

    public async rename(request: RenameAutomaticNotificationRequest): Promise<RenameAutomaticNotificationResponse> {
        return await this.httpPost<RenameAutomaticNotificationResponse>(["automatic-notifications", request.id, "rename"], request);
    }

    public async edit(request: EditAutomaticNotificationRequest): Promise<EditAutomaticNotificationResponse> {
        return await this.httpPost<EditAutomaticNotificationResponse>(["automatic-notifications", request.id, "edit"], request);
    }

    public async add(request: AddAutomaticNotificationRequest): Promise<AddAutomaticNotificationResponse> {
        return await this.httpPost<AddAutomaticNotificationResponse>(["automatic-notifications"], request);
    }

    public async bulkDelete(request: BulkDeleteAutomaticNotificationsRequest): Promise<BulkDeleteAutomaticNotificationsResponse> {
        return await this.httpPost<BulkDeleteAutomaticNotificationsResponse>(["automatic-notifications", "bulk-delete"], request);
    }

    public async generateAll(request: GenerateAllAutomaticNotificationsRequest): Promise<GenerateAllAutomaticNotificationsResponse> {
        return await this.httpPost<GenerateAllAutomaticNotificationsResponse>(["automatic-notifications", "generate-all"], request);
    }

}

class BudgetsService extends BaseService {

    public static readonly instance = new BudgetsService();

    public async getAll(): Promise<GetAllBudgetsResponse> {
        return await this.httpGet<GetAllBudgetsResponse>(["budgets"]);
    }

    public async get(request: GetBudgetRequest): Promise<GetBudgetResponse> {
        return await this.httpGet<GetBudgetResponse>(["budgets", request.id]);
    }

    public async delete(request: DeleteBudgetRequest): Promise<DeleteBudgetResponse> {
        return await this.httpDelete<DeleteBudgetResponse>(["budgets", request.id]);
    }

    public async rename(request: RenameBudgetRequest): Promise<RenameBudgetResponse> {
        return await this.httpPost<RenameBudgetResponse>(["budgets", request.id, "rename"], request);
    }

    public async edit(request: EditBudgetRequest): Promise<EditBudgetResponse> {
        return await this.httpPost<EditBudgetResponse>(["budgets", request.id, "edit"], request);
    }

    public async add(request: AddBudgetRequest): Promise<AddBudgetResponse> {
        return await this.httpPost<AddBudgetResponse>(["budgets"], request);
    }

    public async bulkDelete(request: BulkDeleteBudgetsRequest): Promise<BulkDeleteBudgetsResponse> {
        return await this.httpPost<BulkDeleteBudgetsResponse>(["budgets", "bulk-delete"], request);
    }

    public async confirm(request: ConfirmBudgetRequest): Promise<ConfirmBudgetResponse> {
        return await this.httpPost<ConfirmBudgetResponse>(["budgets", request.id, "confirm"], request);
    }

    public async cancel(request: CancelBudgetRequest): Promise<CancelBudgetResponse> {
        return await this.httpPost<CancelBudgetResponse>(["budgets", request.id, "cancel"], request);
    }

    public getDownloadLink(request: GenerateBudgetProFormaRequest): string {
        const url = this.buildTargetUrl(["budgets", request.id, "download"]);
        const parameters: string[] = [];

        if (request.output) {
            parameters.push("output=" + request.output);
        }

        if (request.includeServiceDescription) {
            parameters.push("includeServiceDescription=true");
        }

        if (request.includePricePerPax) {
            parameters.push("includePricePerPax=true");
        }

        if (request.inline) {
            parameters.push("inline=true");
        }

        // generate final url adding parameters to query string
        return url + (parameters.length > 0 ? "?" + parameters.join("&") : "");
    }

    public async generateProforma(request: GenerateBudgetProFormaRequest): Promise<GenerateBudgetProFormaResponse> {
        return await this.httpPost<GenerateBudgetProFormaResponse>(["budgets", request.id, "proforma"], request);
    }

    public async sendProforma(request: SendBudgetProFormaRequest): Promise<SendBudgetProFormaResponse> {
        return await this.httpPost<SendBudgetProFormaResponse>(["budgets", request.id, "proforma", "send"], request);
    }

}

class SeasonsService extends BaseService {

    public static readonly instance = new SeasonsService();

    public async getAll(): Promise<GetAllSeasonsResponse> {
        return await this.httpGet<GetAllSeasonsResponse>(["seasons"]);
    }

    public async get(request: GetSeasonRequest): Promise<GetSeasonResponse> {
        return await this.httpGet<GetSeasonResponse>(["seasons", request.id]);
    }

    public async delete(request: DeleteSeasonRequest): Promise<DeleteSeasonResponse> {
        return await this.httpDelete<DeleteSeasonResponse>(["seasons", request.id]);
    }

    public async rename(request: RenameSeasonRequest): Promise<RenameSeasonResponse> {
        return await this.httpPost<RenameSeasonResponse>(["seasons", request.id, "rename"], request);
    }

    public async edit(request: EditSeasonRequest): Promise<EditSeasonResponse> {
        return await this.httpPost<EditSeasonResponse>(["seasons", request.id, "edit"], request);
    }

    public async add(request: AddSeasonRequest): Promise<AddSeasonResponse> {
        return await this.httpPost<AddSeasonResponse>(["seasons"], request);
    }

    public async bulkDelete(request: BulkDeleteSeasonsRequest): Promise<BulkDeleteSeasonsResponse> {
        return await this.httpPost<BulkDeleteSeasonsResponse>(["seasons", "bulk-delete"], request);
    }

}

class KeysService extends BaseService {

    public static readonly instance = new KeysService();

    public async getAll(): Promise<GetAllKeysResponse> {
        return await this.httpGet<GetAllKeysResponse>(["keys"]);
    }

    public async get(request: GetKeyRequest): Promise<GetKeyResponse> {
        return await this.httpGet<GetKeyResponse>(["keys", request.id]);
    }

    public async delete(request: DeleteKeyRequest): Promise<DeleteKeyResponse> {
        return await this.httpDelete<DeleteKeyResponse>(["keys", request.id]);
    }

    public async rename(request: RenameKeyRequest): Promise<RenameKeyResponse> {
        return await this.httpPost<RenameKeyResponse>(["keys", request.id, "rename"], request);
    }

    public async edit(request: EditKeyRequest): Promise<EditKeyResponse> {
        return await this.httpPost<EditKeyResponse>(["keys", request.id, "edit"], request);
    }

    public async add(request: AddKeyRequest): Promise<AddKeyResponse> {
        return await this.httpPost<AddKeyResponse>(["keys"], request);
    }

    public async bulkDelete(request: BulkDeleteKeysRequest): Promise<BulkDeleteKeysResponse> {
        return await this.httpPost<BulkDeleteKeysResponse>(["keys", "bulk-delete"], request);
    }

}

class RatesService extends BaseService {

    public static readonly instance = new RatesService();

    public async getAll(): Promise<GetAllRatesResponse> {
        return await this.httpGet<GetAllRatesResponse>(["rates"]);
    }

    public async get(request: GetRateRequest): Promise<GetRateResponse> {
        return await this.httpGet<GetRateResponse>(["rates", request.id]);
    }

    public async getSeasonSummary(request: GetRateSeasonSummaryRequest): Promise<GetRateSeasonSummaryResponse> {
        return await this.httpGet<GetRateSeasonSummaryResponse>(["rates", request.id, "season-summary"]);
    }

    public async delete(request: DeleteRateRequest): Promise<DeleteRateResponse> {
        return await this.httpDelete<DeleteRateResponse>(["rates", request.id]);
    }

    public async rename(request: RenameRateRequest): Promise<RenameRateResponse> {
        return await this.httpPost<RenameRateResponse>(["rates", request.id, "rename"], request);
    }

    public async edit(request: EditRateRequest): Promise<EditRateResponse> {
        return await this.httpPost<EditRateResponse>(["rates", request.id, "edit"], request);
    }

    public async add(request: AddRateRequest): Promise<AddRateResponse> {
        return await this.httpPost<AddRateResponse>(["rates"], request);
    }

    public async bulkDelete(request: BulkDeleteRatesRequest): Promise<BulkDeleteRatesResponse> {
        return await this.httpPost<BulkDeleteRatesResponse>(["rates", "bulk-delete"], request);
    }

    public async duplicate(request: DuplicateRateRequest): Promise<DuplicateRateResponse> {
        return await this.httpPost<DuplicateRateResponse>(["rates", request.id, "duplicate"], request);
    }

    public async addPricing(request: AddRatePricingRequest): Promise<AddRatePricingResponse> {
        return await this.httpPost<AddRatePricingResponse>(["rates", request.id, "add-pricing"], request);
    }

    public async editPricing(request: EditRatePricingRequest): Promise<EditRatePricingResponse> {
        return await this.httpPost<EditRatePricingResponse>(["rates", request.id, "edit-pricing"], request);
    }

    public async removePricing(request: RemoveRatePricingRequest): Promise<RemoveRatePricingResponse> {
        return await this.httpPost<RemoveRatePricingResponse>(["rates", request.id, "remove-pricing"], request);
    }

    public async downloadSeasonSummary(request: DownloadRateSeasonSummaryRequest): Promise<void> {
        await this.httpPostAsBlob<DownloadRateSeasonSummaryResponse>(["rates", request.id, "season-summary", "download"], request, true);
    }

    public async importSeasonSummary(request: ImportRateSeasonSummaryRequest): Promise<ImportRateSeasonSummaryResponse> {
        return await this.httpPost<ImportRateSeasonSummaryResponse>(["rates", request.id, "import"], request);
    }

}

class TimeRecordsService extends BaseService {

    public static readonly instance = new TimeRecordsService();

    public async getAll(): Promise<GetAllTimeRecordsResponse> {
        return await this.httpGet<GetAllTimeRecordsResponse>(["time-records"]);
    }

    public async get(request: GetTimeRecordRequest): Promise<GetTimeRecordResponse> {
        return await this.httpGet<GetTimeRecordResponse>(["time-records", request.id]);
    }

    public async getForCurrentUser(): Promise<GetTimeRecordForCurrentUserResponse> {
        return await this.httpGet<GetTimeRecordForCurrentUserResponse>(["time-records", "current-user"]);
    }

    public async delete(request: DeleteTimeRecordRequest): Promise<DeleteTimeRecordResponse> {
        return await this.httpDelete<DeleteTimeRecordResponse>(["time-records", request.id]);
    }

    public async rename(request: RenameTimeRecordRequest): Promise<RenameTimeRecordResponse> {
        return await this.httpPost<RenameTimeRecordResponse>(["time-records", request.id, "rename"], request);
    }

    public async edit(request: EditTimeRecordRequest): Promise<EditTimeRecordResponse> {
        return await this.httpPost<EditTimeRecordResponse>(["time-records", request.id, "edit"], request);
    }

    public async add(request: AddTimeRecordRequest): Promise<AddTimeRecordResponse> {
        return await this.httpPost<AddTimeRecordResponse>(["time-records"], request);
    }

    public async bulkDelete(request: BulkDeleteTimeRecordsRequest): Promise<BulkDeleteTimeRecordsResponse> {
        return await this.httpPost<BulkDeleteTimeRecordsResponse>(["time-records", "bulk-delete"], request);
    }

    public async search(request: SearchTimeRecordsRequest): Promise<SearchTimeRecordsResponse> {
        return await this.httpPost<SearchTimeRecordsResponse>(["time-records", "search"], request);
    }

    public async getMonthlyView(request: GetTimeRecordMonthlyViewRequest): Promise<GetTimeRecordMonthlyViewResponse> {
        return await this.httpPost<GetTimeRecordMonthlyViewResponse>(["time-records", "monthly-view"], request);
    }

    public async getYearlyView(request: GetTimeRecordYearlyViewRequest): Promise<GetTimeRecordYearlyViewResponse> {
        return await this.httpPost<GetTimeRecordYearlyViewResponse>(["time-records", "yearly-view"], request);
    }

    public async download(request: DownloadTimeRecordRequest): Promise<void> {
        await this.httpPostAsBlob<DownloadTimeRecordResponse>(["time-records", "download"], request, true);
    }

    public async downloadYear(request: DownloadYearTimeRecordRequest): Promise<void> {
        await this.httpPostAsBlob<DownloadYearTimeRecordResponse>(["time-records", "download-year"], request, true);
    }

    public async startForCurrentUser(request: StartTimeRecordForCurrentUserRequest): Promise<StartTimeRecordForCurrentUserResponse> {
        return await this.httpPost<StartTimeRecordForCurrentUserResponse>(["time-records", "start-current-user"], request);
    }

    public async endForCurrentUser(request: EndTimeRecordForCurrentUserRequest): Promise<EndTimeRecordForCurrentUserResponse> {
        return await this.httpPost<EndTimeRecordForCurrentUserResponse>(["time-records", "end-current-user"], request);
    }

    public async end(request: EndTimeRecordRequest): Promise<EndTimeRecordResponse> {
        return await this.httpPost<EndTimeRecordResponse>(["time-records", request.id, "end"], request);
    }

    public async sendSignatureToEmployee(request: SendTimeRecordSignatureToEmployeeRequest): Promise<SendTimeRecordSignatureToEmployeeResponse> {
        return await this.httpPost<SendTimeRecordSignatureToEmployeeResponse>(["time-records", request.id, "send-signature"], request);
    }

    public async bulkClear(request: BulkClearTimeRecordsRequest): Promise<BulkClearTimeRecordsResponse> {
        return await this.httpPost<BulkClearTimeRecordsResponse>(["time-records", "bulk-clear"], request);
    }

    public async generateSignatureVoucher(request: GenerateTimeRecordSignatureVoucherRequest): Promise<void> {
        await this.httpPostAsBlob<GenerateTimeRecordSignatureVoucherResponse>(["time-records", request.id, "signature-voucher"], request, true);
    }

    public async downloadYearlyOrMonthlyView(request: DownloadTimeRecordMonthlyOrYearlyViewRequest): Promise<void> {
        await this.httpPostAsBlob<DownloadTimeRecordMonthlyOrYearlyViewResponse>(["time-records", "download-yearly-monthly-view"], request, true);
    }

}

class EmployeesService extends BaseService {

    public static readonly instance = new EmployeesService();

    public async getAll(): Promise<GetAllEmployeesResponse> {
        return await this.httpGet<GetAllEmployeesResponse>(["employees"]);
    }

    public async get(request: GetEmployeeRequest): Promise<GetEmployeeResponse> {
        return await this.httpGet<GetEmployeeResponse>(["employees", request.id]);
    }

    public async delete(request: DeleteEmployeeRequest): Promise<DeleteEmployeeResponse> {
        return await this.httpDelete<DeleteEmployeeResponse>(["employees", request.id]);
    }

    public async edit(request: EditEmployeeRequest): Promise<EditEmployeeResponse> {
        return await this.httpPost<EditEmployeeResponse>(["employees", request.id, "edit"], request);
    }

    public async add(request: AddEmployeeRequest): Promise<AddEmployeeResponse> {
        return await this.httpPost<AddEmployeeResponse>(["employees"], request);
    }

    public async bulkDelete(request: BulkDeleteEmployeesRequest): Promise<BulkDeleteEmployeesResponse> {
        return await this.httpPost<BulkDeleteEmployeesResponse>(["employees", "bulk-delete"], request);
    }

    public async addDocument(request: AddEmployeeDocumentRequest): Promise<AddEmployeeDocumentResponse> {
        return await this.httpPost<AddEmployeeDocumentResponse>(["employees", request.id, "add-document"], request);
    }

    public async removeDocument(request: RemoveEmployeeDocumentRequest): Promise<RemoveEmployeeDocumentResponse> {
        return await this.httpPost<RemoveEmployeeDocumentResponse>(["employees", request.id, "remove-document", request.documentId], request);
    }

    public async addSeason(request: AddEmployeeSeasonRequest): Promise<AddEmployeeSeasonResponse> {
        return await this.httpPost<AddEmployeeSeasonResponse>(["employees", request.id, "add-season"], request);
    }

    public async removeSeason(request: RemoveEmployeeSeasonRequest): Promise<RemoveEmployeeSeasonResponse> {
        return await this.httpPost<RemoveEmployeeSeasonResponse>(["employees", request.id, "remove-season"], request);
    }

    public async editSeason(request: EditEmployeeSeasonRequest): Promise<EditEmployeeSeasonResponse> {
        return await this.httpPost<EditEmployeeSeasonResponse>(["employees", request.id, "edit-season"], request);
    }

    public async recalculateSeasonWorkedTime(request: RecalculateEmployeeSeasonWorkedTimeRequest): Promise<RecalculateEmployeeSeasonWorkedTimeResponse> {
        return await this.httpPost<RecalculateEmployeeSeasonWorkedTimeResponse>(["employees", request.id, "recalculate-season-worked-time"], request);
    }

    public async link(request: LinkEmployeeRequest): Promise<LinkEmployeeResponse> {
        return await this.httpPost<LinkEmployeeResponse>(["employees", request.id, "link"], request);
    }

    public async refreshRelatedContactInformation(request: RefreshEmployeesRelatedContactInformationRequest): Promise<RefreshEmployeesRelatedContactInformationResponse> {
        return await this.httpPost<RefreshEmployeesRelatedContactInformationResponse>(["employees", "refresh-related-contact-information"], request);
    }

    public async enable(request: EnableEmployeeRequest): Promise<EnableEmployeeResponse> {
        return await this.httpPost<EnableEmployeeResponse>(["employees", request.id, "enable"], request);
    }

    public async disable(request: DisableEmployeeRequest): Promise<DisableEmployeeResponse> {
        return await this.httpPost<DisableEmployeeResponse>(["employees", request.id, "disable"], request);
    }

}

class ConfigurationsService extends BaseService {

    public static readonly instance = new ConfigurationsService();

    public async get(request: GetConfigurationRequest): Promise<GetConfigurationResponse> {
        return await this.httpGet<GetConfigurationResponse>(["configuration"]);
    }

    public async edit(request: EditConfigurationRequest): Promise<EditConfigurationResponse> {
        return await this.httpPost<EditConfigurationResponse>(["configuration"], request);
    }
}

class TransferZonesService extends BaseService {

    public static readonly instance = new TransferZonesService();

    public async getAll(): Promise<GetAllTransferZonesResponse> {
        return await this.httpGet<GetAllTransferZonesResponse>(["transfer-zones"]);
    }

    public async get(request: GetTransferZoneRequest): Promise<GetTransferZoneResponse> {
        return await this.httpGet<GetTransferZoneResponse>(["transfer-zones", request.id]);
    }

    public async delete(request: DeleteTransferZoneRequest): Promise<DeleteTransferZoneResponse> {
        return await this.httpDelete<DeleteTransferZoneResponse>(["transfer-zones", request.id]);
    }

    public async edit(request: EditTransferZoneRequest): Promise<EditTransferZoneResponse> {
        return await this.httpPost<EditTransferZoneResponse>(["transfer-zones", request.id, "edit"], request);
    }

    public async add(request: AddTransferZoneRequest): Promise<AddTransferZoneResponse> {
        return await this.httpPost<AddTransferZoneResponse>(["transfer-zones"], request);
    }

    public async bulkDelete(request: BulkDeleteTransferZonesRequest): Promise<BulkDeleteTransferZonesResponse> {
        return await this.httpPost<BulkDeleteTransferZonesResponse>(["transfer-zones", "bulk-delete"], request);
    }

    public async findFromLatitudeAndLongitude(request: FindTransferZoneFromLatitudeAndLongitudeRequest): Promise<FindTransferZoneFromLatitudeAndLongitudeResponse> {
        return await this.httpPost<FindTransferZoneFromLatitudeAndLongitudeResponse>(["transfer-zones", "find-from-latitude-and-longitude"], request);
    }

    public async getAutocompletion(request: GetTransferZoneAutocompletionRequest): Promise<GetTransferZoneAutocompletionResponse> {
        return await this.httpPost<GetTransferZoneAutocompletionResponse>(["transfer-zones", "autocompletion"], request);
    }

    public async getAutocompletionDetails(request: GetTransferZoneAutocompletionDetailsRequest): Promise<GetTransferZoneAutocompletionDetailsResponse> {
        return await this.httpPost<GetTransferZoneAutocompletionDetailsResponse>(["transfer-zones", "autocompletion-details"], request);
    }

}


class TransferBookingsService extends BaseService {

    public static readonly instance = new TransferBookingsService();

    public async get(request: GetTransferBookingRequest): Promise<GetTransferBookingResponse> {
        return await this.httpGet<GetTransferBookingResponse>(["transfer-bookings", request.id]);
    }

    public async delete(request: DeleteTransferBookingRequest): Promise<DeleteTransferBookingResponse> {
        return await this.httpDelete<DeleteTransferBookingResponse>(["transfer-bookings", request.id]);
    }

    public async edit(request: EditTransferBookingRequest): Promise<EditTransferBookingResponse> {
        return await this.httpPost<EditTransferBookingResponse>(["transfer-bookings", request.id, "edit"], request);
    }

    public async add(request: AddTransferBookingRequest): Promise<AddTransferBookingResponse> {
        return await this.httpPost<AddTransferBookingResponse>(["transfer-bookings"], request);
    }

    public async bulkDelete(request: BulkDeleteTransferBookingsRequest): Promise<BulkDeleteTransferBookingsResponse> {
        return await this.httpPost<BulkDeleteTransferBookingsResponse>(["transfer-bookings", "bulk-delete"], request);
    }

    public async search(request: SearchTransferBookingsRequest): Promise<SearchTransferBookingsResponse> {
        return await this.httpPost<SearchTransferBookingsResponse>(["transfer-bookings", "search"], request);
    }

    public getDownloadLink(request: GenerateTransferBookingVoucherRequest): string {
        const url = this.buildTargetUrl(["transfer-bookings", request.id, "download"]);
        const parameters: string[] = [];

        if (request.output) {
            parameters.push("output=" + request.output);
        }

        if (request.inline) {
            parameters.push("inline=true");
        }

        // generate final url adding parameters to query string
        return url + (parameters.length > 0 ? "?" + parameters.join("&") : "");
    }

}



class OrganizationsService extends BaseService {

    public static readonly instance = new OrganizationsService();

    private defaultOrganizationId = "";

    public async getDefaultOrganizationId(): Promise<string> {
        if (!this.defaultOrganizationId) {
            const response = await this.getAll();
            const defaultOrganization = response.filter(organization => organization.default)[0];

            this.defaultOrganizationId = defaultOrganization?.id || "";
        }

        return this.defaultOrganizationId;
    }

    public async getAll(): Promise<GetAllOrganizationsResponse> {
        return await this.httpGet<GetAllOrganizationsResponse>(["organizations"]);
    }

    public async get(request: GetOrganizationRequest): Promise<GetOrganizationResponse> {
        return await this.httpGet<GetOrganizationResponse>(["organizations", request.id]);
    }

    public async delete(request: DeleteOrganizationRequest): Promise<DeleteOrganizationResponse> {
        return await this.httpDelete<DeleteOrganizationResponse>(["organizations", request.id]);
    }

    public async edit(request: EditOrganizationRequest): Promise<EditOrganizationResponse> {
        return await this.httpPost<EditOrganizationResponse>(["organizations", request.id, "edit"], request);
    }

    public async add(request: AddOrganizationRequest): Promise<AddOrganizationResponse> {
        return await this.httpPost<AddOrganizationResponse>(["organizations"], request);
    }

    public async bulkDelete(request: BulkDeleteOrganizationsRequest): Promise<BulkDeleteOrganizationsResponse> {
        return await this.httpPost<BulkDeleteOrganizationsResponse>(["organizations", "bulk-delete"], request);
    }

    public async resetCounters(request: ResetOrganizationCountersRequest): Promise<ResetOrganizationCountersResponse> {
        return await this.httpPost<ResetOrganizationCountersResponse>(["organizations", request.id, "reset-counters"], request);
    }

}

class ActivitySchedulesService extends BaseService {

    public static readonly instance = new ActivitySchedulesService();

    public async getAll(): Promise<GetAllActivitySchedulesResponse> {
        return await this.httpGet<GetAllActivitySchedulesResponse>(["activityschedules"]);
    }

    public async get(request: GetActivityScheduleRequest): Promise<GetActivityScheduleResponse> {
        return await this.httpGet<GetActivityScheduleResponse>(["activityschedules", request.id]);
    }

    public async delete(request: DeleteActivityScheduleRequest): Promise<DeleteActivityScheduleResponse> {
        return await this.httpDelete<DeleteActivityScheduleResponse>(["activityschedules", request.id]);
    }

    public async edit(request: EditActivityScheduleRequest): Promise<EditActivityScheduleResponse> {
        return await this.httpPost<EditActivityScheduleResponse>(["activityschedules", request.id, "edit"], request);
    }

    public async add(request: AddActivityScheduleRequest): Promise<AddActivityScheduleResponse> {
        return await this.httpPost<AddActivityScheduleResponse>(["activityschedules"], request);
    }

    public async bulkDelete(request: BulkDeleteActivitySchedulesRequest): Promise<BulkDeleteActivitySchedulesResponse> {
        return await this.httpPost<BulkDeleteActivitySchedulesResponse>(["activityschedules", "bulk-delete"], request);
    }

    public async addDocument(request: AddActivityScheduleDocumentRequest): Promise<AddActivityScheduleDocumentResponse> {
        return await this.httpPost<AddActivityScheduleDocumentResponse>(["activity-schedules", request.id, "add-document"], request);
    }

    public async removeDocument(request: RemoveActivityScheduleDocumentRequest): Promise<RemoveActivityScheduleDocumentResponse> {
        return await this.httpPost<RemoveActivityScheduleDocumentResponse>(["activity-schedules", request.id, "remove-document", request.documentId], request);
    }

}

class TransferProductsService extends BaseService {

    public static readonly instance = new TransferProductsService();

    public async getAll(): Promise<GetAllTransferProductsResponse> {
        return await this.httpGet<GetAllTransferProductsResponse>(["transferproducts"]);
    }

    public async get(request: GetTransferProductRequest): Promise<GetTransferProductResponse> {
        return await this.httpGet<GetTransferProductResponse>(["transferproducts", request.id]);
    }

    public async delete(request: DeleteTransferProductRequest): Promise<DeleteTransferProductResponse> {
        return await this.httpDelete<DeleteTransferProductResponse>(["transferproducts", request.id]);
    }

    public async edit(request: EditTransferProductRequest): Promise<EditTransferProductResponse> {
        return await this.httpPost<EditTransferProductResponse>(["transferproducts", request.id, "edit"], request);
    }

    public async add(request: AddTransferProductRequest): Promise<AddTransferProductResponse> {
        return await this.httpPost<AddTransferProductResponse>(["transferproducts"], request);
    }

    public async bulkDelete(request: BulkDeleteTransferProductsRequest): Promise<BulkDeleteTransferProductsResponse> {
        return await this.httpPost<BulkDeleteTransferProductsResponse>(["transferproducts", "bulk-delete"], request);
    }

}


class WorkCalendarsService extends BaseService {

    public static readonly instance = new WorkCalendarsService();

    public async get(request: GetWorkCalendarRequest): Promise<GetWorkCalendarResponse> {
        return await this.httpGet<GetWorkCalendarResponse>(["work-calendars", request.year.toString()]);
    }

    public async setWorkingHours(request: SetWorkCalendarWorkingHoursRequest): Promise<SetWorkCalendarWorkingHoursResponse> {
        return await this.httpPost<SetWorkCalendarWorkingHoursResponse>(["work-calendars", request.year.toString(), "working-hours"], request);
    }

    public async togglePublicHoliday(request: ToggleWorkCalendarPublicHolidayRequest): Promise<ToggleWorkCalendarPublicHolidayResponse> {
        return await this.httpPost<ToggleWorkCalendarPublicHolidayResponse>(["work-calendars", request.year.toString(), "toggle-public-holiday"], request);
    }


}

class WhatsAppAccountsService extends BaseService {

    public static readonly instance = new WhatsAppAccountsService();

    public async getAll(): Promise<GetAllWhatsAppAccountsResponse> {
        return await this.httpGet<GetAllWhatsAppAccountsResponse>(["whatsapp-accounts"]);
    }

    public async get(request: GetWhatsAppAccountRequest): Promise<GetWhatsAppAccountResponse> {
        return await this.httpGet<GetWhatsAppAccountResponse>(["whatsapp-accounts", request.id]);
    }

    public async delete(request: DeleteWhatsAppAccountRequest): Promise<DeleteWhatsAppAccountResponse> {
        return await this.httpDelete<DeleteWhatsAppAccountResponse>(["whatsapp-accounts", request.id]);
    }

    public async rename(request: RenameWhatsAppAccountRequest): Promise<RenameWhatsAppAccountResponse> {
        return await this.httpPost<RenameWhatsAppAccountResponse>(["whatsapp-accounts", request.id, "rename"], request);
    }

    public async add(request: AddWhatsAppAccountRequest): Promise<AddWhatsAppAccountResponse> {
        return await this.httpPost<AddWhatsAppAccountResponse>(["whatsapp-accounts"], request);
    }

    public async edit(request: EditWhatsAppAccountRequest): Promise<EditWhatsAppAccountResponse> {
        return await this.httpPost<EditWhatsAppAccountResponse>(["whatsapp-accounts", request.id, "edit"], request);
    }

    public async toggle(request: ToggleWhatsAppAccountRequest): Promise<ToggleWhatsAppAccountResponse> {
        return await this.httpPost<ToggleWhatsAppAccountResponse>(["whatsapp-accounts", request.id, "toggle"], request);
    }

    public async toggleTag(request: ToggleWhatsAppAccountTagRequest): Promise<ToggleWhatsAppAccountTagResponse> {
        return await this.httpPost<ToggleWhatsAppAccountTagResponse>(["whatsapp-accounts", request.id, "toggle-tag"], request);
    }

    public async test(request: TestWhatsAppAccountRequest): Promise<TestWhatsAppAccountResponse> {
        return await this.httpPost<TestWhatsAppAccountResponse>(["whatsapp-accounts", request.id, "test"], request);
    }

    public async setOrganization(request: SetWhatsAppAccountOrganizationRequest): Promise<SetWhatsAppAccountOrganizationResponse> {
        return await this.httpPost<SetWhatsAppAccountOrganizationResponse>(["whatsapp-accounts", request.id, "set-organization"], request);
    }

}

class TasksService extends BaseService {

    public static readonly instance = new TasksService();

    public async getAll(): Promise<GetAllTasksResponse> {
        return await this.httpGet<GetAllTasksResponse>(["tasks"]);
    }

    public async toggle(request: ToggleTaskRequest): Promise<ToggleTaskResponse> {
        return await this.httpPost<ToggleTaskResponse>(["tasks", request.id, "toggle"], request);
    }

    public async run(request: RunTaskRequest): Promise<RunTaskResponse> {
        return await this.httpPost<RunTaskResponse>(["tasks", request.id, "run"], request);
    }

}

class LeadsService extends BaseService {

    public static readonly instance = new LeadsService();

    public async getAll(): Promise<GetAllLeadsResponse> {
        return await this.httpGet<GetAllLeadsResponse>(["leads"]);
    }

    public async get(request: GetLeadRequest): Promise<GetLeadResponse> {
        return await this.httpGet<GetLeadResponse>(["leads", request.id]);
    }

    public async delete(request: DeleteLeadRequest): Promise<DeleteLeadResponse> {
        return await this.httpDelete<DeleteLeadResponse>(["leads", request.id]);
    }

    public async edit(request: EditLeadRequest): Promise<EditLeadResponse> {
        return await this.httpPost<EditLeadResponse>(["leads", request.id, "edit"], request);
    }

    public async add(request: AddLeadRequest): Promise<AddLeadResponse> {
        return await this.httpPost<AddLeadResponse>(["leads"], request);
    }

    public async bulkDelete(request: BulkDeleteLeadsRequest): Promise<BulkDeleteLeadsResponse> {
        return await this.httpPost<BulkDeleteLeadsResponse>(["leads", "bulk-delete"], request);
    }

}

class TransferExtrasService extends BaseService {

    public static readonly instance = new TransferExtrasService();

    public async getAll(): Promise<GetAllTransferExtrasResponse> {
        return await this.httpGet<GetAllTransferExtrasResponse>(["transferextras"]);
    }

    public async get(request: GetTransferExtraRequest): Promise<GetTransferExtraResponse> {
        return await this.httpGet<GetTransferExtraResponse>(["transferextras", request.id]);
    }

    public async delete(request: DeleteTransferExtraRequest): Promise<DeleteTransferExtraResponse> {
        return await this.httpDelete<DeleteTransferExtraResponse>(["transferextras", request.id]);
    }

    public async edit(request: EditTransferExtraRequest): Promise<EditTransferExtraResponse> {
        return await this.httpPost<EditTransferExtraResponse>(["transferextras", request.id, "edit"], request);
    }

    public async add(request: AddTransferExtraRequest): Promise<AddTransferExtraResponse> {
        return await this.httpPost<AddTransferExtraResponse>(["transferextras"], request);
    }

    public async bulkDelete(request: BulkDeleteTransferExtrasRequest): Promise<BulkDeleteTransferExtrasResponse> {
        return await this.httpPost<BulkDeleteTransferExtrasResponse>(["transferextras", "bulk-delete"], request);
    }

}

class TransferRatesService extends BaseService {

    public static readonly instance = new TransferRatesService();

    public async getAll(): Promise<GetAllTransferRatesResponse> {
        return await this.httpGet<GetAllTransferRatesResponse>(["transfer-rates"]);
    }

    public async get(request: GetTransferRateRequest): Promise<GetTransferRateResponse> {
        return await this.httpGet<GetTransferRateResponse>(["transfer-rates", request.id]);
    }

    public async delete(request: DeleteTransferRateRequest): Promise<DeleteTransferRateResponse> {
        return await this.httpDelete<DeleteTransferRateResponse>(["transfer-rates", request.id]);
    }

    public async edit(request: EditTransferRateRequest): Promise<EditTransferRateResponse> {
        return await this.httpPost<EditTransferRateResponse>(["transfer-rates", request.id, "edit"], request);
    }

    public async add(request: AddTransferRateRequest): Promise<AddTransferRateResponse> {
        return await this.httpPost<AddTransferRateResponse>(["transfer-rates"], request);
    }

    public async bulkDelete(request: BulkDeleteTransferRatesRequest): Promise<BulkDeleteTransferRatesResponse> {
        return await this.httpPost<BulkDeleteTransferRatesResponse>(["transfer-rates", "bulk-delete"], request);
    }

    public async getSummary(request: GetTransferRateSummaryRequest): Promise<GetTransferRateSummaryResponse> {
        return await this.httpPost<GetTransferRateSummaryResponse>(["transfer-rates", request.id, "summary"], request);
    }

}

class TransferJourneysService extends BaseService {

    public static readonly instance = new TransferJourneysService();

    public async getAll(): Promise<GetAllTransferJourneysResponse> {
        return await this.httpGet<GetAllTransferJourneysResponse>(["transferjourneys"]);
    }

    public async get(request: GetTransferJourneyRequest): Promise<GetTransferJourneyResponse> {
        return await this.httpGet<GetTransferJourneyResponse>(["transferjourneys", request.id]);
    }

    public async delete(request: DeleteTransferJourneyRequest): Promise<DeleteTransferJourneyResponse> {
        return await this.httpDelete<DeleteTransferJourneyResponse>(["transferjourneys", request.id]);
    }

    public async edit(request: EditTransferJourneyRequest): Promise<EditTransferJourneyResponse> {
        return await this.httpPost<EditTransferJourneyResponse>(["transferjourneys", request.id, "edit"], request);
    }

    public async add(request: AddTransferJourneyRequest): Promise<AddTransferJourneyResponse> {
        return await this.httpPost<AddTransferJourneyResponse>(["transferjourneys"], request);
    }

    public async bulkDelete(request: BulkDeleteTransferJourneysRequest): Promise<BulkDeleteTransferJourneysResponse> {
        return await this.httpPost<BulkDeleteTransferJourneysResponse>(["transferjourneys", "bulk-delete"], request);
    }

}


class IPCService extends BaseService {

    public static readonly instance = new IPCService();

    public async synchronizeProducts(request: SynchronizeIPCProductsRequest): Promise<SynchronizeIPCProductsResponse> {
        return await this.httpPost<SynchronizeIPCProductsResponse>(["ipc", "synchronize-products"], request);
    }

}
